/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
};

export type AggregatorCompany = Company & {
  accountantDashboardReportUrl: Scalars['String'];
  additional: CompanyAdditional;
  apiUser?: Maybe<ApiUser>;
  apiUsers: ApiUsersQuery;
  b2b: Scalars['Boolean'];
  brand?: Maybe<Scalars['String']>;
  buh: CompanyContact;
  car?: Maybe<Car>;
  cards?: Maybe<Cards>;
  cars: Cars;
  companyType?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  contract?: Maybe<Contract>;
  contracts: Array<Contract>;
  departments: Array<Department>;
  director?: Maybe<Scalars['String']>;
  downloadStatementsReceiptsReport: Scalars['String'];
  driver?: Maybe<Driver>;
  drivers: Drivers;
  email?: Maybe<Scalars['String']>;
  getBalanceReportLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inn?: Maybe<Scalars['String']>;
  integrationsReportLink?: Maybe<Scalars['String']>;
  journal: Journal;
  kpp?: Maybe<Scalars['String']>;
  limits: Limits;
  logs: Logs;
  mode: OrganizationMode;
  monthlyReportLink?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notifications: Notifications;
  officialAddress?: Maybe<Scalars['String']>;
  ogrn?: Maybe<Scalars['String']>;
  orderDetails: Array<OrderDetail>;
  orderNew?: Maybe<Order>;
  orders: OrdersOld;
  ordersNew: Orders;
  ordersNewReportLink?: Maybe<Scalars['String']>;
  ordersReportLink?: Maybe<Scalars['String']>;
  partner?: Maybe<Partner>;
  partners: Array<Partner>;
  payment: Payment;
  payments: Payments;
  phone?: Maybe<Scalars['String']>;
  postAddress?: Maybe<Scalars['String']>;
  profitabilityReportUrl: Scalars['String'];
  registered: Scalars['DateTime'];
  report: Array<ReportItem>;
  reportType?: Maybe<ReportType>;
  reports: Array<ReportGroup>;
  role: Scalars['String'];
  settlement: Array<SettlementItem>;
  settlementLink: Scalars['String'];
  settlements: Array<SettlementsItem>;
  settlementsLink: Scalars['String'];
  simple: Scalars['Boolean'];
  source?: Maybe<Scalars['String']>;
  stat: CompanyStat;
  statementReceiptContracts: Array<StatementReceiptContract>;
  statementsPatterns: Array<StatementPattern>;
  statementsReceipts: StatementsReceipts;
  station?: Maybe<Station>;
  stations: Stations;
  stationsInfoReportLink?: Maybe<Scalars['String']>;
  stationsStateLogsGroups?: Maybe<StationsStateLogsGroups>;
  status?: Maybe<CompanyStatus>;
  summaryByFuelType: Array<SummaryByFuelTypeItem>;
  summaryByFuelTypeLink: Scalars['String'];
  tech: CompanyContact;
  templates: NotificationTemplates;
  terBankReportUrl: Scalars['String'];
  type: Scalars['String'];
  updatedStations?: Maybe<UpdatedStations>;
  user?: Maybe<User>;
  userAccess?: Maybe<Array<CompanyUserAccess>>;
  users: UsersQuery;
  verified: Scalars['Boolean'];
  waybill: Waybill;
  waybills: Waybills;
};


export type AggregatorCompanyAccountantDashboardReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanyApiUserArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyApiUsersArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type AggregatorCompanyCarArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyCarsArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type AggregatorCompanyContractsArgs = {
  contractsSubtype?: InputMaybe<Array<ContractSubtype>>;
  contractsType?: InputMaybe<ContractType>;
};


export type AggregatorCompanyDriverArgs = {
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type AggregatorCompanyDriversArgs = {
  page?: Scalars['Int'];
  partners?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: RecordState;
  status?: InputMaybe<DriverStatus>;
};


export type AggregatorCompanyGetBalanceReportLinkArgs = {
  month: Scalars['String'];
};


export type AggregatorCompanyJournalArgs = {
  filter: JournalFilterParams;
};


export type AggregatorCompanyLimitsArgs = {
  filter: LimitsQueryParams;
};


export type AggregatorCompanyLogsArgs = {
  filter: LogsQueryParams;
};


export type AggregatorCompanyMonthlyReportLinkArgs = {
  month: Scalars['String'];
};


export type AggregatorCompanyNotificationsArgs = {
  filter: NotificationsQueryParams;
};


export type AggregatorCompanyOrderDetailsArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyOrderNewArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyOrdersArgs = {
  filter: OrdersQueryParams;
};


export type AggregatorCompanyOrdersNewArgs = {
  filter: OrdersQueryParams;
};


export type AggregatorCompanyOrdersNewReportLinkArgs = {
  filter: OrdersQueryParams;
  format?: ReportFormat;
};


export type AggregatorCompanyOrdersReportLinkArgs = {
  format?: ReportFormat;
  from: Scalars['DateTime'];
  stationId?: InputMaybe<Scalars['ID']>;
  status?: ReportStatusFilter;
  to: Scalars['DateTime'];
};


export type AggregatorCompanyPartnersArgs = {
  state?: RecordState;
};


export type AggregatorCompanyPaymentArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyProfitabilityReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanyReportArgs = {
  month: Scalars['ID'];
};


export type AggregatorCompanySettlementArgs = {
  contractId: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanySettlementLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanySettlementsArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanySettlementsLinkArgs = {
  companyType?: InputMaybe<Scalars['String']>;
  contractType?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  reportType: SettlementsReportType;
  to: Scalars['String'];
};


export type AggregatorCompanyStatementReceiptContractsArgs = {
  statementReceiptId: Scalars['ID'];
};


export type AggregatorCompanyStatementsReceiptsArgs = {
  filter: StatementsReceiptsQueryParams;
};


export type AggregatorCompanyStationArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyStationsArgs = {
  contractsType?: Scalars['String'];
  page?: Scalars['Int'];
  partnerId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: Array<StationState>;
  status?: InputMaybe<StationStatus>;
};


export type AggregatorCompanyStationsInfoReportLinkArgs = {
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  state?: Array<StationState>;
  status?: InputMaybe<StationStatus>;
};


export type AggregatorCompanyStationsStateLogsGroupsArgs = {
  filter: QueryParams;
};


export type AggregatorCompanySummaryByFuelTypeArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanySummaryByFuelTypeLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanyTemplatesArgs = {
  filter: NotificationsTemplatesQueryParams;
};


export type AggregatorCompanyTerBankReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AggregatorCompanyUpdatedStationsArgs = {
  filter: QueryParams;
};


export type AggregatorCompanyUserArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyUsersArgs = {
  filter?: UsersQueryParams;
  query?: InputMaybe<Scalars['String']>;
};


export type AggregatorCompanyWaybillArgs = {
  id: Scalars['ID'];
};


export type AggregatorCompanyWaybillsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Scalars['String']>;
};

export type ApiUser = User & {
  drivers: Array<Driver>;
  email?: Maybe<Scalars['String']>;
  hasSberLoyalty?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  lastActivity?: Maybe<Scalars['DateTime']>;
  phone?: Maybe<Scalars['String']>;
  registered?: Maybe<Scalars['DateTime']>;
  sberLoyaltyBalance?: Maybe<Scalars['Float']>;
  sberLoyaltyRegistrationDate?: Maybe<Scalars['DateTime']>;
  state: RecordState;
  version?: Maybe<AppVersion>;
};

export type ApiUsersQuery = {
  count: Scalars['Int'];
  items: Array<User>;
};

export type AppUser = User & {
  id?: Maybe<Scalars['ID']>;
  phone?: Maybe<Scalars['String']>;
};

export type AppVersion = {
  appType?: Maybe<Scalars['String']>;
  appVersion?: Maybe<Scalars['String']>;
  os?: Maybe<Scalars['String']>;
  osVersion?: Maybe<Scalars['String']>;
};

export type AzsCompany = Company & {
  accountantDashboardReportUrl: Scalars['String'];
  additional: CompanyAdditional;
  apiUser?: Maybe<ApiUser>;
  apiUsers: ApiUsersQuery;
  b2b: Scalars['Boolean'];
  brand?: Maybe<Scalars['String']>;
  buh: CompanyContact;
  car?: Maybe<Car>;
  cards?: Maybe<Cards>;
  cars: Cars;
  companyRegions?: Maybe<Array<Region>>;
  companyType?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  contract?: Maybe<Contract>;
  contracts: Array<Contract>;
  departments: Array<Department>;
  director?: Maybe<Scalars['String']>;
  downloadStatementsReceiptsReport: Scalars['String'];
  driver?: Maybe<Driver>;
  drivers: Drivers;
  email?: Maybe<Scalars['String']>;
  getBalanceReportLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inn?: Maybe<Scalars['String']>;
  integrationsReportLink?: Maybe<Scalars['String']>;
  journal: Journal;
  kpp?: Maybe<Scalars['String']>;
  limits: Limits;
  logs: Logs;
  mode: OrganizationMode;
  monthlyReportLink?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notifications: Notifications;
  officialAddress?: Maybe<Scalars['String']>;
  offlinePartners?: Maybe<Array<PartnerOffline>>;
  ogrn?: Maybe<Scalars['String']>;
  orderDetails: Array<OrderDetail>;
  orderNew?: Maybe<Order>;
  orders: OrdersOld;
  ordersNew: Orders;
  ordersNewReportLink?: Maybe<Scalars['String']>;
  ordersReportLink?: Maybe<Scalars['String']>;
  partner?: Maybe<Partner>;
  partners: Array<Partner>;
  payment: Payment;
  payments: Payments;
  phone?: Maybe<Scalars['String']>;
  postAddress?: Maybe<Scalars['String']>;
  productCatalog?: Maybe<Array<PartnerProductGroup>>;
  profitabilityReportUrl: Scalars['String'];
  registered: Scalars['DateTime'];
  report: Array<ReportItem>;
  reportType?: Maybe<ReportType>;
  reports: Array<ReportGroup>;
  role: Scalars['String'];
  settings?: Maybe<PartnerSettings>;
  settlement: Array<SettlementItem>;
  settlementLink: Scalars['String'];
  settlements: Array<SettlementsItem>;
  settlementsLink: Scalars['String'];
  simple: Scalars['Boolean'];
  source?: Maybe<Scalars['String']>;
  stat: AzsStat;
  statementReceiptContracts: Array<StatementReceiptContract>;
  statementsPatterns: Array<StatementPattern>;
  statementsReceipts: StatementsReceipts;
  station?: Maybe<Station>;
  stationPartner?: Maybe<StationPartner>;
  stationPartnerFuels?: Maybe<Array<StationPartnerFuel>>;
  stations: Stations;
  stationsInfoReportLink?: Maybe<Scalars['String']>;
  stationsStateLogsGroups?: Maybe<StationsStateLogsGroups>;
  stationsStatuses: Array<StationsStatus>;
  status?: Maybe<CompanyStatus>;
  summaryByFuelType: Array<SummaryByFuelTypeItem>;
  summaryByFuelTypeLink: Scalars['String'];
  tech: CompanyContact;
  templates: NotificationTemplates;
  terBankReportUrl: Scalars['String'];
  type: Scalars['String'];
  updatedStations?: Maybe<UpdatedStations>;
  user?: Maybe<User>;
  userAccess?: Maybe<Array<CompanyUserAccess>>;
  users: UsersQuery;
  verified: Scalars['Boolean'];
  waybill: Waybill;
  waybills: Waybills;
};


export type AzsCompanyAccountantDashboardReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanyApiUserArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyApiUsersArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type AzsCompanyCarArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyCarsArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type AzsCompanyContractsArgs = {
  contractsSubtype?: InputMaybe<Array<ContractSubtype>>;
  contractsType?: InputMaybe<ContractType>;
};


export type AzsCompanyDriverArgs = {
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type AzsCompanyDriversArgs = {
  page?: Scalars['Int'];
  partners?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: RecordState;
  status?: InputMaybe<DriverStatus>;
};


export type AzsCompanyGetBalanceReportLinkArgs = {
  month: Scalars['String'];
};


export type AzsCompanyJournalArgs = {
  filter: JournalFilterParams;
};


export type AzsCompanyLimitsArgs = {
  filter: LimitsQueryParams;
};


export type AzsCompanyLogsArgs = {
  filter: LogsQueryParams;
};


export type AzsCompanyMonthlyReportLinkArgs = {
  month: Scalars['String'];
};


export type AzsCompanyNotificationsArgs = {
  filter: NotificationsQueryParams;
};


export type AzsCompanyOrderDetailsArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyOrderNewArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyOrdersArgs = {
  filter: OrdersQueryParams;
};


export type AzsCompanyOrdersNewArgs = {
  filter: OrdersQueryParams;
};


export type AzsCompanyOrdersNewReportLinkArgs = {
  filter: OrdersQueryParams;
  format?: ReportFormat;
};


export type AzsCompanyOrdersReportLinkArgs = {
  format?: ReportFormat;
  from: Scalars['DateTime'];
  stationId?: InputMaybe<Scalars['ID']>;
  status?: ReportStatusFilter;
  to: Scalars['DateTime'];
};


export type AzsCompanyPartnersArgs = {
  state?: RecordState;
};


export type AzsCompanyPaymentArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyProductCatalogArgs = {
  partnerId: Scalars['ID'];
};


export type AzsCompanyProfitabilityReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanyReportArgs = {
  month: Scalars['ID'];
};


export type AzsCompanySettingsArgs = {
  partnerId: Scalars['ID'];
};


export type AzsCompanySettlementArgs = {
  contractId: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanySettlementLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanySettlementsArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanySettlementsLinkArgs = {
  companyType?: InputMaybe<Scalars['String']>;
  contractType?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  reportType: SettlementsReportType;
  to: Scalars['String'];
};


export type AzsCompanyStatementReceiptContractsArgs = {
  statementReceiptId: Scalars['ID'];
};


export type AzsCompanyStatementsReceiptsArgs = {
  filter: StatementsReceiptsQueryParams;
};


export type AzsCompanyStationArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyStationsArgs = {
  contractsType?: Scalars['String'];
  page?: Scalars['Int'];
  partnerId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: Array<StationState>;
  status?: InputMaybe<StationStatus>;
};


export type AzsCompanyStationsInfoReportLinkArgs = {
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  state?: Array<StationState>;
  status?: InputMaybe<StationStatus>;
};


export type AzsCompanyStationsStateLogsGroupsArgs = {
  filter: QueryParams;
};


export type AzsCompanySummaryByFuelTypeArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanySummaryByFuelTypeLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanyTemplatesArgs = {
  filter: NotificationsTemplatesQueryParams;
};


export type AzsCompanyTerBankReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type AzsCompanyUpdatedStationsArgs = {
  filter: QueryParams;
};


export type AzsCompanyUserArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyUsersArgs = {
  filter?: UsersQueryParams;
  query?: InputMaybe<Scalars['String']>;
};


export type AzsCompanyWaybillArgs = {
  id: Scalars['ID'];
};


export type AzsCompanyWaybillsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Scalars['String']>;
};

export type AzsStat = {
  active: Scalars['Int'];
  all: Scalars['Int'];
  online: Scalars['Int'];
};

export type BalanceHistory = {
  count: Scalars['Int'];
  items: Array<BalanceHistoryEntry>;
};

export type BalanceHistoryEntry = {
  date: Scalars['DateTime'];
  total: Scalars['Float'];
};

export type BulkEditStationsData = {
  active?: InputMaybe<Scalars['Boolean']>;
  color?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<StationMode>;
  promo?: InputMaybe<Scalars['String']>;
};

export type Cabinet = {
  companies: Array<Company>;
  company?: Maybe<Company>;
  email?: Maybe<Scalars['String']>;
  findCompanies: Companies;
  isSberBusinessIdLinked?: Maybe<Scalars['Boolean']>;
  me?: Maybe<LkUser>;
  phone?: Maybe<Scalars['String']>;
  serverAsu: Array<Scalars['String']>;
  stationsGroup?: Maybe<StationsGroup>;
  stationsGroups: StationsGroups;
  utms: Array<Scalars['String']>;
};


export type CabinetCompanyArgs = {
  cardOwnerId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
};


export type CabinetFindCompaniesArgs = {
  filter?: InputMaybe<CompaniesFilterParams>;
  page?: Scalars['Int'];
  size?: Scalars['Int'];
};


export type CabinetStationsGroupArgs = {
  id: Scalars['ID'];
};


export type CabinetStationsGroupsArgs = {
  filter: StationsGroupQueryParams;
};

export type Car = {
  description?: Maybe<Scalars['String']>;
  drivers: Array<Driver>;
  hasTransactions: Scalars['Boolean'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  partnerDrivers: Array<CarPartnerDriver>;
  partners: Array<Partner>;
  region: Scalars['String'];
  sts?: Maybe<Scalars['String']>;
};

export type CarData = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number: Scalars['String'];
  region: Scalars['Int'];
  state?: RecordState;
  sts?: InputMaybe<Scalars['Int']>;
};

export type CarPartnerDriver = {
  driverId?: Maybe<Scalars['String']>;
  driverName?: Maybe<Scalars['String']>;
  parentPartnerId?: Maybe<Scalars['String']>;
  parentPartnerName?: Maybe<Scalars['String']>;
  partnerId: Scalars['String'];
  partnerName: Scalars['String'];
};

export type CarSaveData = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  partnerDriverId?: InputMaybe<Array<Scalars['String']>>;
  partnerId?: InputMaybe<Array<Scalars['String']>>;
  region?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<RecordState>;
  sts?: InputMaybe<Scalars['Int']>;
};

export type Card = {
  balance: Array<CardBalance>;
  label: Scalars['String'];
  limits: Array<CardTemplate>;
  limitsShort: Scalars['String'];
  number: Scalars['String'];
  psp: Scalars['Float'];
  status: Scalars['Boolean'];
  token: Scalars['String'];
};

export type CardBalance = {
  groupCafe: CardBalanceRestrictions;
  groupGoods: CardBalanceRestrictions;
  groupPetroleum: CardBalanceRestrictions;
  groupServices: CardBalanceRestrictions;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CardBalanceRestriction = {
  allowed: Scalars['Boolean'];
  balanceQuantity?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  period?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  unlimited: Scalars['Boolean'];
  usedQuantity: Scalars['Float'];
};

export type CardBalanceRestrictions = {
  balanceQuantity: Scalars['Float'];
  groupRestriction: CardTemplateGroupRestrictions;
  restrictions: Array<CardBalanceRestriction>;
  usedQuantity: Scalars['Float'];
};

export type CardFuel = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CardLimitsData = {
  groupCafe: CardTemplateRestrictionsData;
  groupGoods: CardTemplateRestrictionsData;
  groupPetroleum: CardTemplateRestrictionsData;
  groupServices: CardTemplateRestrictionsData;
  id: Scalars['String'];
  name: Scalars['String'];
  nets: Array<Scalars['String']>;
  regions: Array<Scalars['String']>;
};

export type CardNet = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CardOwner = Order & {
  corp?: Maybe<OrderCorp>;
  date: Scalars['DateTime'];
  finished?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ip?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  payment: OrderPayment;
  sberId?: Maybe<Scalars['Boolean']>;
  sberSpasiboDetails?: Maybe<OrderItemSberSpasiboDetails>;
  shortName?: Maybe<Scalars['String']>;
  station?: Maybe<Station>;
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['ID']>;
  user?: Maybe<AppUser>;
};

export type CardRegion = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CardTemplate = {
  groupCafe: CardTemplateRestrictions;
  groupGoods: CardTemplateRestrictions;
  groupPetroleum: CardTemplateRestrictions;
  groupServices: CardTemplateRestrictions;
  id: Scalars['String'];
  name: Scalars['String'];
  nets: Array<Scalars['String']>;
  regions: Array<Scalars['String']>;
};

export type CardTemplateData = {
  groupCafe: CardTemplateRestrictionsData;
  groupGoods: CardTemplateRestrictionsData;
  groupPetroleum: CardTemplateRestrictionsData;
  groupServices: CardTemplateRestrictionsData;
  name: Scalars['String'];
  nets: Array<Scalars['String']>;
  regions: Array<Scalars['String']>;
};

export type CardTemplateGroupRestrictions = {
  allowed: Scalars['Boolean'];
  period?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  unlimited: Scalars['Boolean'];
};

export type CardTemplateGroupRestrictionsData = {
  allowed: Scalars['Boolean'];
  period?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Scalars['String']>;
  unlimited: Scalars['Boolean'];
};

export type CardTemplateRestriction = {
  allowed: Scalars['Boolean'];
  name: Scalars['String'];
  period?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  unlimited: Scalars['Boolean'];
};

export type CardTemplateRestrictionData = {
  allowed: Scalars['Boolean'];
  name: Scalars['String'];
  period?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Float']>;
  unit?: InputMaybe<Scalars['String']>;
  unlimited: Scalars['Boolean'];
};

export type CardTemplateRestrictions = {
  groupRestriction: CardTemplateGroupRestrictions;
  restrictions: Array<CardTemplateRestriction>;
};

export type CardTemplateRestrictionsData = {
  groupRestriction: CardTemplateGroupRestrictionsData;
  restrictions: Array<CardTemplateRestrictionData>;
};

export type Cards = {
  card: Card;
  cards: Array<Card>;
  fuels: Array<CardFuel>;
  nets: Array<CardNet>;
  regions: Array<CardRegion>;
  template: CardTemplate;
  templates: Array<CardTemplate>;
};


export type CardsCardArgs = {
  token: Scalars['String'];
};


export type CardsTemplateArgs = {
  id: Scalars['ID'];
};

export type Cars = {
  count: Scalars['Int'];
  hasAny: Scalars['Boolean'];
  items: Array<Car>;
};


export type CarsCountArgs = {
  state?: RecordState;
};


export type CarsHasAnyArgs = {
  state?: RecordState;
};


export type CarsItemsArgs = {
  state?: RecordState;
};

export type CheckPaymentsResult = {
  amount: Scalars['Int'];
  completed: Scalars['Int'];
  errors: Scalars['Int'];
};

export type Color = {
  color?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  symbol?: Maybe<Scalars['String']>;
};

export type Companies = {
  count: Scalars['Int'];
  items: Array<Company>;
  stat: Array<CompaniesStat>;
};

export type CompaniesFilterParams = {
  asuProtocols?: InputMaybe<Array<Scalars['String']>>;
  contractsType?: ContractType;
  flag?: InputMaybe<CompanyFlag>;
  from?: InputMaybe<Scalars['DateTime']>;
  paymentType?: InputMaybe<ContractPaymentType>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CompanyStatus>;
  to?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<CompaniesTypeFilter>;
  utms?: InputMaybe<Array<Scalars['String']>>;
};

export type CompaniesStat = {
  count: Scalars['Int'];
  status: CompanyStatus;
};

export enum CompaniesTypeFilter {
  Aggregator = 'aggregator',
  Azs = 'azs',
  Corp = 'corp',
  Taxi = 'taxi',
  Tk = 'tk'
}

export type Company = {
  accountantDashboardReportUrl: Scalars['String'];
  additional: CompanyAdditional;
  apiUser?: Maybe<ApiUser>;
  apiUsers: ApiUsersQuery;
  b2b: Scalars['Boolean'];
  brand?: Maybe<Scalars['String']>;
  buh: CompanyContact;
  car?: Maybe<Car>;
  cards?: Maybe<Cards>;
  cars: Cars;
  companyType?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  contract?: Maybe<Contract>;
  contracts: Array<Contract>;
  departments: Array<Department>;
  director?: Maybe<Scalars['String']>;
  downloadStatementsReceiptsReport: Scalars['String'];
  driver?: Maybe<Driver>;
  drivers: Drivers;
  email?: Maybe<Scalars['String']>;
  getBalanceReportLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inn?: Maybe<Scalars['String']>;
  integrationsReportLink?: Maybe<Scalars['String']>;
  journal: Journal;
  kpp?: Maybe<Scalars['String']>;
  limits: Limits;
  logs: Logs;
  mode: OrganizationMode;
  monthlyReportLink?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notifications: Notifications;
  officialAddress?: Maybe<Scalars['String']>;
  ogrn?: Maybe<Scalars['String']>;
  orderDetails: Array<OrderDetail>;
  orderNew?: Maybe<Order>;
  orders: OrdersOld;
  ordersNew: Orders;
  ordersNewReportLink?: Maybe<Scalars['String']>;
  ordersReportLink?: Maybe<Scalars['String']>;
  partner?: Maybe<Partner>;
  partners: Array<Partner>;
  payment: Payment;
  payments: Payments;
  phone?: Maybe<Scalars['String']>;
  postAddress?: Maybe<Scalars['String']>;
  profitabilityReportUrl: Scalars['String'];
  registered: Scalars['DateTime'];
  report: Array<ReportItem>;
  reportType?: Maybe<ReportType>;
  reports: Array<ReportGroup>;
  role: Scalars['String'];
  settlement: Array<SettlementItem>;
  settlementLink: Scalars['String'];
  settlements: Array<SettlementsItem>;
  settlementsLink: Scalars['String'];
  simple: Scalars['Boolean'];
  source?: Maybe<Scalars['String']>;
  statementReceiptContracts: Array<StatementReceiptContract>;
  statementsPatterns: Array<StatementPattern>;
  statementsReceipts: StatementsReceipts;
  station?: Maybe<Station>;
  stations: Stations;
  stationsInfoReportLink?: Maybe<Scalars['String']>;
  stationsStateLogsGroups?: Maybe<StationsStateLogsGroups>;
  status?: Maybe<CompanyStatus>;
  summaryByFuelType: Array<SummaryByFuelTypeItem>;
  summaryByFuelTypeLink: Scalars['String'];
  tech: CompanyContact;
  templates: NotificationTemplates;
  terBankReportUrl: Scalars['String'];
  type: Scalars['String'];
  updatedStations?: Maybe<UpdatedStations>;
  user?: Maybe<User>;
  userAccess?: Maybe<Array<CompanyUserAccess>>;
  users: UsersQuery;
  verified: Scalars['Boolean'];
  waybill: Waybill;
  waybills: Waybills;
};


export type CompanyAccountantDashboardReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type CompanyApiUserArgs = {
  id: Scalars['ID'];
};


export type CompanyApiUsersArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type CompanyCarArgs = {
  id: Scalars['ID'];
};


export type CompanyCarsArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type CompanyContractsArgs = {
  contractsSubtype?: InputMaybe<Array<ContractSubtype>>;
  contractsType?: InputMaybe<ContractType>;
};


export type CompanyDriverArgs = {
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type CompanyDriversArgs = {
  page?: Scalars['Int'];
  partners?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: RecordState;
  status?: InputMaybe<DriverStatus>;
};


export type CompanyGetBalanceReportLinkArgs = {
  month: Scalars['String'];
};


export type CompanyJournalArgs = {
  filter: JournalFilterParams;
};


export type CompanyLimitsArgs = {
  filter: LimitsQueryParams;
};


export type CompanyLogsArgs = {
  filter: LogsQueryParams;
};


export type CompanyMonthlyReportLinkArgs = {
  month: Scalars['String'];
};


export type CompanyNotificationsArgs = {
  filter: NotificationsQueryParams;
};


export type CompanyOrderDetailsArgs = {
  id: Scalars['ID'];
};


export type CompanyOrderNewArgs = {
  id: Scalars['ID'];
};


export type CompanyOrdersArgs = {
  filter: OrdersQueryParams;
};


export type CompanyOrdersNewArgs = {
  filter: OrdersQueryParams;
};


export type CompanyOrdersNewReportLinkArgs = {
  filter: OrdersQueryParams;
  format?: ReportFormat;
};


export type CompanyOrdersReportLinkArgs = {
  format?: ReportFormat;
  from: Scalars['DateTime'];
  stationId?: InputMaybe<Scalars['ID']>;
  status?: ReportStatusFilter;
  to: Scalars['DateTime'];
};


export type CompanyPartnersArgs = {
  state?: RecordState;
};


export type CompanyPaymentArgs = {
  id: Scalars['ID'];
};


export type CompanyProfitabilityReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type CompanyReportArgs = {
  month: Scalars['ID'];
};


export type CompanySettlementArgs = {
  contractId: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
};


export type CompanySettlementLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type CompanySettlementsArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type CompanySettlementsLinkArgs = {
  companyType?: InputMaybe<Scalars['String']>;
  contractType?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  reportType: SettlementsReportType;
  to: Scalars['String'];
};


export type CompanyStatementReceiptContractsArgs = {
  statementReceiptId: Scalars['ID'];
};


export type CompanyStatementsReceiptsArgs = {
  filter: StatementsReceiptsQueryParams;
};


export type CompanyStationArgs = {
  id: Scalars['ID'];
};


export type CompanyStationsArgs = {
  contractsType?: Scalars['String'];
  page?: Scalars['Int'];
  partnerId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: Array<StationState>;
  status?: InputMaybe<StationStatus>;
};


export type CompanyStationsInfoReportLinkArgs = {
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  state?: Array<StationState>;
  status?: InputMaybe<StationStatus>;
};


export type CompanyStationsStateLogsGroupsArgs = {
  filter: QueryParams;
};


export type CompanySummaryByFuelTypeArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type CompanySummaryByFuelTypeLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type CompanyTemplatesArgs = {
  filter: NotificationsTemplatesQueryParams;
};


export type CompanyTerBankReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type CompanyUpdatedStationsArgs = {
  filter: QueryParams;
};


export type CompanyUserArgs = {
  id: Scalars['ID'];
};


export type CompanyUsersArgs = {
  filter?: UsersQueryParams;
  query?: InputMaybe<Scalars['String']>;
};


export type CompanyWaybillArgs = {
  id: Scalars['ID'];
};


export type CompanyWaybillsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Scalars['String']>;
};

export type CompanyAdditional = {
  commentary?: Maybe<Scalars['String']>;
};

export type CompanyAdditionalData = {
  commentary?: InputMaybe<Scalars['String']>;
};

export type CompanyContact = {
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type CompanyContactData = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CompanyData = {
  additional?: InputMaybe<CompanyAdditionalData>;
  brand?: InputMaybe<Scalars['String']>;
  buh?: InputMaybe<CompanyContactData>;
  companyType?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  contract?: InputMaybe<ContractData>;
  director?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstApply?: InputMaybe<Scalars['Boolean']>;
  inn?: InputMaybe<Scalars['String']>;
  kpp?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  officialAddress?: InputMaybe<Scalars['String']>;
  ogrn?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  postAddress?: InputMaybe<Scalars['String']>;
  productCatalog?: InputMaybe<Array<PartnerProductGroupData>>;
  reportType?: InputMaybe<ReportType>;
  settings?: InputMaybe<PartnerSettingsData>;
  source?: InputMaybe<Scalars['String']>;
  stationPartner?: InputMaybe<StationPartnerData>;
  stationPartnerFuels?: InputMaybe<Array<StationPartnerFuelData>>;
  status?: InputMaybe<CompanyStatus>;
  tech?: InputMaybe<CompanyContactData>;
  type?: InputMaybe<Scalars['String']>;
};

export enum CompanyFlag {
  Card = 'CARD',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Topup = 'TOPUP'
}

export type CompanyStat = {
  activeDriversCount: Scalars['Int'];
  allDepartmentsCount: Scalars['Int'];
  departmentsCount: Scalars['Int'];
  driversCount: Scalars['Int'];
};

export enum CompanyStatus {
  Awaiting = 'AWAITING',
  Off = 'OFF',
  On = 'ON'
}

export type CompanyUserAccess = {
  name: Scalars['String'];
  partnerId: Scalars['String'];
  partnerParentId?: Maybe<Scalars['String']>;
  role: Scalars['String'];
};

export type Contract = {
  account?: Maybe<Scalars['String']>;
  agentCommission?: Maybe<Scalars['Float']>;
  balance: Scalars['Float'];
  balanceLimit: Scalars['Float'];
  bank?: Maybe<Scalars['String']>;
  bankCity?: Maybe<Scalars['String']>;
  bik?: Maybe<Scalars['String']>;
  businessType: ContractBusinessType;
  correspondence?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  delayedDiscount?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['Float']>;
  edo?: Maybe<Scalars['Boolean']>;
  finishDate?: Maybe<Scalars['String']>;
  got: Scalars['Boolean'];
  id: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
  paymentType?: Maybe<ContractPaymentType>;
  personalDiscount?: Maybe<Scalars['Boolean']>;
  type: ContractType;
};

export enum ContractBusinessType {
  B2b = 'b2b',
  B2c = 'b2c',
  Custom = 'custom'
}

export type ContractCustumFuelDiscount = {
  discount: Scalars['Float'];
  fuel: Scalars['Float'];
};

export type ContractCustumFuelDiscountData = {
  discount: Scalars['Float'];
  fuel: Scalars['Float'];
};

export type ContractData = {
  account?: InputMaybe<Scalars['String']>;
  agentCommission?: InputMaybe<Scalars['Float']>;
  balanceLimit?: InputMaybe<Scalars['Float']>;
  bank?: InputMaybe<Scalars['String']>;
  bankCity?: InputMaybe<Scalars['String']>;
  bik?: InputMaybe<Scalars['String']>;
  businessType?: InputMaybe<Scalars['String']>;
  correspondence?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  delayedDiscount?: InputMaybe<Scalars['Boolean']>;
  discount?: InputMaybe<Scalars['Float']>;
  edo?: InputMaybe<Scalars['Boolean']>;
  finishDate?: InputMaybe<Scalars['String']>;
  got?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  number?: InputMaybe<Scalars['String']>;
  paymentType?: InputMaybe<Scalars['String']>;
  personalDiscount?: InputMaybe<Scalars['Boolean']>;
  timezoneOffset?: InputMaybe<Scalars['Int']>;
};

export enum ContractPaymentType {
  Acquiring = 'acquiring',
  Postpay = 'postpay',
  Prepay = 'prepay'
}

export enum ContractSubtype {
  Custom = 'custom',
  Info = 'info',
  Sale = 'sale'
}

export enum ContractType {
  Custom = 'custom',
  Offline = 'offline',
  Online = 'online'
}

export type CustomContract = Contract & {
  account?: Maybe<Scalars['String']>;
  agentCommission?: Maybe<Scalars['Float']>;
  balance: Scalars['Float'];
  balanceLimit: Scalars['Float'];
  bank?: Maybe<Scalars['String']>;
  bankCity?: Maybe<Scalars['String']>;
  bik?: Maybe<Scalars['String']>;
  businessType: ContractBusinessType;
  correspondence?: Maybe<Scalars['String']>;
  customFuelDiscount?: Maybe<Array<ContractCustumFuelDiscount>>;
  date?: Maybe<Scalars['String']>;
  delayedDiscount?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['Float']>;
  discountOrganizations?: Maybe<Array<Scalars['String']>>;
  document?: Maybe<OnlineContractDocument>;
  documents?: Maybe<OnlineContractDocuments>;
  edo?: Maybe<Scalars['Boolean']>;
  finishDate?: Maybe<Scalars['String']>;
  got: Scalars['Boolean'];
  id: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
  paymentType?: Maybe<ContractPaymentType>;
  personalDiscount?: Maybe<Scalars['Boolean']>;
  timezoneOffset: Scalars['Int'];
  type: ContractType;
};


export type CustomContractDocumentArgs = {
  id: Scalars['ID'];
};

export type Department = {
  children: Array<Department>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  role: DepartmentRole;
};

export enum DepartmentRole {
  Accountant = 'accountant',
  Admin = 'admin',
  AzsSales = 'azs_sales',
  Custom = 'custom',
  Lawyer = 'lawyer',
  Manager = 'manager',
  Readonly = 'readonly',
  Sales = 'sales',
  Support = 'support',
  TaxiSales = 'taxi_sales',
  User = 'user'
}

export type Driver = User & {
  apiUser?: Maybe<ApiUser>;
  balanceHistory?: Maybe<BalanceHistory>;
  car?: Maybe<Car>;
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyReportType?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['DateTime']>;
  hasTransactions: Scalars['Boolean'];
  id?: Maybe<Scalars['ID']>;
  isActive: Scalars['Boolean'];
  limits?: Maybe<DriverLimits>;
  limitsAndExpenses: DriverLimitsAndExpenses;
  name?: Maybe<Scalars['String']>;
  partnerCars: Array<DriverPartnerCar>;
  partnerDriverId: Scalars['String'];
  partnerId: Scalars['String'];
  partnerName: Scalars['String'];
  partnerParentId?: Maybe<Scalars['String']>;
  partnerParentName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  state: RecordState;
};


export type DriverBalanceHistoryArgs = {
  filter: QueryParams;
};

export type DriverData = {
  carId?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  limits: DriverLimitsData;
  name: Scalars['String'];
  partnerIds: Array<Scalars['String']>;
  phone: Scalars['String'];
  state?: RecordState;
};

export type DriverEditData = {
  isActive?: InputMaybe<Scalars['Boolean']>;
  limits?: InputMaybe<DriverLimitsData>;
  name?: InputMaybe<Scalars['String']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  partnersIds?: InputMaybe<Array<Scalars['ID']>>;
  phone?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<RecordState>;
};

export type DriverLimits = {
  balance?: Maybe<Scalars['Float']>;
  blocked: Scalars['Boolean'];
  day?: Maybe<Scalars['Float']>;
  fuels?: Maybe<Array<Scalars['ID']>>;
  fuelsGroups?: Maybe<Array<Scalars['ID']>>;
  isQuantity?: Maybe<Scalars['Boolean']>;
  limitsType: RidersConstraintsType;
  minLeft: Scalars['Float'];
  month?: Maybe<Scalars['Float']>;
  regions?: Maybe<Array<Scalars['ID']>>;
  week?: Maybe<Scalars['Float']>;
};

export type DriverLimitsAndExpenses = {
  balance?: Maybe<Scalars['Float']>;
  blocked: Scalars['Boolean'];
  day?: Maybe<Scalars['Float']>;
  dayExpenses?: Maybe<Scalars['Float']>;
  fuels?: Maybe<Array<Scalars['ID']>>;
  fuelsGroups?: Maybe<Array<Scalars['ID']>>;
  isQuantity?: Maybe<Scalars['Boolean']>;
  limitsType: RidersConstraintsType;
  month?: Maybe<Scalars['Float']>;
  monthExpenses?: Maybe<Scalars['Float']>;
  regions?: Maybe<Array<Scalars['ID']>>;
  week?: Maybe<Scalars['Float']>;
  weekExpenses?: Maybe<Scalars['Float']>;
};

export enum DriverLimitsChangeOperation {
  Add = 'ADD',
  Set = 'SET',
  Substract = 'SUBSTRACT'
}

export type DriverLimitsData = {
  balanceValue?: InputMaybe<Scalars['Float']>;
  blocked?: InputMaybe<Scalars['Boolean']>;
  day?: InputMaybe<Scalars['Float']>;
  fuels?: InputMaybe<Array<Scalars['ID']>>;
  fuelsGroups?: InputMaybe<Array<Scalars['ID']>>;
  isQuantity?: InputMaybe<Scalars['Boolean']>;
  limitsOperation?: DriverLimitsChangeOperation;
  limitsType: RidersConstraintsType;
  minLeft?: InputMaybe<Scalars['Float']>;
  month?: InputMaybe<Scalars['Float']>;
  regions?: InputMaybe<Array<Scalars['ID']>>;
  week?: InputMaybe<Scalars['Float']>;
};

export type DriverPartnerCar = {
  car?: Maybe<Car>;
  isActive: Scalars['Boolean'];
  limits: DriverLimits;
  partner: Partner;
};

export enum DriverStatus {
  Active = 'active',
  Blocked = 'blocked',
  Inactive = 'inactive'
}

export type Drivers = {
  activeCount: Scalars['Int'];
  count: Scalars['Int'];
  hasAny: Scalars['Boolean'];
  items: Array<Driver>;
  totalCount: Scalars['Int'];
};

export type EditStationData = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  addressApi?: InputMaybe<Scalars['String']>;
  brand?: InputMaybe<Scalars['String']>;
  color?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  latApi?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  lngApi?: InputMaybe<Scalars['Float']>;
  mode?: InputMaybe<StationMode>;
  name?: InputMaybe<Scalars['String']>;
  nameApi?: InputMaybe<Scalars['String']>;
  promo?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
};

export type Faq = {
  answer?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  question?: Maybe<Scalars['String']>;
  sorting?: Maybe<Scalars['Float']>;
};

export type Fuel = {
  code: Scalars['String'];
  group?: Maybe<FuelGroup>;
  groupId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shortName: Scalars['String'];
};

export type FuelDiscount = {
  discount: Scalars['Float'];
  endDate?: Maybe<Scalars['DateTime']>;
  fuel: Scalars['Int'];
  id: Scalars['ID'];
  startDate?: Maybe<Scalars['DateTime']>;
};

export type FuelDiscounts = {
  count: Scalars['Int'];
  items: Array<FuelDiscount>;
};

export type FuelDiscountsGroupItem = {
  contractId: Scalars['String'];
  contractNumber?: Maybe<Scalars['String']>;
  discounts: Array<Scalars['Float']>;
  fuels: Array<Scalars['Int']>;
  organizationName: Scalars['String'];
};

export type FuelDiscountsGroups = {
  count: Scalars['Int'];
  items: Array<FuelDiscountsGroupItem>;
};

export type FuelGroup = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type InvoiceItem = {
  amount: Scalars['Float'];
  contract: Scalars['String'];
  contractId: Scalars['String'];
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  organizationId: Scalars['String'];
  organizationName: Scalars['String'];
  paymentPurpose: Scalars['String'];
  status: Scalars['String'];
};

export type InvoiceItems = {
  count: Scalars['Int'];
  items: Array<InvoiceItem>;
  total: Scalars['Float'];
};

export type InvoiceOrganizationItem = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type InvoicePayment = Payment & {
  amount: Scalars['Float'];
  balance: Array<PaymentBalanceItem>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  logs?: Maybe<PaymentsLogs>;
  provider: PaymentProvider;
  status: Scalars['String'];
  statusDescription?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type InvoicePaymentResponse = PaymentResponse & {
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  number: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export enum InvoiceType {
  All = 'ALL',
  Postpaid = 'POSTPAID',
  Prepaid = 'PREPAID'
}

export type InvoicesData = {
  fuelUpBankAccount: Scalars['String'];
  invoiceOrganizations: Array<InvoiceOrganizationItem>;
  invoicesList: InvoiceItems;
};


export type InvoicesDataInvoicesListArgs = {
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  invoiceStatus?: InputMaybe<Array<Scalars['String']>>;
  organizationName?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
};

export type Journal = {
  count: Scalars['Int'];
  items: Array<JournalItem>;
};

export type JournalFilterParams = {
  action?: InputMaybe<Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type JournalItem = {
  action: Scalars['String'];
  date: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  response: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};

export type LkUser = User & {
  access: Array<LkUserAccess>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lastActivity?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  oldAuthLink: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  role?: Maybe<UsersRoles>;
};

export type LkUserAccess = {
  id: Scalars['ID'];
  partners?: Maybe<Array<Partner>>;
  role?: Maybe<UsersRoles>;
};

export type Limit = {
  type: Scalars['String'];
};

export type Limits = {
  count: Scalars['Int'];
  items: Array<Limit>;
};

export type LimitsQueryParams = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  type: LimitsType;
};

export enum LimitsType {
  LkAuth = 'lkAuth',
  MaAuth = 'maAuth'
}

export type Log = {
  code?: Maybe<Scalars['Float']>;
  date: Scalars['DateTime'];
  input?: Maybe<Scalars['String']>;
  logName: Scalars['String'];
  logType: Scalars['String'];
  phone: Scalars['String'];
  smsCode?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export enum LogType {
  LkAuth = 'lkAuth',
  MaAuth = 'maAuth'
}

export type Logs = {
  count: Scalars['Int'];
  items: Array<Log>;
  summary: LogsSummary;
};

export type LogsQueryParams = {
  code: Array<Scalars['Int']>;
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  type: LogType;
};

export type LogsSummary = {
  errors?: Maybe<Scalars['Int']>;
  invalid?: Maybe<Scalars['Int']>;
  successful?: Maybe<Scalars['Int']>;
  timeouts?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type MissingPump = {
  address: Scalars['String'];
  name: Scalars['String'];
};

export type Mutation = {
  addCar?: Maybe<Car>;
  addCarToPartner?: Maybe<Car>;
  addColor?: Maybe<Color>;
  addCorpClientStationsGroupFuelDiscounts: Scalars['Boolean'];
  addDriver?: Maybe<Array<Driver>>;
  addDriverToCar?: Maybe<Car>;
  addFaq?: Maybe<Faq>;
  addOfflineStation?: Maybe<Station>;
  addPartner?: Maybe<Partner>;
  addStatementsPattern: Scalars['Boolean'];
  addStation?: Maybe<Station>;
  addStationSystem?: Maybe<StationSystem>;
  addStationsGroup: Scalars['String'];
  addStationsToStationsGroup: Scalars['Boolean'];
  addUser?: Maybe<Scalars['String']>;
  bulkEditStations?: Maybe<Station>;
  bulkSetStationsState?: Maybe<NotEnabledStations>;
  bulkSetStationsStateByGroupId: Scalars['Boolean'];
  cancelOrder: Order;
  cancelSberLoyaltyReceipt: Scalars['Boolean'];
  cancelStatementReceipt?: Maybe<Scalars['Boolean']>;
  changeBusinessCardSettings: Scalars['Boolean'];
  changeDiscount?: Maybe<Scalars['Boolean']>;
  checkContractPayments: CheckPaymentsResult;
  checkPayment?: Maybe<Payment>;
  closeOrder: Order;
  copyStation: Scalars['Boolean'];
  copyStations: Scalars['Boolean'];
  createCardTemplate: CardTemplate;
  createCompany?: Maybe<Company>;
  createContract?: Maybe<Company>;
  createInvoices?: Maybe<Scalars['Boolean']>;
  createNotificationTemplate: NotificationTemplate;
  createOfflinePartner?: Maybe<Scalars['ID']>;
  createPayment?: Maybe<PaymentResponse>;
  createScriptRun: RunResult;
  deleteApiUser: MutationResult;
  deleteCardTemplate: Scalars['Boolean'];
  deleteContractDocument: Scalars['Boolean'];
  deleteNotificationTemplate: Scalars['Boolean'];
  deletePayment?: Maybe<Scalars['String']>;
  deleteStatementsPattern: Scalars['Boolean'];
  deleteStationsGroupContractFuelDiscounts: Scalars['Boolean'];
  deleteStationsGroupFuelDiscount: Scalars['Boolean'];
  deleteStationsGroupFuelDiscounts: Scalars['Boolean'];
  deleteStationsGroupStation: Scalars['Boolean'];
  deleteStationsGroupStations: Scalars['Boolean'];
  dismissOrder: Order;
  dismissOrderToIncome: Order;
  editContractDocument: Scalars['Boolean'];
  editCorpClientStationsGroupFuelDiscount: Scalars['Boolean'];
  editFaq?: Maybe<Faq>;
  editPartner?: Maybe<Partner>;
  editStation?: Maybe<Station>;
  editStationSystem?: Maybe<StationSystem>;
  editStationsGroup: Scalars['Boolean'];
  executeScriptRun: RunResult;
  indexOrder: Scalars['Boolean'];
  indexOrders: Scalars['Boolean'];
  indexStations?: Maybe<Scalars['Boolean']>;
  linkSberBusinessId?: Maybe<Scalars['String']>;
  modifyOrder: Order;
  previewScriptRun: Scalars['String'];
  putCardsFirmReference: Scalars['Boolean'];
  refundOrder: Order;
  removeCarFromPartner?: Maybe<Car>;
  removeCard?: Maybe<Scalars['String']>;
  removeDriverFromCar?: Maybe<Car>;
  removeFaq?: Maybe<Faq>;
  removeUser?: Maybe<Scalars['String']>;
  resetAuthLimits: Scalars['Boolean'];
  restartStatementReceipt?: Maybe<Scalars['Boolean']>;
  restoreApiUser: MutationResult;
  saveCar?: Maybe<Car>;
  saveCompany?: Maybe<Company>;
  saveDriver?: Maybe<Driver>;
  saveDriverPartners?: Maybe<Scalars['String']>;
  saveInvoice?: Maybe<Scalars['Boolean']>;
  sendReceipt: Scalars['String'];
  sendRestoreUserPasswordEmail: Scalars['String'];
  setCarState: Scalars['Boolean'];
  setDriverState?: Maybe<Scalars['Boolean']>;
  setOrganizationMode: Scalars['Boolean'];
  setPartnerState?: Maybe<Scalars['Boolean']>;
  setStationFuelDiscount?: Maybe<Scalars['Boolean']>;
  setStationFuelDiscounts?: Maybe<Scalars['Boolean']>;
  setStationState: MutationResult;
  submitInvoices?: Maybe<Scalars['Boolean']>;
  transferStations?: Maybe<Scalars['Boolean']>;
  undoLoss: OrderChangeResult;
  unlinkSberBusinessId?: Maybe<Scalars['Boolean']>;
  unlinkUserSberId: Scalars['String'];
  updateCardLimits: Scalars['Boolean'];
  updateCardTemplate: CardTemplate;
  updateNotificationTemplate: NotificationTemplate;
  updatePartnerStations?: Maybe<Scalars['Boolean']>;
};


export type MutationAddCarArgs = {
  companyId: Scalars['ID'];
  data: CarData;
  partnerId: Array<Scalars['ID']>;
};


export type MutationAddCarToPartnerArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  partnerId: Array<Scalars['ID']>;
};


export type MutationAddColorArgs = {
  color: Scalars['String'];
  name: Scalars['String'];
  symbol?: InputMaybe<Scalars['String']>;
};


export type MutationAddCorpClientStationsGroupFuelDiscountsArgs = {
  contractId: Scalars['ID'];
  discount: Scalars['Float'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  fuelsIds: Array<Scalars['Int']>;
  groupId: Scalars['ID'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationAddDriverArgs = {
  companyId: Scalars['ID'];
  data: DriverData;
};


export type MutationAddDriverToCarArgs = {
  companyId: Scalars['ID'];
  driverId: Scalars['ID'];
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
  unblock?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddFaqArgs = {
  answer?: InputMaybe<Scalars['String']>;
  question?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Scalars['Float']>;
};


export type MutationAddOfflineStationArgs = {
  partnerId: Scalars['ID'];
  stationData: NewOfflineStationData;
};


export type MutationAddPartnerArgs = {
  companyId: Scalars['ID'];
  data: PartnerData;
  moveDrivers?: InputMaybe<Scalars['Boolean']>;
  parentId?: InputMaybe<Scalars['ID']>;
};


export type MutationAddStatementsPatternArgs = {
  data: StatementPatternData;
};


export type MutationAddStationArgs = {
  companyId: Scalars['ID'];
  stationData: NewStationData;
};


export type MutationAddStationSystemArgs = {
  data: NewStationSystemData;
};


export type MutationAddStationsGroupArgs = {
  description: Scalars['String'];
  name: Scalars['String'];
};


export type MutationAddStationsToStationsGroupArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  groupId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  stationsIds?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationAddUserArgs = {
  companyId: Scalars['ID'];
  data: UserData;
};


export type MutationBulkEditStationsArgs = {
  companyId: Scalars['ID'];
  stationsData: BulkEditStationsData;
};


export type MutationBulkSetStationsStateArgs = {
  commentary: Scalars['String'];
  companyId: Scalars['ID'];
  newState: StationState;
  oldState: Array<StationState>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StationStatus>;
};


export type MutationBulkSetStationsStateByGroupIdArgs = {
  commentary: Scalars['String'];
  groupId: Scalars['ID'];
  state: StationState;
};


export type MutationCancelOrderArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationCancelSberLoyaltyReceiptArgs = {
  id: Scalars['String'];
  orderId: Scalars['ID'];
};


export type MutationCancelStatementReceiptArgs = {
  id: Scalars['ID'];
};


export type MutationChangeBusinessCardSettingsArgs = {
  companyId: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  token: Scalars['String'];
};


export type MutationChangeDiscountArgs = {
  commentary: Scalars['String'];
  contractId: Scalars['ID'];
  customFuelDiscount?: InputMaybe<Array<ContractCustumFuelDiscountData>>;
  discount?: InputMaybe<Scalars['Float']>;
};


export type MutationCheckContractPaymentsArgs = {
  contractId: Scalars['ID'];
};


export type MutationCheckPaymentArgs = {
  id: Scalars['ID'];
};


export type MutationCloseOrderArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
  volume: Scalars['Float'];
};


export type MutationCopyStationArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCopyStationsArgs = {
  companyId: Scalars['ID'];
  ids: Array<Scalars['ID']>;
};


export type MutationCreateCardTemplateArgs = {
  companyId: Scalars['ID'];
  template: CardTemplateData;
};


export type MutationCreateCompanyArgs = {
  data: CompanyData;
  type: OrganizationType;
};


export type MutationCreateContractArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  data: ContractData;
};


export type MutationCreateInvoicesArgs = {
  bankAccount: Scalars['String'];
  invoiceType: InvoiceType;
  organizations: Array<Scalars['String']>;
  prepayDays: Scalars['Float'];
};


export type MutationCreateNotificationTemplateArgs = {
  data: NotificationTemplateData;
};


export type MutationCreateOfflinePartnerArgs = {
  contract: Scalars['String'];
  firmId: Scalars['String'];
  name: Scalars['String'];
  organization: Scalars['ID'];
  osnovans?: InputMaybe<Array<Scalars['Float']>>;
};


export type MutationCreatePaymentArgs = {
  amount: Scalars['Float'];
  cardId?: InputMaybe<Scalars['ID']>;
  confirm?: InputMaybe<Scalars['Boolean']>;
  contractId: Scalars['ID'];
  date?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  providerId: Scalars['ID'];
};


export type MutationCreateScriptRunArgs = {
  id: Scalars['Int'];
  params: Scalars['String'];
};


export type MutationDeleteApiUserArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationDeleteCardTemplateArgs = {
  companyId: Scalars['ID'];
  templateId: Scalars['ID'];
};


export type MutationDeleteContractDocumentArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteNotificationTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePaymentArgs = {
  commentary?: InputMaybe<Scalars['String']>;
  contractId: Scalars['ID'];
  paymentId: Scalars['ID'];
};


export type MutationDeleteStatementsPatternArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStationsGroupContractFuelDiscountsArgs = {
  contractId: Scalars['ID'];
  groupId: Scalars['ID'];
};


export type MutationDeleteStationsGroupFuelDiscountArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStationsGroupFuelDiscountsArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteStationsGroupStationArgs = {
  groupId: Scalars['ID'];
  stationId: Scalars['ID'];
};


export type MutationDeleteStationsGroupStationsArgs = {
  id: Scalars['ID'];
};


export type MutationDismissOrderArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
  partial?: InputMaybe<Scalars['Boolean']>;
  volume?: InputMaybe<Scalars['Float']>;
};


export type MutationDismissOrderToIncomeArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
  volume?: InputMaybe<Scalars['Float']>;
};


export type MutationEditContractDocumentArgs = {
  data: OnlineContractDocumentData;
  id: Scalars['ID'];
};


export type MutationEditCorpClientStationsGroupFuelDiscountArgs = {
  discount: Scalars['Float'];
  discountId: Scalars['ID'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};


export type MutationEditFaqArgs = {
  answer?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  question?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Scalars['Float']>;
};


export type MutationEditPartnerArgs = {
  companyId: Scalars['ID'];
  data: PartnerData;
  partnerId: Scalars['ID'];
};


export type MutationEditStationArgs = {
  stationData: EditStationData;
  stationId: Scalars['ID'];
};


export type MutationEditStationSystemArgs = {
  data: StationSystemData;
};


export type MutationEditStationsGroupArgs = {
  description: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationExecuteScriptRunArgs = {
  id: Scalars['Int'];
};


export type MutationIndexOrderArgs = {
  id: Scalars['String'];
};


export type MutationIndexOrdersArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationIndexStationsArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type MutationLinkSberBusinessIdArgs = {
  companyId: Scalars['ID'];
};


export type MutationModifyOrderArgs = {
  carId?: InputMaybe<Scalars['ID']>;
  commentary: Scalars['String'];
  costPromotion?: InputMaybe<Scalars['Float']>;
  discountCorp?: InputMaybe<Scalars['Float']>;
  discountStation?: InputMaybe<Scalars['Float']>;
  fuelId?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  stationId?: InputMaybe<Scalars['ID']>;
  volume?: InputMaybe<Scalars['Float']>;
};


export type MutationPreviewScriptRunArgs = {
  id: Scalars['Int'];
  params: Scalars['String'];
};


export type MutationPutCardsFirmReferenceArgs = {
  companyId: Scalars['ID'];
};


export type MutationRefundOrderArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
  volume: Scalars['Float'];
};


export type MutationRemoveCarFromPartnerArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type MutationRemoveCardArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveDriverFromCarArgs = {
  companyId: Scalars['ID'];
  driverId: Scalars['ID'];
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type MutationRemoveFaqArgs = {
  id: Scalars['String'];
};


export type MutationRemoveUserArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationResetAuthLimitsArgs = {
  id: Scalars['String'];
  type: Scalars['String'];
};


export type MutationRestartStatementReceiptArgs = {
  customContractId?: InputMaybe<Scalars['ID']>;
  force?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};


export type MutationRestoreApiUserArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
};


export type MutationSaveCarArgs = {
  car: CarSaveData;
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationSaveCompanyArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  data: CompanyData;
  partnerId?: InputMaybe<Scalars['ID']>;
};


export type MutationSaveDriverArgs = {
  companyId: Scalars['ID'];
  driver: DriverEditData;
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type MutationSaveDriverPartnersArgs = {
  companyId: Scalars['ID'];
  driver: DriverEditData;
  id: Scalars['ID'];
};


export type MutationSaveInvoiceArgs = {
  amount: Scalars['Float'];
  invoiceId: Scalars['ID'];
  paymentPurpose: Scalars['String'];
  status: Scalars['String'];
};


export type MutationSendReceiptArgs = {
  bankReserveId: Scalars['String'];
  paymentSource: Scalars['String'];
};


export type MutationSendRestoreUserPasswordEmailArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  referer: Scalars['String'];
};


export type MutationSetCarStateArgs = {
  companyId: Scalars['ID'];
  id: Scalars['ID'];
  state: RecordState;
};


export type MutationSetDriverStateArgs = {
  companyId: Scalars['ID'];
  driverId: Scalars['ID'];
  partnerId: Scalars['ID'];
  state: RecordState;
};


export type MutationSetOrganizationModeArgs = {
  companyId: Scalars['ID'];
  mode: OrganizationMode;
};


export type MutationSetPartnerStateArgs = {
  companyId: Scalars['ID'];
  partnerId: Scalars['ID'];
  state: RecordState;
};


export type MutationSetStationFuelDiscountArgs = {
  discount: Scalars['Float'];
  discountId?: InputMaybe<Scalars['ID']>;
  fuelId?: InputMaybe<Scalars['ID']>;
  stationId: Scalars['ID'];
};


export type MutationSetStationFuelDiscountsArgs = {
  discounts: Array<Scalars['Float']>;
  fuelIds: Array<Scalars['ID']>;
  stationId: Scalars['ID'];
};


export type MutationSetStationStateArgs = {
  commentary: Scalars['String'];
  id: Scalars['ID'];
  state: StationState;
};


export type MutationTransferStationsArgs = {
  companyId: Scalars['ID'];
  isAllSelected: Scalars['Boolean'];
  newCompanyId: Scalars['String'];
  selectedStationIds: Array<Scalars['String']>;
};


export type MutationUndoLossArgs = {
  commentary: Scalars['String'];
  companyId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationUnlinkSberBusinessIdArgs = {
  companyId: Scalars['ID'];
};


export type MutationUnlinkUserSberIdArgs = {
  userId: Scalars['ID'];
};


export type MutationUpdateCardLimitsArgs = {
  companyId: Scalars['ID'];
  limits: CardLimitsData;
  token: Scalars['String'];
};


export type MutationUpdateCardTemplateArgs = {
  companyId: Scalars['ID'];
  template: CardTemplateData;
  templateId: Scalars['ID'];
};


export type MutationUpdateNotificationTemplateArgs = {
  data: NotificationTemplateData;
  id: Scalars['ID'];
};


export type MutationUpdatePartnerStationsArgs = {
  companyId: Scalars['ID'];
};

export type MutationResult = {
  error?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
};

export type NewOfflineStationData = {
  address: Scalars['String'];
  brand: Scalars['String'];
  name: Scalars['String'];
  partnerExtId: Scalars['String'];
  region: Scalars['String'];
};

export type NewStationData = {
  address: Scalars['String'];
  brand: Scalars['String'];
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  name: Scalars['String'];
  partnerId: Scalars['String'];
  region: Scalars['String'];
};

export type NewStationSystemData = {
  name: Scalars['String'];
  protocol: Scalars['String'];
};

export type NotEnabledStations = {
  dataError: Array<Scalars['String']>;
  pumpsError: Array<MissingPump>;
};

export type Notification = {
  channel: NotificationChannel;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
  recipient: Scalars['String'];
  status: NotificationStatus;
};

export enum NotificationChannel {
  Email = 'Email',
  Sms = 'Sms'
}

export enum NotificationStatus {
  Delivered = 'Delivered',
  Error = 'Error',
  Sent = 'Sent'
}

export type NotificationTemplate = {
  channel: NotificationChannel;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  template: Scalars['String'];
  title: Scalars['String'];
  trigger: NotificationTrigger;
  updatedAt: Scalars['String'];
};

export type NotificationTemplateData = {
  channel: NotificationChannel;
  name: Scalars['String'];
  template: Scalars['String'];
  title: Scalars['String'];
  trigger: NotificationTrigger;
};

export type NotificationTemplates = {
  count: Scalars['Int'];
  items: Array<NotificationTemplate>;
};

export enum NotificationTrigger {
  Debt = 'Debt',
  DiscountChange = 'DiscountChange',
  LowBalance = 'LowBalance'
}

export type Notifications = {
  count: Scalars['Int'];
  items: Array<Notification>;
};

export type NotificationsQueryParams = {
  channel?: InputMaybe<NotificationChannel>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<NotificationStatus>;
};

export type NotificationsTemplatesQueryParams = {
  channel?: InputMaybe<NotificationChannel>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  trigger?: InputMaybe<NotificationTrigger>;
};

export type OfflineContract = Contract & {
  account?: Maybe<Scalars['String']>;
  agentCommission?: Maybe<Scalars['Float']>;
  balance: Scalars['Float'];
  balanceLimit: Scalars['Float'];
  bank?: Maybe<Scalars['String']>;
  bankCity?: Maybe<Scalars['String']>;
  bik?: Maybe<Scalars['String']>;
  businessType: ContractBusinessType;
  correspondence?: Maybe<Scalars['String']>;
  date?: Maybe<Scalars['String']>;
  delayedDiscount?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['Float']>;
  edo?: Maybe<Scalars['Boolean']>;
  finishDate?: Maybe<Scalars['String']>;
  got: Scalars['Boolean'];
  id: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
  paymentType?: Maybe<ContractPaymentType>;
  personalDiscount?: Maybe<Scalars['Boolean']>;
  type: ContractType;
};

export type OfflineOrder = Order & {
  bankProduct?: Maybe<Scalars['String']>;
  cardNumber?: Maybe<Scalars['String']>;
  corp?: Maybe<OrderCorp>;
  date: Scalars['DateTime'];
  finished?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ip?: Maybe<Scalars['String']>;
  items: Array<OrderProductItem>;
  mps?: Maybe<Scalars['String']>;
  owner?: Maybe<CardOwner>;
  payment: OrderPayment;
  sberId?: Maybe<Scalars['Boolean']>;
  sberSpasiboDetails?: Maybe<OrderItemSberSpasiboDetails>;
  station?: Maybe<Station>;
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['ID']>;
  user?: Maybe<AppUser>;
};

export type OldOrder = {
  carNumber?: Maybe<Scalars['String']>;
  date: Scalars['DateTime'];
  driver?: Maybe<Driver>;
  fact: OrderDetails;
  fuel: Scalars['String'];
  id: Scalars['ID'];
  payType?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  pump?: Maybe<Scalars['Int']>;
  refund: Scalars['Boolean'];
  req: OrderDetails;
  station?: Maybe<Station>;
  stationPrice?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  statusDetails?: Maybe<Scalars['String']>;
  taxi?: Maybe<Taxi>;
  userPrice?: Maybe<Scalars['Float']>;
};

export type OnlineContract = Contract & {
  account?: Maybe<Scalars['String']>;
  agentCommission?: Maybe<Scalars['Float']>;
  balance: Scalars['Float'];
  balanceLimit: Scalars['Float'];
  bank?: Maybe<Scalars['String']>;
  bankCity?: Maybe<Scalars['String']>;
  bik?: Maybe<Scalars['String']>;
  businessType: ContractBusinessType;
  correspondence?: Maybe<Scalars['String']>;
  customFuelDiscount?: Maybe<Array<ContractCustumFuelDiscount>>;
  date?: Maybe<Scalars['String']>;
  delayedDiscount?: Maybe<Scalars['Boolean']>;
  discount?: Maybe<Scalars['Float']>;
  document?: Maybe<OnlineContractDocument>;
  documents?: Maybe<OnlineContractDocuments>;
  edo?: Maybe<Scalars['Boolean']>;
  finishDate?: Maybe<Scalars['String']>;
  got: Scalars['Boolean'];
  id: Scalars['ID'];
  number?: Maybe<Scalars['String']>;
  paymentType?: Maybe<ContractPaymentType>;
  personalDiscount?: Maybe<Scalars['Boolean']>;
  timezoneOffset: Scalars['Int'];
  type: ContractType;
};


export type OnlineContractDocumentArgs = {
  id: Scalars['ID'];
};

export type OnlineContractDocument = {
  commentary?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  filename: Scalars['String'];
  id: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
};

export type OnlineContractDocumentData = {
  commentary?: InputMaybe<Scalars['String']>;
};

export type OnlineContractDocuments = {
  count: Scalars['Float'];
  items: Array<OnlineContractDocument>;
};

export type OnlineOrder = Order & {
  bankReserveId?: Maybe<Scalars['ID']>;
  corp?: Maybe<OrderCorp>;
  date: Scalars['DateTime'];
  finished?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ip?: Maybe<Scalars['String']>;
  item?: Maybe<OrderFuelItem>;
  payment: OrderPayment;
  sberId?: Maybe<Scalars['Boolean']>;
  sberSpasiboDetails?: Maybe<OrderItemSberSpasiboDetails>;
  station?: Maybe<Station>;
  stationOrderId?: Maybe<Scalars['ID']>;
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['ID']>;
  user?: Maybe<AppUser>;
};

export type OnlinePayment = Payment & {
  amount: Scalars['Float'];
  balance: Array<PaymentBalanceItem>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  logs?: Maybe<PaymentsLogs>;
  pan?: Maybe<Scalars['String']>;
  provider: PaymentProvider;
  status: Scalars['String'];
  statusDescription?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type OnlinePaymentResponse = PaymentResponse & {
  auto?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export type Order = {
  corp?: Maybe<OrderCorp>;
  date: Scalars['DateTime'];
  finished?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  ip?: Maybe<Scalars['String']>;
  payment: OrderPayment;
  sberId?: Maybe<Scalars['Boolean']>;
  sberSpasiboDetails?: Maybe<OrderItemSberSpasiboDetails>;
  station?: Maybe<Station>;
  status: Scalars['String'];
  statusMessage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['ID']>;
  user?: Maybe<AppUser>;
};

export type OrderChangeResult = {
  id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type OrderCorp = {
  car?: Maybe<Car>;
  company: Company;
  driver?: Maybe<Driver>;
  waybill?: Maybe<Waybill>;
};

export type OrderDetail = {
  details?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  params?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  time: Scalars['Float'];
};

export type OrderDetails = {
  cost: Scalars['Float'];
  stationCost: Scalars['Float'];
  userCost: Scalars['Float'];
  volume: Scalars['Float'];
};

export type OrderFuelItem = OrderItem & {
  cost?: Maybe<OrderItemDetails>;
  costReport?: Maybe<OrderItemRefundDetails>;
  costReq?: Maybe<OrderItemDetails>;
  discount?: Maybe<OrderItemDetails>;
  fuel: Fuel;
  id?: Maybe<Scalars['ID']>;
  prices?: Maybe<OrderItemDetails>;
  pump?: Maybe<Scalars['Int']>;
  quantity: Scalars['Float'];
  quantityReport: Scalars['Float'];
  quantityReq: Scalars['Float'];
  refund?: Maybe<OrderItemRefundDetails>;
  type: OrderItemType;
};

export type OrderItem = {
  id?: Maybe<Scalars['ID']>;
  quantity: Scalars['Float'];
  quantityReport: Scalars['Float'];
  quantityReq: Scalars['Float'];
  type: OrderItemType;
};

export type OrderItemDetails = OrderItemDetailsBase & {
  corp?: Maybe<Scalars['Float']>;
  fact?: Maybe<Scalars['Float']>;
  station?: Maybe<Scalars['Float']>;
  user?: Maybe<Scalars['Float']>;
};

export type OrderItemDetailsBase = {
  corp?: Maybe<Scalars['Float']>;
  fact?: Maybe<Scalars['Float']>;
  station?: Maybe<Scalars['Float']>;
  user?: Maybe<Scalars['Float']>;
};

export type OrderItemRefundDetails = OrderItemDetailsBase & {
  corp?: Maybe<Scalars['Float']>;
  fact?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
  station?: Maybe<Scalars['Float']>;
  user?: Maybe<Scalars['Float']>;
};

export type OrderItemSberSpasiboDetails = {
  costPromotion?: Maybe<Scalars['Float']>;
  credit?: Maybe<Scalars['Float']>;
  debit?: Maybe<Scalars['Float']>;
  oid?: Maybe<Scalars['String']>;
  refund?: Maybe<Scalars['Float']>;
  status?: Maybe<SberSpasiboStatus>;
  subId: Scalars['String'];
};

export enum OrderItemType {
  Fuel = 'fuel',
  Product = 'product'
}

export type OrderPayment = {
  cardPan?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  loyalty?: Maybe<OrderPaymentLoyalty>;
  source: Array<Scalars['String']>;
  type: Scalars['String'];
};

export type OrderPaymentLoyalty = {
  approvedAmountAward?: Maybe<Scalars['Float']>;
  approvedAmountBonus?: Maybe<Scalars['Float']>;
  depositedAmountAward?: Maybe<Scalars['Float']>;
  depositedAmountBonus?: Maybe<Scalars['Float']>;
  refundedAmountAward?: Maybe<Scalars['Float']>;
  refundedAmountBonus?: Maybe<Scalars['Float']>;
  successfulAward?: Maybe<Scalars['Boolean']>;
  successfulBonus?: Maybe<Scalars['Boolean']>;
};

export type OrderProductItem = OrderItem & {
  cost?: Maybe<OrderItemDetails>;
  groupName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  prices?: Maybe<OrderItemDetails>;
  quantity: Scalars['Float'];
  quantityReport: Scalars['Float'];
  quantityReq: Scalars['Float'];
  shortName?: Maybe<Scalars['String']>;
  type: OrderItemType;
};

/** Статус заказа */
export type OrderStatusResult = {
  /** Объём топлива, литры */
  quantity: Scalars['Float'];
  /** Статус заказа */
  status: Scalars['Boolean'];
};

export type OrderSummaryItem = {
  count: Scalars['Int'];
  discount: Scalars['Float'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
  total: Scalars['Float'];
  /** @deprecated Не работает */
  volume: Scalars['Float'];
};

export type OrderSummaryItemOld = {
  count: Scalars['Int'];
  fuel: Scalars['ID'];
  total: Scalars['Float'];
  totalDiscount: Scalars['Float'];
  volume: Scalars['Float'];
};

export type Orders = {
  count: Scalars['Int'];
  items: Array<Order>;
  summary: Array<OrderSummaryItem>;
};

export type OrdersOld = {
  count: Scalars['Int'];
  items: Array<OldOrder>;
  summary: Array<OrderSummaryItemOld>;
};

export type OrdersQueryParams = {
  carId?: InputMaybe<Scalars['String']>;
  cardHash?: InputMaybe<Scalars['String']>;
  contractsType?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  driverId?: InputMaybe<Scalars['String']>;
  driverPhone?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  partnerId?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<Array<Scalars['String']>>;
  paymentType?: InputMaybe<OrdersQueryPaymentType>;
  query?: InputMaybe<Scalars['String']>;
  showErrors?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Scalars['Int']>;
  stationId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<OrdersQueryStatus>;
  subId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
  waybillId?: InputMaybe<Scalars['String']>;
};

export enum OrdersQueryPaymentType {
  Card = 'card',
  CardBusiness = 'cardBusiness',
  Sberpay = 'sberpay',
  Sberspasibo = 'sberspasibo',
  Taxi = 'taxi'
}

export enum OrdersQueryStatus {
  Active = 'active',
  All = 'all',
  Fail = 'fail',
  Refund = 'refund',
  Success = 'success'
}

export enum OrganizationMode {
  Cards = 'cards',
  Drivers = 'drivers',
  Full = 'full',
  Inactive = 'inactive',
  Simple = 'simple'
}

export enum OrganizationType {
  Aggregator = 'AGGREGATOR',
  Azs = 'AZS',
  Internal = 'INTERNAL',
  Taxi = 'TAXI',
  Tk = 'TK'
}

export type Partner = {
  hasChildren?: Maybe<Scalars['Boolean']>;
  hasTransactions?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<Partner>;
  statistics?: Maybe<PartnerStatistics>;
  status: TaxiPartnerStatus;
};

export type PartnerData = {
  name?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<RecordState>;
};

export type PartnerOffline = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PartnerProduct = {
  discount?: Maybe<Scalars['Float']>;
  internalId: Scalars['Float'];
  productId: Scalars['String'];
  productName: Scalars['String'];
};

export type PartnerProductData = {
  discount?: InputMaybe<Scalars['Float']>;
  internalId: Scalars['Float'];
  productId: Scalars['String'];
  productName: Scalars['String'];
};

export type PartnerProductGroup = {
  discount?: Maybe<Scalars['Float']>;
  groupId: Scalars['String'];
  groupName: Scalars['String'];
  internalId: Scalars['Float'];
  parentGroupId?: Maybe<Scalars['String']>;
  products?: Maybe<Array<PartnerProduct>>;
};

export type PartnerProductGroupData = {
  discount?: InputMaybe<Scalars['Float']>;
  groupId: Scalars['String'];
  groupName: Scalars['String'];
  internalId: Scalars['Float'];
  parentGroupId?: InputMaybe<Scalars['String']>;
  products?: InputMaybe<Array<PartnerProductData>>;
};

export type PartnerSettings = {
  osnovans?: Maybe<Array<Scalars['Float']>>;
};

export type PartnerSettingsData = {
  osnovans?: InputMaybe<Array<Scalars['Float']>>;
};

export type PartnerStatistics = {
  carsCount: Scalars['Int'];
  driversCount: Scalars['Int'];
  registeredDriversCount: Scalars['Int'];
};

export type Payment = {
  amount: Scalars['Float'];
  balance: Array<PaymentBalanceItem>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  logs?: Maybe<PaymentsLogs>;
  provider: PaymentProvider;
  status: Scalars['String'];
  statusDescription?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type PaymentBalanceItem = {
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
};

export type PaymentCard = {
  id: Scalars['ID'];
  name: Scalars['String'];
  provider: PaymentProvider;
};

export type PaymentLog = {
  commentary?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  state: RecordState;
};

export type PaymentProvider = {
  id: Scalars['ID'];
  name: Scalars['String'];
  service: PaymentService;
  type: PaymentType;
};

export type PaymentResponse = {
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export enum PaymentService {
  Invoice = 'INVOICE',
  Sberbank = 'SBERBANK',
  Sbid = 'SBID'
}

export enum PaymentType {
  Card = 'CARD',
  Invoice = 'INVOICE'
}

export type Payments = {
  balance: Scalars['Float'];
  cards: Array<PaymentCard>;
  count: Scalars['Int'];
  items: Array<Payment>;
  needMoney: Scalars['Boolean'];
};


export type PaymentsItemsArgs = {
  filter?: InputMaybe<PaymentsQueryParams>;
};

export type PaymentsLogs = {
  count: Scalars['Int'];
  items: Array<PaymentLog>;
};

export type PaymentsQueryParams = {
  page?: Scalars['Int'];
  size?: Scalars['Int'];
};

export type Product = {
  productId: Scalars['Float'];
  productName: Scalars['String'];
};

export type ProductGroup = {
  groupId: Scalars['Float'];
  groupName: Scalars['String'];
  products?: Maybe<Array<Product>>;
};

export type Query = {
  cabinet?: Maybe<Cabinet>;
  colors?: Maybe<Array<Color>>;
  faq?: Maybe<Array<Faq>>;
  fuel: Array<Fuel>;
  fuelGroups: Array<FuelGroup>;
  /** Обертка для получения статуса заказа */
  getOrderStatus: OrderStatusResult;
  invoices: InvoicesData;
  paymentProviders: Array<PaymentProvider>;
  productCatalog: Array<ProductGroup>;
  regions: Array<Region>;
  run?: Maybe<Run>;
  runs: Runs;
  script?: Maybe<Script>;
  scripts: Array<Script>;
  station?: Maybe<Station>;
  stations: Array<Station>;
  stationsByES: Stations;
  stationsWithDiscount: Array<Scalars['String']>;
  suggest: Array<SuggestCompany>;
  systems?: Maybe<Array<StationSystem>>;
};


export type QueryGetOrderStatusArgs = {
  id: Scalars['ID'];
};


export type QueryPaymentProvidersArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
};


export type QueryRunArgs = {
  id: Scalars['Int'];
};


export type QueryRunsArgs = {
  page?: Scalars['Int'];
  size?: Scalars['Int'];
};


export type QueryScriptArgs = {
  id: Scalars['Int'];
};


export type QueryStationArgs = {
  id: Scalars['ID'];
};


export type QueryStationsByEsArgs = {
  bounds?: InputMaybe<Array<Array<Scalars['Float']>>>;
  fuels?: InputMaybe<Array<Scalars['Int']>>;
  offset?: Scalars['Int'];
  point?: InputMaybe<Array<Scalars['Float']>>;
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  sort?: InputMaybe<StationsSort>;
  sortDir?: InputMaybe<SortDirection>;
  state?: Array<StationState>;
  status?: InputMaybe<StationStatus>;
};


export type QueryStationsWithDiscountArgs = {
  contractId: Scalars['ID'];
};


export type QuerySuggestArgs = {
  query: Scalars['String'];
};

export type QueryParams = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
};

export enum RecordState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE'
}

export type Region = {
  id?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
};

export enum ReportFormat {
  Csv = 'csv',
  Excel = 'excel',
  Pdf = 'pdf'
}

export type ReportGroup = {
  cardCount?: Maybe<Scalars['Int']>;
  credit: Scalars['Float'];
  creditCount: Scalars['Int'];
  debit: Scalars['Float'];
  debitCount: Scalars['Int'];
  month: Scalars['Int'];
  returns: Scalars['Float'];
  year: Scalars['Int'];
};

export type ReportItem = {
  balance: Scalars['Float'];
  credit: Scalars['Float'];
  day: Scalars['Int'];
  debit: Scalars['Float'];
  returns: Scalars['Float'];
};

export enum ReportStatusFilter {
  Active = 'active',
  Error = 'error',
  Refund = 'refund',
  Success = 'success'
}

export enum ReportType {
  Car = 'car',
  Default = 'default'
}

export type Rider = {
  id: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

export enum RidersConstraintsType {
  Api = 'API',
  Balance = 'BALANCE',
  Limits = 'LIMITS'
}

export type Run = {
  date?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  params: Scalars['String'];
  script: Script;
  state: RunState;
  user?: Maybe<LkUser>;
};

export type RunResult = {
  data?: Maybe<Scalars['String']>;
  status: RunResultStatus;
};

export enum RunResultStatus {
  Created = 'created',
  Error = 'error',
  Ok = 'ok'
}

export enum RunState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Error = 'ERROR',
  Pending = 'PENDING',
  Running = 'RUNNING',
  Scheduled = 'SCHEDULED'
}

export type Runs = {
  count: Scalars['Int'];
  items: Array<Run>;
};

export type SberInvoicePaymentResponse = PaymentResponse & {
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  url?: Maybe<Scalars['String']>;
};

export enum SberSpasiboStatus {
  Cld = 'CLD',
  Cnd = 'CND',
  Hld = 'HLD',
  New = 'NEW',
  Prf = 'PRF',
  Rcf = 'RCF'
}

export type Script = {
  args: Scalars['String'];
  entry: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  preview: Scalars['Boolean'];
  sorting: Scalars['Float'];
};

export type SettlementItem = {
  costFact: Scalars['Float'];
  costFirm: Scalars['Float'];
  costRefund: Scalars['Float'];
  firmCostRefund: Scalars['Float'];
  name: Scalars['String'];
  shortName: Scalars['String'];
  volumeFact: Scalars['Float'];
  volumeRefund: Scalars['Float'];
};

export type SettlementsItem = {
  companyId?: Maybe<Scalars['String']>;
  companyType?: Maybe<Scalars['String']>;
  contract?: Maybe<Scalars['String']>;
  contractId?: Maybe<Scalars['String']>;
  contractType?: Maybe<Scalars['String']>;
  costFact: Scalars['Float'];
  costPromotion: Scalars['Float'];
  costPromotionRefund: Scalars['Float'];
  costRefund: Scalars['Float'];
  credit: Scalars['Float'];
  debit: Scalars['Float'];
  name?: Maybe<Scalars['String']>;
  payments: Scalars['Float'];
  refunds: Scalars['Float'];
  saldoIn: Scalars['Float'];
  saldoOut: Scalars['Float'];
  volumeFact: Scalars['Float'];
  volumeRefund: Scalars['Float'];
};

export enum SettlementsReportType {
  AccountTopups = 'accountTopups',
  AcquiringTopups = 'acquiringTopups',
  B2b1c = 'b2b1c',
  B2cCorpClients1c = 'b2cCorpClients1c',
  Default = 'default',
  IndividualsAmounts = 'individualsAmounts',
  OfflineOrdersByClientByDate = 'offlineOrdersByClientByDate',
  SberLeasingClients = 'sberLeasingClients',
  SberLogisticsSupplies = 'sberLogisticsSupplies',
  SberSpasibo = 'sberSpasibo',
  Stations = 'stations',
  Stations1c = 'stations1c',
  StationsOffline = 'stationsOffline',
  Taxi = 'taxi',
  TaxiOffline = 'taxiOffline'
}

export type SmsLimit = Limit & {
  phone: Scalars['String'];
  type: Scalars['String'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type StatementPattern = {
  commentary: Scalars['String'];
  companyName: Scalars['String'];
  contractName: Scalars['String'];
  id: Scalars['ID'];
  pattern: Scalars['String'];
  payerName?: Maybe<Scalars['String']>;
};

export type StatementPatternData = {
  commentary: Scalars['String'];
  companyId: Scalars['String'];
  contractId: Scalars['String'];
  pattern: Scalars['String'];
  payerId: Scalars['String'];
};

export type StatementReceipt = {
  account: Scalars['String'];
  amount: Scalars['String'];
  contractId?: Maybe<Scalars['String']>;
  contragent: Scalars['String'];
  date: Scalars['String'];
  direction: Scalars['String'];
  id: Scalars['ID'];
  inn: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  organizationId?: Maybe<Scalars['String']>;
  purpose: Scalars['String'];
  status: Scalars['String'];
};

export type StatementReceiptContract = {
  contract: Scalars['String'];
  id: Scalars['ID'];
};

export type StatementsReceipts = {
  count: Scalars['Int'];
  items: Array<StatementReceipt>;
};

export type StatementsReceiptsQueryParams = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

export type Station = {
  acs?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  brand?: Maybe<Scalars['String']>;
  certificate?: Maybe<Scalars['String']>;
  certificateExpiration?: Maybe<Scalars['DateTime']>;
  certificateKey?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  contractId?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  integration?: Maybe<StationIntegration>;
  isActive?: Maybe<Scalars['Boolean']>;
  lastIndexed?: Maybe<Scalars['DateTime']>;
  lastOnline?: Maybe<Scalars['DateTime']>;
  mode?: Maybe<StationModeInfo>;
  name: Scalars['String'];
  nameApi: Scalars['String'];
  officialAddress?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  organizationName?: Maybe<Scalars['String']>;
  partnerExtId?: Maybe<Scalars['String']>;
  point?: Maybe<Array<Scalars['Float']>>;
  prices: Array<StationFuelPrice>;
  promo?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  routeTarget?: Maybe<Company>;
  state: StationState;
  stateDetails?: Maybe<StationStateDetails>;
  stateLogs?: Maybe<StationStageLogs>;
  stationFuelDiscounts: Array<StationFuelDiscount>;
  stationName?: Maybe<Scalars['String']>;
  status?: Maybe<StationStatus>;
};


export type StationStateLogsArgs = {
  filter: QueryParams;
};

export type StationFuelDiscount = {
  discount: Scalars['Float'];
  fuel: Scalars['Float'];
  id: Scalars['ID'];
};

export type StationFuelPrice = {
  fuel: Fuel;
  price: Scalars['Float'];
  pumps?: Maybe<Array<Scalars['Int']>>;
};

export type StationIntegration = {
  login: Scalars['String'];
  password?: Maybe<Scalars['String']>;
};

export enum StationMode {
  After = 'after',
  Before = 'before',
  Both = 'both'
}

export type StationModeInfo = {
  message?: Maybe<Scalars['String']>;
  type: StationMode;
};

export type StationPartner = {
  apiKey?: Maybe<Scalars['String']>;
  apiType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  outgoing?: Maybe<Scalars['String']>;
  system?: Maybe<StationSystem>;
};

export type StationPartnerData = {
  apiKey?: InputMaybe<Scalars['String']>;
  apiUrl?: InputMaybe<Scalars['String']>;
  systemId?: InputMaybe<Scalars['ID']>;
};

export type StationPartnerFuel = {
  ename?: Maybe<Scalars['String']>;
  fuelId: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  partnerFuelId: Scalars['String'];
};

export type StationPartnerFuelData = {
  ename?: InputMaybe<Scalars['String']>;
  fuelId: Scalars['Float'];
  name?: InputMaybe<Scalars['String']>;
  partnerFuelId: Scalars['String'];
};

export type StationStageLog = {
  commentary: Scalars['String'];
  date: Scalars['DateTime'];
  state: StationState;
  user: Scalars['String'];
};

export type StationStageLogs = {
  count: Scalars['Float'];
  items: Array<StationStageLog>;
};

export enum StationState {
  Active = 'active',
  Archived = 'archived',
  Deleted = 'deleted',
  Inactive = 'inactive'
}

export type StationStateDetails = {
  commentary: Scalars['String'];
  date: Scalars['String'];
  email: Scalars['String'];
};

export enum StationStatus {
  Offline = 'offline',
  Online = 'online',
  Unknown = 'unknown'
}

export type StationSystem = {
  id: Scalars['ID'];
  isPing: Scalars['Boolean'];
  name: Scalars['String'];
  protocol?: Maybe<Scalars['String']>;
};

export type StationSystemData = {
  id: Scalars['ID'];
  isPing?: InputMaybe<Scalars['Boolean']>;
};

export type Stations = {
  active: Scalars['Int'];
  count: Scalars['Int'];
  items: Array<Station>;
  status: Array<StationsStatus>;
};

export type StationsGroup = {
  contractDiscount: FuelDiscount;
  contractDiscounts: FuelDiscounts;
  description: Scalars['String'];
  discountsGroups: FuelDiscountsGroups;
  id: Scalars['ID'];
  name: Scalars['String'];
  stations: Stations;
};


export type StationsGroupContractDiscountArgs = {
  id: Scalars['ID'];
};


export type StationsGroupContractDiscountsArgs = {
  contractId: Scalars['ID'];
};


export type StationsGroupDiscountsGroupsArgs = {
  filter: QueryParams;
};


export type StationsGroupStationsArgs = {
  filter: QueryParams;
};

export type StationsGroupQueryParams = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<StationsGroupSort>;
  sortDir?: InputMaybe<SortDirection>;
};

export enum StationsGroupSort {
  Name = 'name'
}

export type StationsGroups = {
  count: Scalars['Int'];
  items: Array<StationsGroup>;
};

export enum StationsSort {
  Acs = 'acs',
  LastOnline = 'lastOnline',
  OrganizationName = 'organizationName',
  StationName = 'stationName',
  TurnOffDate = 'turnOffDate',
  TurnOffUser = 'turnOffUser'
}

export type StationsStateLogsGroup = {
  commentary: Scalars['String'];
  date: Scalars['DateTime'];
  email: Scalars['String'];
  id: Scalars['String'];
  state: StationState;
};

export type StationsStateLogsGroups = {
  count: Scalars['Float'];
  items: Array<StationsStateLogsGroup>;
};

export type StationsStatus = {
  count: Scalars['Int'];
  status: StationStatus;
};

export type SuggestCompany = {
  address?: Maybe<Scalars['String']>;
  inn?: Maybe<Scalars['String']>;
  kpp?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ogrn?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type SummaryByFuelTypeItem = {
  costFact: Scalars['Float'];
  costFirm: Scalars['Float'];
  costRefund: Scalars['Float'];
  firmCostRefund: Scalars['Float'];
  shortName?: Maybe<Scalars['String']>;
  volumeFact: Scalars['Float'];
  volumeRefund: Scalars['Float'];
};

export type TkCompany = Company & {
  accountantDashboardReportUrl: Scalars['String'];
  additional: CompanyAdditional;
  apiUser?: Maybe<ApiUser>;
  apiUsers: ApiUsersQuery;
  b2b: Scalars['Boolean'];
  brand?: Maybe<Scalars['String']>;
  buh: CompanyContact;
  car?: Maybe<Car>;
  cards?: Maybe<Cards>;
  cars: Cars;
  companyType?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  contract?: Maybe<Contract>;
  contracts: Array<Contract>;
  departments: Array<Department>;
  director?: Maybe<Scalars['String']>;
  downloadStatementsReceiptsReport: Scalars['String'];
  driver?: Maybe<Driver>;
  drivers: Drivers;
  email?: Maybe<Scalars['String']>;
  getBalanceReportLink?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inn?: Maybe<Scalars['String']>;
  integrationsReportLink?: Maybe<Scalars['String']>;
  journal: Journal;
  kpp?: Maybe<Scalars['String']>;
  limits: Limits;
  logs: Logs;
  mode: OrganizationMode;
  monthlyReportLink?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notifications: Notifications;
  officialAddress?: Maybe<Scalars['String']>;
  ogrn?: Maybe<Scalars['String']>;
  orderDetails: Array<OrderDetail>;
  orderNew?: Maybe<Order>;
  orders: OrdersOld;
  ordersNew: Orders;
  ordersNewReportLink?: Maybe<Scalars['String']>;
  ordersReportLink?: Maybe<Scalars['String']>;
  partner?: Maybe<Partner>;
  partners: Array<Partner>;
  payment: Payment;
  payments: Payments;
  phone?: Maybe<Scalars['String']>;
  postAddress?: Maybe<Scalars['String']>;
  profitabilityReportUrl: Scalars['String'];
  registered: Scalars['DateTime'];
  report: Array<ReportItem>;
  reportType?: Maybe<ReportType>;
  reports: Array<ReportGroup>;
  role: Scalars['String'];
  settlement: Array<SettlementItem>;
  settlementLink: Scalars['String'];
  settlements: Array<SettlementsItem>;
  settlementsLink: Scalars['String'];
  simple: Scalars['Boolean'];
  source?: Maybe<Scalars['String']>;
  stat: CompanyStat;
  statementReceiptContracts: Array<StatementReceiptContract>;
  statementsPatterns: Array<StatementPattern>;
  statementsReceipts: StatementsReceipts;
  station?: Maybe<Station>;
  stations: Stations;
  stationsInfoReportLink?: Maybe<Scalars['String']>;
  stationsStateLogsGroups?: Maybe<StationsStateLogsGroups>;
  status?: Maybe<CompanyStatus>;
  summaryByFuelType: Array<SummaryByFuelTypeItem>;
  summaryByFuelTypeLink: Scalars['String'];
  tech: CompanyContact;
  templates: NotificationTemplates;
  terBankReportUrl: Scalars['String'];
  type: Scalars['String'];
  updatedStations?: Maybe<UpdatedStations>;
  user?: Maybe<User>;
  userAccess?: Maybe<Array<CompanyUserAccess>>;
  users: UsersQuery;
  verified: Scalars['Boolean'];
  waybill: Waybill;
  waybills: Waybills;
};


export type TkCompanyAccountantDashboardReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanyApiUserArgs = {
  id: Scalars['ID'];
};


export type TkCompanyApiUsersArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type TkCompanyCarArgs = {
  id: Scalars['ID'];
};


export type TkCompanyCarsArgs = {
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
};


export type TkCompanyContractsArgs = {
  contractsSubtype?: InputMaybe<Array<ContractSubtype>>;
  contractsType?: InputMaybe<ContractType>;
};


export type TkCompanyDriverArgs = {
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
};


export type TkCompanyDriversArgs = {
  page?: Scalars['Int'];
  partners?: InputMaybe<Array<Scalars['String']>>;
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: RecordState;
  status?: InputMaybe<DriverStatus>;
};


export type TkCompanyGetBalanceReportLinkArgs = {
  month: Scalars['String'];
};


export type TkCompanyJournalArgs = {
  filter: JournalFilterParams;
};


export type TkCompanyLimitsArgs = {
  filter: LimitsQueryParams;
};


export type TkCompanyLogsArgs = {
  filter: LogsQueryParams;
};


export type TkCompanyMonthlyReportLinkArgs = {
  month: Scalars['String'];
};


export type TkCompanyNotificationsArgs = {
  filter: NotificationsQueryParams;
};


export type TkCompanyOrderDetailsArgs = {
  id: Scalars['ID'];
};


export type TkCompanyOrderNewArgs = {
  id: Scalars['ID'];
};


export type TkCompanyOrdersArgs = {
  filter: OrdersQueryParams;
};


export type TkCompanyOrdersNewArgs = {
  filter: OrdersQueryParams;
};


export type TkCompanyOrdersNewReportLinkArgs = {
  filter: OrdersQueryParams;
  format?: ReportFormat;
};


export type TkCompanyOrdersReportLinkArgs = {
  format?: ReportFormat;
  from: Scalars['DateTime'];
  stationId?: InputMaybe<Scalars['ID']>;
  status?: ReportStatusFilter;
  to: Scalars['DateTime'];
};


export type TkCompanyPartnersArgs = {
  state?: RecordState;
};


export type TkCompanyPaymentArgs = {
  id: Scalars['ID'];
};


export type TkCompanyProfitabilityReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanyReportArgs = {
  month: Scalars['ID'];
};


export type TkCompanySettlementArgs = {
  contractId: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanySettlementLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanySettlementsArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanySettlementsLinkArgs = {
  companyType?: InputMaybe<Scalars['String']>;
  contractType?: InputMaybe<Scalars['String']>;
  from: Scalars['String'];
  query?: InputMaybe<Scalars['String']>;
  reportType: SettlementsReportType;
  to: Scalars['String'];
};


export type TkCompanyStatementReceiptContractsArgs = {
  statementReceiptId: Scalars['ID'];
};


export type TkCompanyStatementsReceiptsArgs = {
  filter: StatementsReceiptsQueryParams;
};


export type TkCompanyStationArgs = {
  id: Scalars['ID'];
};


export type TkCompanyStationsArgs = {
  contractsType?: Scalars['String'];
  page?: Scalars['Int'];
  partnerId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: Array<StationState>;
  status?: InputMaybe<StationStatus>;
};


export type TkCompanyStationsInfoReportLinkArgs = {
  query?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  state?: Array<StationState>;
  status?: InputMaybe<StationStatus>;
};


export type TkCompanyStationsStateLogsGroupsArgs = {
  filter: QueryParams;
};


export type TkCompanySummaryByFuelTypeArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanySummaryByFuelTypeLinkArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanyTemplatesArgs = {
  filter: NotificationsTemplatesQueryParams;
};


export type TkCompanyTerBankReportUrlArgs = {
  from: Scalars['String'];
  to: Scalars['String'];
};


export type TkCompanyUpdatedStationsArgs = {
  filter: QueryParams;
};


export type TkCompanyUserArgs = {
  id: Scalars['ID'];
};


export type TkCompanyUsersArgs = {
  filter?: UsersQueryParams;
  query?: InputMaybe<Scalars['String']>;
};


export type TkCompanyWaybillArgs = {
  id: Scalars['ID'];
};


export type TkCompanyWaybillsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  page?: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
  size?: Scalars['Int'];
  state?: InputMaybe<Scalars['String']>;
};

export type Taxi = {
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export enum TaxiPartnerStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type UpdatedStation = {
  address: Scalars['String'];
  addressApi: Scalars['String'];
  id: Scalars['ID'];
  lat: Scalars['Float'];
  latApi: Scalars['Float'];
  lng: Scalars['Float'];
  lngApi: Scalars['Float'];
  name: Scalars['String'];
  nameApi: Scalars['String'];
  organizationName: Scalars['String'];
};

export type UpdatedStations = {
  count: Scalars['Int'];
  items: Array<UpdatedStation>;
};

export type User = {
  id?: Maybe<Scalars['ID']>;
  phone?: Maybe<Scalars['String']>;
};

export type UserData = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<Array<Scalars['ID']>>;
  phone?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UsersRoles>;
};

export type UsersQuery = {
  count: Scalars['Int'];
  items: Array<User>;
};

export type UsersQueryParams = {
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
};

export enum UsersRoles {
  Accountant = 'accountant',
  Admin = 'admin',
  AzsSales = 'azs_sales',
  Custom = 'custom',
  FirstLineSupport = 'first_line_support',
  Lawyer = 'lawyer',
  Manager = 'manager',
  Sales = 'sales',
  Support = 'support',
  TaxiSales = 'taxi_sales',
  User = 'user'
}

export type Waybill = {
  allowedFuels?: Maybe<Array<Scalars['Int']>>;
  allowedFuelsGroups?: Maybe<Array<Scalars['Int']>>;
  car: Car;
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  limit: Scalars['Float'];
  limitQuantity: Scalars['Boolean'];
  number: Scalars['String'];
  partner: Car;
  riders: WaybillRiders;
  state: Scalars['String'];
  validSince: Scalars['String'];
  validTo: Scalars['String'];
};


export type WaybillRidersArgs = {
  page?: Scalars['Int'];
  size?: Scalars['Int'];
};

export type WaybillRider = {
  id: Scalars['String'];
  isBlocked: Scalars['Boolean'];
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type WaybillRiders = {
  count: Scalars['Int'];
  items: Array<WaybillRider>;
};

export type Waybills = {
  count: Scalars['Int'];
  items: Array<Waybill>;
};

export type GetPaymentsByContractIdQueryVariables = Exact<{
  contractId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<PaymentsQueryParams>;
}>;


export type GetPaymentsByContractIdQuery = { cabinet?: { company?: { payments: { items: Array<{ id: string, type: string, balance: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> } | { id: string, type: string, balance: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> }> } } | { payments: { items: Array<{ id: string, type: string, balance: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> } | { id: string, type: string, balance: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> }> } } | { payments: { items: Array<{ id: string, type: string, balance: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> } | { id: string, type: string, balance: Array<{ amount?: number | null, createdAt?: any | null, description?: string | null }> }> } } | null } | null };

export type DeletePaymentMutationVariables = Exact<{
  contractId: Scalars['ID'];
  paymentId: Scalars['ID'];
  commentary: Scalars['String'];
}>;


export type DeletePaymentMutation = { deletePayment?: string | null };

export type GetStatementsReceiptsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: StatementsReceiptsQueryParams;
}>;


export type GetStatementsReceiptsQuery = { cabinet?: { company?: { statementsReceipts: { count: number, items: Array<{ id: string, number: string, date: string, contragent: string, inn: string, purpose: string, amount: string, status: string, message?: string | null, contractId?: string | null, organizationId?: string | null }> } } | { statementsReceipts: { count: number, items: Array<{ id: string, number: string, date: string, contragent: string, inn: string, purpose: string, amount: string, status: string, message?: string | null, contractId?: string | null, organizationId?: string | null }> } } | { statementsReceipts: { count: number, items: Array<{ id: string, number: string, date: string, contragent: string, inn: string, purpose: string, amount: string, status: string, message?: string | null, contractId?: string | null, organizationId?: string | null }> } } | null } | null };

export type AccountantRestartStatementReceiptMutationVariables = Exact<{
  id: Scalars['ID'];
  customContractId?: InputMaybe<Scalars['ID']>;
  force?: InputMaybe<Scalars['Boolean']>;
}>;


export type AccountantRestartStatementReceiptMutation = { restartStatementReceipt?: boolean | null };

export type GetStatementReceiptContractsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  statementReceiptId: Scalars['ID'];
}>;


export type GetStatementReceiptContractsQuery = { cabinet?: { company?: { statementReceiptContracts: Array<{ id: string, contract: string }> } | { statementReceiptContracts: Array<{ id: string, contract: string }> } | { statementReceiptContracts: Array<{ id: string, contract: string }> } | null } | null };

export type AccountantCancelStatementReceiptMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AccountantCancelStatementReceiptMutation = { cancelStatementReceipt?: boolean | null };

export type GetStatementsReceiptsReportUrlQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
}>;


export type GetStatementsReceiptsReportUrlQuery = { cabinet?: { company?: { downloadStatementsReceiptsReport: string } | { downloadStatementsReceiptsReport: string } | { downloadStatementsReceiptsReport: string } | null } | null };

export type GetInvoicesQueryVariables = Exact<{
  page: Scalars['Int'];
  size: Scalars['Int'];
  organizationName?: InputMaybe<Scalars['String']>;
  invoiceStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
}>;


export type GetInvoicesQuery = { invoices: { invoicesList: { count: number, total: number, items: Array<{ id: string, createdAt: string, organizationId: string, organizationName: string, contract: string, contractId: string, paymentPurpose: string, amount: number, status: string }> } } };

export type GetInvoiceOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvoiceOrganizationsQuery = { invoices: { fuelUpBankAccount: string, invoiceOrganizations: Array<{ name: string, id: string }> } };

export type CreateInvoicesMutationVariables = Exact<{
  organizations: Array<Scalars['String']> | Scalars['String'];
  invoiceType: InvoiceType;
  bankAccount: Scalars['String'];
  prepayDays: Scalars['Float'];
}>;


export type CreateInvoicesMutation = { createInvoices?: boolean | null };

export type SaveInvoiceMutationVariables = Exact<{
  invoiceId: Scalars['ID'];
  amount: Scalars['Float'];
  paymentPurpose: Scalars['String'];
  status: Scalars['String'];
}>;


export type SaveInvoiceMutation = { saveInvoice?: boolean | null };

export type SubmitInvoicesMutationVariables = Exact<{ [key: string]: never; }>;


export type SubmitInvoicesMutation = { submitInvoices?: boolean | null };

export type AccountantFetchOfflineCompanyStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  contractsType: Scalars['String'];
  partnerId?: InputMaybe<Scalars['ID']>;
}>;


export type AccountantFetchOfflineCompanyStationsQuery = { regions: Array<{ id?: string | null, name: string }>, cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null, region?: string | null, partnerExtId?: string | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null, region?: string | null, partnerExtId?: string | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null, region?: string | null, partnerExtId?: string | null }>, status: Array<{ status: StationStatus, count: number }> } } | null } | null };

export type AccountantGetCompanyOrdersWithContractsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type AccountantGetCompanyOrdersWithContractsQuery = { cabinet?: { company?: { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, ordersNew: { count: number, items: Array<{ id: string, date: any, type?: string | null, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, type?: string | null, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, type?: string | null, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, ordersNew: { count: number, items: Array<{ id: string, date: any, type?: string | null, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, type?: string | null, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, type?: string | null, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, ordersNew: { count: number, items: Array<{ id: string, date: any, type?: string | null, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, type?: string | null, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, type?: string | null, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type GetStatementsPatternsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetStatementsPatternsQuery = { cabinet?: { company?: { statementsPatterns: Array<{ id: string, payerName?: string | null, companyName: string, contractName: string, pattern: string, commentary: string }> } | { statementsPatterns: Array<{ id: string, payerName?: string | null, companyName: string, contractName: string, pattern: string, commentary: string }> } | { statementsPatterns: Array<{ id: string, payerName?: string | null, companyName: string, contractName: string, pattern: string, commentary: string }> } | null } | null };

export type AddStatementsPatternMutationVariables = Exact<{
  data: StatementPatternData;
}>;


export type AddStatementsPatternMutation = { addStatementsPattern: boolean };

export type DeleteStatementsPatternMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStatementsPatternMutation = { deleteStatementsPattern: boolean };

export type AdminFetchCompanyUsersQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UsersQueryParams>;
}>;


export type AdminFetchCompanyUsersQuery = { cabinet?: { company?: { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null }> } } | { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null }> } } | { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null }> } } | null } | null };

export type GetAuthLogsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: LogsQueryParams;
}>;


export type GetAuthLogsQuery = { cabinet?: { company?: { logs: { count: number, items: Array<{ date: any, phone: string, logType: string, logName: string, smsCode?: string | null, input?: string | null }>, summary: { total?: number | null, successful?: number | null, errors?: number | null, invalid?: number | null, timeouts?: number | null } } } | { logs: { count: number, items: Array<{ date: any, phone: string, logType: string, logName: string, smsCode?: string | null, input?: string | null }>, summary: { total?: number | null, successful?: number | null, errors?: number | null, invalid?: number | null, timeouts?: number | null } } } | { logs: { count: number, items: Array<{ date: any, phone: string, logType: string, logName: string, smsCode?: string | null, input?: string | null }>, summary: { total?: number | null, successful?: number | null, errors?: number | null, invalid?: number | null, timeouts?: number | null } } } | null } | null };

export type AdminGetCompanyLimitsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: LimitsQueryParams;
}>;


export type AdminGetCompanyLimitsQuery = { cabinet?: { company?: { limits: { count: number, items: Array<{ phone: string }> } } | { limits: { count: number, items: Array<{ phone: string }> } } | { limits: { count: number, items: Array<{ phone: string }> } } | null } | null };

export type AdminResetAuthLimitMutationVariables = Exact<{
  type: Scalars['String'];
  id: Scalars['String'];
}>;


export type AdminResetAuthLimitMutation = { resetAuthLimits: boolean };

export type AdminFetchAzsInfoQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type AdminFetchAzsInfoQuery = { cabinet?: { company?: { id: string, name?: string | null, status?: CompanyStatus | null, contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }> } | { id: string, name?: string | null, status?: CompanyStatus | null, contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }> } | { id: string, name?: string | null, status?: CompanyStatus | null, contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }> } | null } | null };

export type AdminGetAzsInfoTabQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type AdminGetAzsInfoTabQuery = { cabinet?: { company?: { contract?: { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { contract?: { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { contract?: { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | { balance: number, balanceLimit: number } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type AdminGetAzsCompanyInfoQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type AdminGetAzsCompanyInfoQuery = { cabinet?: { company?: { id: string, name?: string | null, type: string, brand?: string | null, director?: string | null, phone?: string | null, email?: string | null, inn?: string | null, kpp?: string | null, ogrn?: string | null, postAddress?: string | null, officialAddress?: string | null, companyType?: string | null, buh: { name?: string | null, phone?: string | null, email?: string | null }, tech: { name?: string | null, phone?: string | null, email?: string | null }, additional: { commentary?: string | null }, contract?: { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | null, contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null }> } | { id: string, name?: string | null, type: string, brand?: string | null, director?: string | null, phone?: string | null, email?: string | null, inn?: string | null, kpp?: string | null, ogrn?: string | null, postAddress?: string | null, officialAddress?: string | null, companyType?: string | null, buh: { name?: string | null, phone?: string | null, email?: string | null }, tech: { name?: string | null, phone?: string | null, email?: string | null }, additional: { commentary?: string | null }, contract?: { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | null, contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null }> } | { id: string, name?: string | null, type: string, brand?: string | null, director?: string | null, phone?: string | null, email?: string | null, inn?: string | null, kpp?: string | null, ogrn?: string | null, postAddress?: string | null, officialAddress?: string | null, companyType?: string | null, buh: { name?: string | null, phone?: string | null, email?: string | null }, tech: { name?: string | null, phone?: string | null, email?: string | null }, additional: { commentary?: string | null }, contract?: { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | { bik?: string | null, account?: string | null, correspondence?: string | null } | null, contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null }> } | null } | null };

export type AdminGetContractDataQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type AdminGetContractDataQuery = { cabinet?: { company?: { type: string, contract?: { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | null } | { type: string, contract?: { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | null } | { type: string, contract?: { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | { timezoneOffset: number, id: string, number?: string | null, bik?: string | null, account?: string | null, bank?: string | null, bankCity?: string | null, correspondence?: string | null, date?: string | null, finishDate?: string | null, got: boolean, edo?: boolean | null, paymentType?: ContractPaymentType | null, businessType: ContractBusinessType, delayedDiscount?: boolean | null, personalDiscount?: boolean | null, discount?: number | null, agentCommission?: number | null } | null } | null } | null };

export type AdminGetContractDiscountsQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type AdminGetContractDiscountsQuery = { cabinet?: { company?: { contract?: { discount?: number | null } | { discount?: number | null } | { discount?: number | null, customFuelDiscount?: Array<{ fuel: number, discount: number }> | null } | null } | { contract?: { discount?: number | null } | { discount?: number | null } | { discount?: number | null, customFuelDiscount?: Array<{ fuel: number, discount: number }> | null } | null } | { contract?: { discount?: number | null } | { discount?: number | null } | { discount?: number | null, customFuelDiscount?: Array<{ fuel: number, discount: number }> | null } | null } | null } | null };

export type AdminGetStationIntegrationQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type AdminGetStationIntegrationQuery = { cabinet?: { company?: { stationPartner?: { id: string, name: string, outgoing?: string | null, apiType?: string | null, system?: { id: string, name: string, protocol?: string | null, isPing: boolean } | null } | null, stationPartnerFuels?: Array<{ partnerFuelId: string, fuelId: string, name?: string | null, ename?: string | null }> | null } | {} | null } | null, systems?: Array<{ id: string, name: string, protocol?: string | null, isPing: boolean }> | null, fuel: Array<{ id: string, name: string }> };

export type AdminGetSbidAuthLinkStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminGetSbidAuthLinkStatusQuery = { cabinet?: { isSberBusinessIdLinked?: boolean | null } | null };

export type AdminLinkSberBusinessIdMutationVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type AdminLinkSberBusinessIdMutation = { linkSberBusinessId?: string | null };

export type AdminUnlinkSberBusinessIdMutationVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type AdminUnlinkSberBusinessIdMutation = { unlinkSberBusinessId?: boolean | null };

export type AdminGetContractDocumentsQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type AdminGetContractDocumentsQuery = { cabinet?: { company?: { contract?: { documents?: { count: number, items: Array<{ id: string, filename: string, commentary?: string | null, createdAt: any }> } | null } | {} | null } | { contract?: { documents?: { count: number, items: Array<{ id: string, filename: string, commentary?: string | null, createdAt: any }> } | null } | {} | null } | { contract?: { documents?: { count: number, items: Array<{ id: string, filename: string, commentary?: string | null, createdAt: any }> } | null } | {} | null } | null } | null };

export type AdminDownloadContractDocumentQueryVariables = Exact<{
  contractId: Scalars['ID'];
  documentId: Scalars['ID'];
}>;


export type AdminDownloadContractDocumentQuery = { cabinet?: { company?: { contract?: { document?: { url?: string | null } | null } | {} | null } | { contract?: { document?: { url?: string | null } | null } | {} | null } | { contract?: { document?: { url?: string | null } | null } | {} | null } | null } | null };

export type AdminEditContractDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
  data: OnlineContractDocumentData;
}>;


export type AdminEditContractDocumentMutation = { editContractDocument: boolean };

export type AdminDeleteContractDocumentMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AdminDeleteContractDocumentMutation = { deleteContractDocument: boolean };

export type GetTerBankReportUrlQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type GetTerBankReportUrlQuery = { cabinet?: { company?: { terBankReportUrl: string } | { terBankReportUrl: string } | { terBankReportUrl: string } | null } | null };

export type GetAccountantDashboardReportUrlQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type GetAccountantDashboardReportUrlQuery = { cabinet?: { company?: { accountantDashboardReportUrl: string } | { accountantDashboardReportUrl: string } | { accountantDashboardReportUrl: string } | null } | null };

export type FindCompaniesQueryVariables = Exact<{
  filter: CompaniesFilterParams;
}>;


export type FindCompaniesQuery = { cabinet?: { findCompanies: { items: Array<{ id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }> } } | null };

export type GetCompanyContractsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type GetCompanyContractsQuery = { cabinet?: { company?: { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | null } | null };

export type IndexOrderMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type IndexOrderMutation = { indexOrder: boolean };

export type GetUtmsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUtmsQuery = { cabinet?: { utms: Array<string> } | null };

export type SendReceiptMutationVariables = Exact<{
  bankReserveId: Scalars['String'];
  paymentSource: Scalars['String'];
}>;


export type SendReceiptMutation = { sendReceipt: string };

export type GetNotificationsTemplatesQueryVariables = Exact<{
  id: Scalars['ID'];
  filter: NotificationsTemplatesQueryParams;
}>;


export type GetNotificationsTemplatesQuery = { cabinet?: { company?: { templates: { count: number, items: Array<{ id: string, name: string, channel: NotificationChannel, title: string, template: string, trigger: NotificationTrigger }> } } | { templates: { count: number, items: Array<{ id: string, name: string, channel: NotificationChannel, title: string, template: string, trigger: NotificationTrigger }> } } | { templates: { count: number, items: Array<{ id: string, name: string, channel: NotificationChannel, title: string, template: string, trigger: NotificationTrigger }> } } | null } | null };

export type CreateNotificationTemplateMutationVariables = Exact<{
  data: NotificationTemplateData;
}>;


export type CreateNotificationTemplateMutation = { createNotificationTemplate: { id: string, name: string, channel: NotificationChannel, title: string, template: string, trigger: NotificationTrigger, createdAt: string } };

export type UpdateNotificationTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
  data: NotificationTemplateData;
}>;


export type UpdateNotificationTemplateMutation = { updateNotificationTemplate: { id: string, name: string, channel: NotificationChannel, title: string, template: string, trigger: NotificationTrigger, createdAt: string } };

export type DeleteNotificationTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteNotificationTemplateMutation = { deleteNotificationTemplate: boolean };

export type GetNotificationsQueryVariables = Exact<{
  id: Scalars['ID'];
  filter: NotificationsQueryParams;
}>;


export type GetNotificationsQuery = { cabinet?: { company?: { notifications: { count: number, items: Array<{ recipient: string, message: string, channel: NotificationChannel, status: NotificationStatus, createdAt: string }> } } | { notifications: { count: number, items: Array<{ recipient: string, message: string, channel: NotificationChannel, status: NotificationStatus, createdAt: string }> } } | { notifications: { count: number, items: Array<{ recipient: string, message: string, channel: NotificationChannel, status: NotificationStatus, createdAt: string }> } } | null } | null };

export type GetServerAsuQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServerAsuQuery = { cabinet?: { serverAsu: Array<string> } | null };

export type GetJournalQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: JournalFilterParams;
}>;


export type GetJournalQuery = { cabinet?: { company?: { journal: { count: number, items: Array<{ date: string, email?: string | null, action: string, response: string }> } } | { journal: { count: number, items: Array<{ date: string, email?: string | null, action: string, response: string }> } } | { journal: { count: number, items: Array<{ date: string, email?: string | null, action: string, response: string }> } } | null } | null };

export type GetProfitabilityReportUrlQueryVariables = Exact<{
  id: Scalars['ID'];
  from: Scalars['String'];
  to: Scalars['String'];
}>;


export type GetProfitabilityReportUrlQuery = { cabinet?: { company?: { profitabilityReportUrl: string } | { profitabilityReportUrl: string } | { profitabilityReportUrl: string } | null } | null };

export type GetOrderStatusQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetOrderStatusQuery = { getOrderStatus: { status: boolean, quantity: number } };

export type DeleteApiUserMutationVariables = Exact<{
  userId: Scalars['ID'];
  commentary: Scalars['String'];
}>;


export type DeleteApiUserMutation = { deleteApiUser: { result?: string | null, error?: string | null } };

export type RestoreApiUserMutationVariables = Exact<{
  userId: Scalars['ID'];
  commentary: Scalars['String'];
}>;


export type RestoreApiUserMutation = { restoreApiUser: { result?: string | null, error?: string | null } };

export type CarsGetCompanyCarPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  carId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type CarsGetCompanyCarPageQuery = { cabinet?: { company?: { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: RidersConstraintsType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: RidersConstraintsType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: RidersConstraintsType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | null } | null };

export type CarsRefreshCompanyCarPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  carId: Scalars['ID'];
}>;


export type CarsRefreshCompanyCarPageQuery = { cabinet?: { company?: { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: RidersConstraintsType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null } | { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: RidersConstraintsType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null } | { car?: { id: string, name?: string | null, number: string, region: string, drivers: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, isActive: boolean, limits?: { day?: number | null, week?: number | null, month?: number | null, fuels?: Array<string> | null, blocked: boolean, limitsType: RidersConstraintsType, balance?: number | null } | null }>, partners: Array<{ id: string, name: string, status: TaxiPartnerStatus }> } | null } | null } | null };

export type CarsAddCarMutationVariables = Exact<{
  companyId: Scalars['ID'];
  partnerId: Array<Scalars['ID']> | Scalars['ID'];
  car: CarData;
}>;


export type CarsAddCarMutation = { addCar?: { id: string } | null };

export type CarsGetCarsByQueryQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type CarsGetCarsByQueryQuery = { cabinet?: { company?: { cars: { items: Array<{ id: string, number: string, partners: Array<{ name: string }> }> } } | { cars: { items: Array<{ id: string, number: string, partners: Array<{ name: string }> }> } } | { cars: { items: Array<{ id: string, number: string, partners: Array<{ name: string }> }> } } | null } | null };

export type CodegenMockQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CodegenMockQuery = { cabinet?: { company?: { id: string } | { id: string } | { id: string } | null } | null };

export type CommonGetCompanyUsersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type CommonGetCompanyUsersQuery = { cabinet?: { company?: { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null, access: Array<{ id: string, partners?: Array<{ id: string, name: string }> | null }> }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null, access: Array<{ id: string, partners?: Array<{ id: string, name: string }> | null }> }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { users: { count: number, items: Array<{ id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { name?: string | null, email?: string | null, role?: UsersRoles | null, lastActivity?: any | null, id?: string | null, phone?: string | null, access: Array<{ id: string, partners?: Array<{ id: string, name: string }> | null }> }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | null } | null };

export type CommonAddUserMutationVariables = Exact<{
  companyId: Scalars['ID'];
  user: UserData;
}>;


export type CommonAddUserMutation = { addUser?: string | null };

export type CommonRequestUserPasswordResetMutationVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
  referer: Scalars['String'];
}>;


export type CommonRequestUserPasswordResetMutation = { sendRestoreUserPasswordEmail: string };

export type CommonDeleteUserMutationVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type CommonDeleteUserMutation = { removeUser?: string | null };

export type CommonSaveCompanyDataMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: CompanyData;
}>;


export type CommonSaveCompanyDataMutation = { saveCompany?: { id: string } | { id: string } | { id: string } | null };

export type CommonFetchCompanyStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  contractsType: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StationStatus>;
  partnerId?: InputMaybe<Scalars['ID']>;
}>;


export type CommonFetchCompanyStationsQuery = { cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, certificate?: string | null, certificateKey?: string | null, certificateExpiration?: any | null }>, status: Array<{ status: StationStatus, count: number }> } } | null } | null };

export type CommonGetCompanyOrdersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type CommonGetCompanyOrdersQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type CommonDownloadReportQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type CommonDownloadReportQuery = { cabinet?: { company?: { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | null } | null };

export type SetOrganizationModeMutationVariables = Exact<{
  companyId: Scalars['ID'];
  mode: OrganizationMode;
}>;


export type SetOrganizationModeMutation = { setOrganizationMode: boolean };

export type CompanyAddUserToCompanyMutationVariables = Exact<{
  companyId: Scalars['ID'];
  user: UserData;
}>;


export type CompanyAddUserToCompanyMutation = { addUser?: string | null };

export type RemoveCompanyUserMutationVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
}>;


export type RemoveCompanyUserMutation = { removeUser?: string | null };

export type GetCompanyDepartmentStatsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
}>;


export type GetCompanyDepartmentStatsQuery = { cabinet?: { company?: { partners: Array<{ id: string }>, drivers: { count: number }, cars: { count: number } } | { partners: Array<{ id: string }>, drivers: { count: number }, cars: { count: number } } | { partners: Array<{ id: string }>, drivers: { count: number }, cars: { count: number } } | null } | null };

export type AddCompanyDepartmentMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: PartnerData;
  parentId?: InputMaybe<Scalars['ID']>;
  moveDrivers?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddCompanyDepartmentMutation = { addPartner?: { id: string, name: string } | null };

export type CompanyCreateNewContractMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: ContractData;
}>;


export type CompanyCreateNewContractMutation = { createContract?: { id: string } | { id: string } | { id: string } | null };

export type ChangeDiscountMutationVariables = Exact<{
  contractId: Scalars['ID'];
  discount?: InputMaybe<Scalars['Float']>;
  customFuelDiscount?: InputMaybe<Array<ContractCustumFuelDiscountData> | ContractCustumFuelDiscountData>;
  commentary: Scalars['String'];
}>;


export type ChangeDiscountMutation = { changeDiscount?: boolean | null };

export type CompanyUpdateCompanyContractMutationVariables = Exact<{
  contractId: Scalars['ID'];
  data: CompanyData;
}>;


export type CompanyUpdateCompanyContractMutation = { saveCompany?: { id: string } | { id: string } | { id: string } | null };

export type FindCorpCompaniesQueryVariables = Exact<{
  filter?: InputMaybe<CompaniesFilterParams>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type FindCorpCompaniesQuery = { cabinet?: { findCompanies: { count: number, stat: Array<{ status: CompanyStatus, count: number }>, items: Array<{ id: string, name?: string | null, type: string, source?: string | null, companyType?: string | null, registered: any, status?: CompanyStatus | null, stat: { driversCount: number, departmentsCount: number, allDepartmentsCount: number, activeDriversCount: number }, payments: { balance: number }, contract?: { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | null } | { id: string, name?: string | null, type: string, source?: string | null, companyType?: string | null, registered: any, status?: CompanyStatus | null, payments: { balance: number }, contract?: { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | null } | { id: string, name?: string | null, type: string, source?: string | null, companyType?: string | null, registered: any, status?: CompanyStatus | null, stat: { driversCount: number, departmentsCount: number, allDepartmentsCount: number, activeDriversCount: number }, payments: { balance: number }, contract?: { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | null }> } } | null };

export type FindAzsCompaniesQueryVariables = Exact<{
  filter?: InputMaybe<CompaniesFilterParams>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type FindAzsCompaniesQuery = { cabinet?: { findCompanies: { count: number, stat: Array<{ status: CompanyStatus, count: number }>, items: Array<{ id: string, name?: string | null, type: string, brand?: string | null, source?: string | null, companyType?: string | null, registered: any, status?: CompanyStatus | null, contract?: { balance: number } | {} | null, contracts: Array<{ id: string, number?: string | null, paymentType?: ContractPaymentType | null, balanceLimit: number } | { id: string, number?: string | null, paymentType?: ContractPaymentType | null, balanceLimit: number } | { id: string, number?: string | null, paymentType?: ContractPaymentType | null, balanceLimit: number }> } | { id: string, name?: string | null, type: string, brand?: string | null, source?: string | null, companyType?: string | null, registered: any, status?: CompanyStatus | null, stat: { active: number, online: number, all: number }, contract?: { balance: number } | {} | null, contracts: Array<{ id: string, number?: string | null, paymentType?: ContractPaymentType | null, balanceLimit: number } | { id: string, number?: string | null, paymentType?: ContractPaymentType | null, balanceLimit: number } | { id: string, number?: string | null, paymentType?: ContractPaymentType | null, balanceLimit: number }> } | { id: string, name?: string | null, type: string, brand?: string | null, source?: string | null, companyType?: string | null, registered: any, status?: CompanyStatus | null, contract?: { balance: number } | {} | null, contracts: Array<{ id: string, number?: string | null, paymentType?: ContractPaymentType | null, balanceLimit: number } | { id: string, number?: string | null, paymentType?: ContractPaymentType | null, balanceLimit: number } | { id: string, number?: string | null, paymentType?: ContractPaymentType | null, balanceLimit: number }> }> } } | null };

export type FindCompaniesNamesQueryVariables = Exact<{
  filter?: InputMaybe<CompaniesFilterParams>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type FindCompaniesNamesQuery = { cabinet?: { findCompanies: { items: Array<{ id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }> } } | null };

export type GetCompanyBalanceByContractIdQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type GetCompanyBalanceByContractIdQuery = { cabinet?: { company?: { contract?: { balance: number } | {} | null } | { contract?: { balance: number } | {} | null } | { contract?: { balance: number } | {} | null } | null } | null };

export type GetCompanyPaymentsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<PaymentsQueryParams>;
}>;


export type GetCompanyPaymentsQuery = { cabinet?: { company?: { payments: { count: number, items: Array<{ status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | { payments: { count: number, items: Array<{ status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | { payments: { count: number, items: Array<{ status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { status: string, statusDescription?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | null } | null };

export type GetAdminAzsStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  state: Array<StationState> | StationState;
  status?: InputMaybe<StationStatus>;
  region?: InputMaybe<Scalars['String']>;
}>;


export type GetAdminAzsStationsQuery = { cabinet?: { company?: { stationPartner?: { system?: { protocol?: string | null } | null } | null, stations: { active: number, count: number, items: Array<{ id: string, name: string, nameApi: string, brand?: string | null, address?: string | null, color?: string | null, state: StationState, status?: StationStatus | null }> } } | {} | null } | null };

export type GetColorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetColorsQuery = { colors?: Array<{ id?: string | null, name?: string | null }> | null };

export type GetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionsQuery = { regions: Array<{ id?: string | null, name: string }> };

export type GetAdminAzsStationsPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  state: Array<StationState> | StationState;
  status?: InputMaybe<StationStatus>;
  region?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type GetAdminAzsStationsPageQuery = { cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, brand?: string | null, address?: string | null, color?: string | null, status?: StationStatus | null, state: StationState, point?: Array<number> | null, promo?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, brand?: string | null, address?: string | null, color?: string | null, status?: StationStatus | null, state: StationState, point?: Array<number> | null, promo?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, brand?: string | null, address?: string | null, color?: string | null, status?: StationStatus | null, state: StationState, point?: Array<number> | null, promo?: string | null }> } } | null } | null };

export type GetCompanyStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetCompanyStationsQuery = { cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | null } | null };

export type GetCompaniesQueryVariables = Exact<{
  filter?: InputMaybe<CompaniesFilterParams>;
}>;


export type GetCompaniesQuery = { cabinet?: { findCompanies: { items: Array<{ id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }> } } | null };

export type FetchCompanyContractsAndBalanceQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter?: InputMaybe<PaymentsQueryParams>;
}>;


export type FetchCompanyContractsAndBalanceQuery = { cabinet?: { company?: { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, contract?: { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | null, payments: { count: number, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, contract?: { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | null, payments: { count: number, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | { contracts: Array<{ id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType } | { id: string, number?: string | null, businessType: ContractBusinessType }>, contract?: { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | { balanceLimit: number, balance: number } | null, payments: { count: number, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | null } | null, paymentProviders: Array<{ id: string, name: string, service: PaymentService, type: PaymentType }> };

export type RefetchCompanyContractsAndBalanceQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<PaymentsQueryParams>;
}>;


export type RefetchCompanyContractsAndBalanceQuery = { cabinet?: { company?: { contract?: { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | null, payments: { items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | { contract?: { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | null, payments: { items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | { contract?: { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | { balanceLimit: number, balance: number, id: string } | null, payments: { items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | null } | null };

export type CompanyFetchAggregatorTransactionsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type CompanyFetchAggregatorTransactionsQuery = { cabinet?: { company?: { ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | null } | null };

export type CompanyFetchAggregatorContractsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyFetchAggregatorContractsQuery = { cabinet?: { company?: { contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType }> } | { contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType }> } | { contracts: Array<{ id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType } | { id: string, number?: string | null, date?: string | null, finishDate?: string | null, paymentType?: ContractPaymentType | null, discount?: number | null, businessType: ContractBusinessType }> } | null } | null };

export type CompanyGetCustomContractsQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyGetCustomContractsQuery = { cabinet?: { company?: { verified: boolean, contracts: Array<{ discountOrganizations?: Array<string> | null, number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null }> } | { verified: boolean, contracts: Array<{ discountOrganizations?: Array<string> | null, number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null }> } | { verified: boolean, contracts: Array<{ discountOrganizations?: Array<string> | null, number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null } | { number?: string | null, discount?: number | null }> } | null } | null };

export type FetchAdminAzsTransactionsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type FetchAdminAzsTransactionsQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, status: string, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, total: number, quantity: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, status: string, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, total: number, quantity: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, status: string, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, date: any, status: string, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, user?: { phone?: string | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, total: number, quantity: number, discount: number }> } } | null } | null };

export type DownloadAdminAzsTransactionsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type DownloadAdminAzsTransactionsQuery = { cabinet?: { company?: { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | null } | null };

export type CompanyGetCompanyNameByIdQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyGetCompanyNameByIdQuery = { cabinet?: { company?: { name?: string | null } | { name?: string | null } | { name?: string | null } | null } | null };

export type CompanyGetCompanyContractsByIdQueryVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type CompanyGetCompanyContractsByIdQuery = { cabinet?: { company?: { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | { contracts: Array<{ id: string, number?: string | null } | { id: string, number?: string | null } | { id: string, number?: string | null }> } | null } | null };

export type CompanyGetCardsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type CompanyGetCardsQuery = { cabinet?: { company?: { cards?: { cards: Array<{ token: string, psp: number, number: string, label: string, status: boolean, limitsShort: string }> } | null } | { cards?: { cards: Array<{ token: string, psp: number, number: string, label: string, status: boolean, limitsShort: string }> } | null } | { cards?: { cards: Array<{ token: string, psp: number, number: string, label: string, status: boolean, limitsShort: string }> } | null } | null } | null };

export type CompanyGetCardQueryVariables = Exact<{
  companyId: Scalars['ID'];
  token: Scalars['String'];
  filter: OrdersQueryParams;
}>;


export type CompanyGetCardQuery = { cabinet?: { company?: { cards?: { card: { psp: number, number: string, label: string, status: boolean } } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { cards?: { card: { psp: number, number: string, label: string, status: boolean } } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { cards?: { card: { psp: number, number: string, label: string, status: boolean } } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type ChangeBusinessCardSettingsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  token: Scalars['String'];
  status?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
}>;


export type ChangeBusinessCardSettingsMutation = { changeBusinessCardSettings: boolean };

export type GetCardTemplatesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCardTemplatesQuery = { cabinet?: { company?: { cards?: { templates: Array<{ id: string, name: string }> } | null } | { cards?: { templates: Array<{ id: string, name: string }> } | null } | { cards?: { templates: Array<{ id: string, name: string }> } | null } | null } | null };

export type GetCardTemplateQueryVariables = Exact<{
  companyId: Scalars['ID'];
  templateId: Scalars['ID'];
}>;


export type GetCardTemplateQuery = { cabinet?: { company?: { cards?: { template: { name: string, regions: Array<string>, nets: Array<string>, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } } } | null } | { cards?: { template: { name: string, regions: Array<string>, nets: Array<string>, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } } } | null } | { cards?: { template: { name: string, regions: Array<string>, nets: Array<string>, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } } } | null } | null } | null };

export type CreateCardTemplateMutationVariables = Exact<{
  companyId: Scalars['ID'];
  template: CardTemplateData;
}>;


export type CreateCardTemplateMutation = { createCardTemplate: { name: string } };

export type UpdateCardTemplateMutationVariables = Exact<{
  companyId: Scalars['ID'];
  templateId: Scalars['ID'];
  template: CardTemplateData;
}>;


export type UpdateCardTemplateMutation = { updateCardTemplate: { name: string } };

export type DeleteCardTemplateMutationVariables = Exact<{
  companyId: Scalars['ID'];
  templateId: Scalars['ID'];
}>;


export type DeleteCardTemplateMutation = { deleteCardTemplate: boolean };

export type GetCardLimitsQueryVariables = Exact<{
  id: Scalars['ID'];
  token: Scalars['String'];
}>;


export type GetCardLimitsQuery = { cabinet?: { company?: { cards?: { card: { balance: Array<{ id: string, name: string, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean, balanceQuantity?: number | null, usedQuantity: number }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } }>, limits: Array<{ regions: Array<string>, nets: Array<string> }> } } | null } | { cards?: { card: { balance: Array<{ id: string, name: string, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean, balanceQuantity?: number | null, usedQuantity: number }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } }>, limits: Array<{ regions: Array<string>, nets: Array<string> }> } } | null } | { cards?: { card: { balance: Array<{ id: string, name: string, groupPetroleum: { groupRestriction: { allowed: boolean, unlimited: boolean }, restrictions: Array<{ allowed: boolean, name: string, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean, balanceQuantity?: number | null, usedQuantity: number }> }, groupServices: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupGoods: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } }, groupCafe: { groupRestriction: { allowed: boolean, period?: string | null, quantity?: number | null, unit?: string | null, unlimited: boolean } } }>, limits: Array<{ regions: Array<string>, nets: Array<string> }> } } | null } | null } | null };

export type UpdateCardLimitsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  token: Scalars['String'];
  limits: CardLimitsData;
}>;


export type UpdateCardLimitsMutation = { updateCardLimits: boolean };

export type GetCardsDataQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCardsDataQuery = { cabinet?: { company?: { cards?: { fuels: Array<{ name: string }>, regions: Array<{ name: string }>, nets: Array<{ name: string }> } | null } | { cards?: { fuels: Array<{ name: string }>, regions: Array<{ name: string }>, nets: Array<{ name: string }> } | null } | { cards?: { fuels: Array<{ name: string }>, regions: Array<{ name: string }>, nets: Array<{ name: string }> } | null } | null } | null };

export type GetCompanyVerifiedQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyVerifiedQuery = { cabinet?: { company?: { verified: boolean } | { verified: boolean } | { verified: boolean } | null } | null };

export type GetCompanyTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCompanyTypeQuery = { cabinet?: { company?: { type: string } | { type: string } | { type: string } | null } | null };

export type CorpClientGetCompanyPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type CorpClientGetCompanyPageQuery = { cabinet?: { company?: { id: string, name?: string | null, type: string, status?: CompanyStatus | null, source?: string | null, mode: OrganizationMode, registered: any, payments: { balance: number }, contract?: { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | null, cars: { count: number }, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { id: string, name?: string | null, type: string, status?: CompanyStatus | null, source?: string | null, mode: OrganizationMode, registered: any, payments: { balance: number }, contract?: { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | null, cars: { count: number }, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { id: string, name?: string | null, type: string, status?: CompanyStatus | null, source?: string | null, mode: OrganizationMode, registered: any, stat: { driversCount: number, departmentsCount: number, allDepartmentsCount: number, activeDriversCount: number }, payments: { balance: number }, contract?: { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | { id: string, balanceLimit: number } | null, cars: { count: number }, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, payment: { type: string, source: Array<string> }, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | null } | null };

export type ChangeLkFormMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: CompanyData;
}>;


export type ChangeLkFormMutation = { saveCompany?: { id: string, mode: OrganizationMode } | { id: string, mode: OrganizationMode } | { id: string, mode: OrganizationMode } | null };

export type CorpClientFetchDriversTabQueryVariables = Exact<{
  companyId: Scalars['ID'];
  status?: InputMaybe<DriverStatus>;
  query?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type CorpClientFetchDriversTabQuery = { cabinet?: { company?: { reportType?: ReportType | null, type: string, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }>, drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | { reportType?: ReportType | null, type: string, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }>, drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | { reportType?: ReportType | null, type: string, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }>, drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | null } | null };

export type CorpClientRefetchDriversTabQueryVariables = Exact<{
  companyId: Scalars['ID'];
  status?: InputMaybe<DriverStatus>;
  query?: InputMaybe<Scalars['String']>;
  partners?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type CorpClientRefetchDriversTabQuery = { cabinet?: { company?: { drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | { drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | { drivers: { count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> } } | null } | null };

export type GetOfflineClientsQueryVariables = Exact<{
  filter?: InputMaybe<CompaniesFilterParams>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetOfflineClientsQuery = { cabinet?: { findCompanies: { count: number, items: Array<{ id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }> } } | null };

export type GetCompanyOfflineTransactionsQueryVariables = Exact<{
  cardOwnerId?: InputMaybe<Scalars['ID']>;
  dateFrom: Scalars['String'];
  dateTo: Scalars['String'];
}>;


export type GetCompanyOfflineTransactionsQuery = { cabinet?: { company?: { name?: string | null, summaryByFuelType: Array<{ shortName?: string | null, volumeFact: number, costFact: number, costFirm: number, costRefund: number, firmCostRefund: number, volumeRefund: number }> } | { name?: string | null, summaryByFuelType: Array<{ shortName?: string | null, volumeFact: number, costFact: number, costFirm: number, costRefund: number, firmCostRefund: number, volumeRefund: number }> } | { name?: string | null, summaryByFuelType: Array<{ shortName?: string | null, volumeFact: number, costFact: number, costFirm: number, costRefund: number, firmCostRefund: number, volumeRefund: number }> } | null } | null };

export type GetDriversQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<DriverStatus>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetDriversQuery = { cabinet?: { company?: { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | null } | null };

export type GetDriversListPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<DriverStatus>;
  query?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetDriversListPageQuery = { cabinet?: { company?: { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | { drivers: { hasAny: boolean, count: number, items: Array<{ id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerId: string, partnerDriverId: string, partnerName: string, isActive: boolean, limits?: { minLeft: number, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } | null, car?: { id: string, number: string } | null }> }, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null } | null } | null };

export type DriversGetDriverPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  partnerId: Scalars['ID'];
  driverId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type DriversGetDriverPageQuery = { cabinet?: { company?: { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> }, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | null } | null };

export type DriversRefreshDriverPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  partnerId: Scalars['ID'];
  driverId: Scalars['ID'];
}>;


export type DriversRefreshDriverPageQuery = { cabinet?: { company?: { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | { type: string, driver?: { id?: string | null, name?: string | null, phone?: string | null, created?: any | null, partnerCars: Array<{ isActive: boolean, partner: { id: string, name: string }, car?: { id: string, number: string } | null, limits: { blocked: boolean, day?: number | null, week?: number | null, month?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null, limitsType: RidersConstraintsType, balance?: number | null } }> } | null, userAccess?: Array<{ partnerParentId?: string | null, partnerId: string, name: string, role: string }> | null, departments: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null, children: Array<{ id: string, name?: string | null }> }> }> } | null } | null };

export type DriversAddDriverMutationVariables = Exact<{
  companyId: Scalars['ID'];
  driver: DriverData;
}>;


export type DriversAddDriverMutation = { addDriver?: Array<{ id?: string | null }> | null };

export type GetDriverBalanceHistoryQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId: Scalars['ID'];
  contractId?: InputMaybe<Scalars['ID']>;
  driverId: Scalars['ID'];
  filter: QueryParams;
}>;


export type GetDriverBalanceHistoryQuery = { cabinet?: { company?: { driver?: { balanceHistory?: { count: number, items: Array<{ total: number, date: any }> } | null } | null } | { driver?: { balanceHistory?: { count: number, items: Array<{ total: number, date: any }> } | null } | null } | { driver?: { balanceHistory?: { count: number, items: Array<{ total: number, date: any }> } | null } | null } | null } | null };

export type GetDriverExpensesQueryVariables = Exact<{
  companyId: Scalars['ID'];
  partnerId: Scalars['ID'];
  driverId: Scalars['ID'];
}>;


export type GetDriverExpensesQuery = { cabinet?: { company?: { driver?: { limitsAndExpenses: { limitsType: RidersConstraintsType, isQuantity?: boolean | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null } } | null } | { driver?: { limitsAndExpenses: { limitsType: RidersConstraintsType, isQuantity?: boolean | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null } } | null } | { driver?: { limitsAndExpenses: { limitsType: RidersConstraintsType, isQuantity?: boolean | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null } } | null } | null } | null };

export type GetFaqQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFaqQuery = { faq?: Array<{ id?: string | null, question?: string | null, answer?: string | null, sorting?: number | null }> | null };

export type AddFaqMutationVariables = Exact<{
  question?: InputMaybe<Scalars['String']>;
  answer?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Scalars['Float']>;
}>;


export type AddFaqMutation = { addFaq?: { id?: string | null } | null };

export type RemoveQuestionMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveQuestionMutation = { removeFaq?: { id?: string | null } | null };

export type UpdateQuestionMutationVariables = Exact<{
  id: Scalars['String'];
  question?: InputMaybe<Scalars['String']>;
  answer?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Scalars['Float']>;
}>;


export type UpdateQuestionMutation = { editFaq?: { id?: string | null } | null };

export type GetStationsGroupsQueryVariables = Exact<{
  filter: StationsGroupQueryParams;
}>;


export type GetStationsGroupsQuery = { cabinet?: { stationsGroups: { count: number, items: Array<{ id: string, name: string, description: string }> } } | null };

export type GetIndividualDiscountsGroupPageQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GetIndividualDiscountsGroupPageQuery = { cabinet?: { stationsGroup?: { name: string, description: string, stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, organizationName?: string | null }> }, discountsGroups: { count: number, items: Array<{ contractId: string, contractNumber?: string | null, organizationName: string, fuels: Array<number>, discounts: Array<number> }> } } | null } | null };

export type GetStationsGroupStationsQueryVariables = Exact<{
  groupId: Scalars['ID'];
  filter: QueryParams;
}>;


export type GetStationsGroupStationsQuery = { cabinet?: { stationsGroup?: { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, organizationName?: string | null }> } } | null } | null };

export type GetStationsGroupDiscountsQueryVariables = Exact<{
  groupId: Scalars['ID'];
  filter: QueryParams;
}>;


export type GetStationsGroupDiscountsQuery = { cabinet?: { stationsGroup?: { discountsGroups: { count: number, items: Array<{ contractId: string, contractNumber?: string | null, organizationName: string, fuels: Array<number>, discounts: Array<number> }> } } | null } | null };

export type GetStationsGroupFuelDiscountQueryVariables = Exact<{
  groupId: Scalars['ID'];
  discountId: Scalars['ID'];
}>;


export type GetStationsGroupFuelDiscountQuery = { cabinet?: { stationsGroup?: { contractDiscount: { fuel: number, discount: number, startDate?: any | null, endDate?: any | null } } | null } | null };

export type GetStationsGroupContractDiscountsQueryVariables = Exact<{
  groupId: Scalars['ID'];
  contractId: Scalars['ID'];
}>;


export type GetStationsGroupContractDiscountsQuery = { cabinet?: { company?: { name?: string | null, contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | { name?: string | null, contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | { name?: string | null, contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | null, stationsGroup?: { name: string, contractDiscounts: { count: number, items: Array<{ id: string, fuel: number, discount: number, startDate?: any | null, endDate?: any | null }> } } | null } | null };

export type GetStationsGroupNameAndDescriptionQueryVariables = Exact<{
  groupId: Scalars['ID'];
}>;


export type GetStationsGroupNameAndDescriptionQuery = { cabinet?: { stationsGroup?: { name: string, description: string } | null } | null };

export type AddStationsGroupMutationVariables = Exact<{
  name: Scalars['String'];
  description: Scalars['String'];
}>;


export type AddStationsGroupMutation = { addStationsGroup: string };

export type EditStationsGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
  description: Scalars['String'];
}>;


export type EditStationsGroupMutation = { editStationsGroup: boolean };

export type AddCorpClientStationsGroupFuelDiscountsMutationVariables = Exact<{
  groupId: Scalars['ID'];
  contractId: Scalars['ID'];
  discount: Scalars['Float'];
  fuelsIds: Array<Scalars['Int']> | Scalars['Int'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type AddCorpClientStationsGroupFuelDiscountsMutation = { addCorpClientStationsGroupFuelDiscounts: boolean };

export type EditCorpClientStationsGroupFuelDiscountMutationVariables = Exact<{
  discountId: Scalars['ID'];
  discount: Scalars['Float'];
  startDate?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
}>;


export type EditCorpClientStationsGroupFuelDiscountMutation = { editCorpClientStationsGroupFuelDiscount: boolean };

export type DeleteStationsGroupStationsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStationsGroupStationsMutation = { deleteStationsGroupStations: boolean };

export type DeleteStationsGroupStationMutationVariables = Exact<{
  groupId: Scalars['ID'];
  stationId: Scalars['ID'];
}>;


export type DeleteStationsGroupStationMutation = { deleteStationsGroupStation: boolean };

export type DeleteStationsGroupFuelDiscountsMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStationsGroupFuelDiscountsMutation = { deleteStationsGroupFuelDiscounts: boolean };

export type DeleteStationsGroupContractFuelDiscountsMutationVariables = Exact<{
  groupId: Scalars['ID'];
  contractId: Scalars['ID'];
}>;


export type DeleteStationsGroupContractFuelDiscountsMutation = { deleteStationsGroupContractFuelDiscounts: boolean };

export type DeleteStationsGroupFuelDiscountMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteStationsGroupFuelDiscountMutation = { deleteStationsGroupFuelDiscount: boolean };

export type MapsFetchStationsQueryVariables = Exact<{ [key: string]: never; }>;


export type MapsFetchStationsQuery = { stations: Array<{ id: string, name: string, address?: string | null, point?: Array<number> | null, prices: Array<{ price: number, fuel: { code: string } }> }> };

export type MapsFetchFindStationsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type MapsFetchFindStationsQuery = { stationsByES: { items: Array<{ id: string, name: string, address?: string | null }> } };

export type MapsFetchStationPointQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MapsFetchStationPointQuery = { station?: { point?: Array<number> | null } | null };

export type FetchOfflineCompanySettingsAndCatalogQueryVariables = Exact<{
  companyId: Scalars['ID'];
  partnerId: Scalars['ID'];
}>;


export type FetchOfflineCompanySettingsAndCatalogQuery = { productCatalog: Array<{ groupId: number, groupName: string, products?: Array<{ productId: number, productName: string }> | null }>, cabinet?: { company?: { settings?: { osnovans?: Array<number> | null } | null, productCatalog?: Array<{ groupId: string, groupName: string, parentGroupId?: string | null, discount?: number | null, internalId: number, products?: Array<{ productId: string, productName: string, discount?: number | null, internalId: number }> | null }> | null } | {} | null } | null };

export type OfflineSaveCompanySettingsAndCatalogMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: CompanyData;
  partnerId: Scalars['ID'];
}>;


export type OfflineSaveCompanySettingsAndCatalogMutation = { saveCompany?: { id: string } | { id: string } | { id: string } | null };

export type CreateOfflinePartnerMutationVariables = Exact<{
  contract: Scalars['String'];
  firmId: Scalars['String'];
  name: Scalars['String'];
  organization: Scalars['ID'];
  osnovans?: InputMaybe<Array<Scalars['Float']> | Scalars['Float']>;
}>;


export type CreateOfflinePartnerMutation = { createOfflinePartner?: string | null };

export type AddOfflineStationMutationVariables = Exact<{
  partnerId: Scalars['ID'];
  stationData: NewOfflineStationData;
}>;


export type AddOfflineStationMutation = { addOfflineStation?: { id: string } | null };

export type GetOfflineTransactionsPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type GetOfflineTransactionsPageQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | null } | null };

export type GetOfflineTransactionsDownloadLinkQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type GetOfflineTransactionsDownloadLinkQuery = { cabinet?: { company?: { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | { ordersNewReportLink?: string | null } | null } | null };

export type GetOfflineOrderQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
}>;


export type GetOfflineOrderQuery = { cabinet?: { company?: { orderNew?: { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { mps?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | null } | { orderNew?: { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { mps?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | null } | { orderNew?: { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { mps?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { id: string, name: string, address?: string | null, organizationName?: string | null } | null } | null } | null } | null };

export type OrdersGetOrderDataQueryVariables = Exact<{
  fuelUpCompanyId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type OrdersGetOrderDataQuery = { cabinet?: { company?: { orderNew?: { station?: { id: string, name: string, address?: string | null } | null, sberSpasiboDetails?: { credit?: number | null } | null, item?: { quantityReport: number, quantityReq: number, fuel: { id: string, name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null, user?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null, discount?: { station?: number | null, corp?: number | null } | null } | null, corp?: { car?: { id: string, number: string } | null, driver?: { id?: string | null } | null, company: { id: string } | { id: string } | { id: string } } | null } | {} | null } | { orderNew?: { station?: { id: string, name: string, address?: string | null } | null, sberSpasiboDetails?: { credit?: number | null } | null, item?: { quantityReport: number, quantityReq: number, fuel: { id: string, name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null, user?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null, discount?: { station?: number | null, corp?: number | null } | null } | null, corp?: { car?: { id: string, number: string } | null, driver?: { id?: string | null } | null, company: { id: string } | { id: string } | { id: string } } | null } | {} | null } | { orderNew?: { station?: { id: string, name: string, address?: string | null } | null, sberSpasiboDetails?: { credit?: number | null } | null, item?: { quantityReport: number, quantityReq: number, fuel: { id: string, name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null, user?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null, discount?: { station?: number | null, corp?: number | null } | null } | null, corp?: { car?: { id: string, number: string } | null, driver?: { id?: string | null } | null, company: { id: string } | { id: string } | { id: string } } | null } | {} | null } | null } | null };

export type OrdersModifyOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  volume?: InputMaybe<Scalars['Float']>;
  discountCorp?: InputMaybe<Scalars['Float']>;
  discountStation?: InputMaybe<Scalars['Float']>;
  carId?: InputMaybe<Scalars['ID']>;
  fuelId?: InputMaybe<Scalars['Int']>;
  stationId?: InputMaybe<Scalars['ID']>;
  costPromotion?: InputMaybe<Scalars['Float']>;
  commentary: Scalars['String'];
}>;


export type OrdersModifyOrderMutation = { modifyOrder: { id: string } | { id: string } | { id: string } };

export type GetPaymentsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  partnerId?: InputMaybe<Scalars['ID']>;
  filter?: InputMaybe<PaymentsQueryParams>;
}>;


export type GetPaymentsQuery = { cabinet?: { company?: { payments: { balance: number, needMoney: boolean, count: number, cards: Array<{ id: string, name: string, provider: { id: string, name: string } }>, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | { payments: { balance: number, needMoney: boolean, count: number, cards: Array<{ id: string, name: string, provider: { id: string, name: string } }>, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | { payments: { balance: number, needMoney: boolean, count: number, cards: Array<{ id: string, name: string, provider: { id: string, name: string } }>, items: Array<{ id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> } | { pan?: string | null, id: string, amount: number, type: string, status: string, statusDescription?: string | null, transactionId?: string | null, createdAt: any, provider: { name: string }, balance: Array<{ amount?: number | null, description?: string | null }> }> } } | null } | null };

export type GetPaymentProvidersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
}>;


export type GetPaymentProvidersQuery = { paymentProviders: Array<{ id: string, name: string, service: PaymentService, type: PaymentType }> };

export type CreatePaymentMutationVariables = Exact<{
  contractId: Scalars['ID'];
  providerId: Scalars['ID'];
  cardId?: InputMaybe<Scalars['ID']>;
  amount: Scalars['Float'];
}>;


export type CreatePaymentMutation = { createPayment?: { url?: string | null, number: string, id?: string | null, error?: string | null } | { url?: string | null, auto?: boolean | null, id?: string | null, error?: string | null } | { url?: string | null, id?: string | null, error?: string | null } | null };

export type GetMonthlyReportLinkQueryVariables = Exact<{
  id: Scalars['ID'];
  month: Scalars['String'];
}>;


export type GetMonthlyReportLinkQuery = { cabinet?: { company?: { monthlyReportLink?: string | null } | { monthlyReportLink?: string | null } | { monthlyReportLink?: string | null } | null } | null };

export type StationsGetStationPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  stationId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type StationsGetStationPageQuery = { cabinet?: { company?: { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type AdminGetStationPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  stationId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type AdminGetStationPageQuery = { cabinet?: { company?: { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, lastOnline?: any | null, integration?: { login: string, password?: string | null } | null, routeTarget?: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { id: string, name?: string | null, stationPartner?: { system?: { isPing: boolean } | null } | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, lastOnline?: any | null, integration?: { login: string, password?: string | null } | null, routeTarget?: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, lastOnline?: any | null, integration?: { login: string, password?: string | null } | null, routeTarget?: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type GetStationDataQueryVariables = Exact<{
  companyId: Scalars['ID'];
  stationId: Scalars['ID'];
}>;


export type GetStationDataQuery = { cabinet?: { company?: { station?: { name: string, promo?: string | null, address?: string | null, color?: string | null, point?: Array<number> | null } | null } | { station?: { name: string, promo?: string | null, address?: string | null, color?: string | null, point?: Array<number> | null } | null } | { station?: { name: string, promo?: string | null, address?: string | null, color?: string | null, point?: Array<number> | null } | null } | null } | null };

export type StationsRefreshStationPageQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  stationId: Scalars['ID'];
}>;


export type StationsRefreshStationPageQuery = { cabinet?: { company?: { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null } | { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null } | { id: string, name?: string | null, station?: { name: string, status?: StationStatus | null, address?: string | null, isActive?: boolean | null, integration?: { login: string, password?: string | null } | null } | null } | null } | null };

export type StationsGetStationOrdersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type StationsGetStationOrdersQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, corp?: { driver?: { name?: string | null, phone?: string | null } | null } | null, station?: { name: string, address?: string | null } | null, payment: { type: string, source: Array<string> } }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type StationsGetStationCoordsQueryVariables = Exact<{
  stationId: Scalars['ID'];
}>;


export type StationsGetStationCoordsQuery = { station?: { name: string, point?: Array<number> | null, address?: string | null } | null };

export type StationsGetStationPricesQueryVariables = Exact<{
  stationId: Scalars['ID'];
}>;


export type StationsGetStationPricesQuery = { station?: { prices: Array<{ pumps?: Array<number> | null, price: number, fuel: { shortName: string } }> } | null };

export type StationsGetStationPricesDiscountsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  stationId: Scalars['ID'];
}>;


export type StationsGetStationPricesDiscountsQuery = { cabinet?: { company?: { station?: { prices: Array<{ pumps?: Array<number> | null, price: number, fuel: { id: string, shortName: string } }>, stationFuelDiscounts: Array<{ id: string, fuel: number, discount: number }> } | null } | { station?: { prices: Array<{ pumps?: Array<number> | null, price: number, fuel: { id: string, shortName: string } }>, stationFuelDiscounts: Array<{ id: string, fuel: number, discount: number }> } | null } | { station?: { prices: Array<{ pumps?: Array<number> | null, price: number, fuel: { id: string, shortName: string } }>, stationFuelDiscounts: Array<{ id: string, fuel: number, discount: number }> } | null } | null } | null };

export type SetStationDiscountPriceMutationVariables = Exact<{
  discountId?: InputMaybe<Scalars['ID']>;
  stationId: Scalars['ID'];
  fuelId?: InputMaybe<Scalars['ID']>;
  discount: Scalars['Float'];
}>;


export type SetStationDiscountPriceMutation = { setStationFuelDiscount?: boolean | null };

export type AddCompanyStationMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: NewStationData;
}>;


export type AddCompanyStationMutation = { addStation?: { id: string } | null };

export type EditCompanyStationMutationVariables = Exact<{
  stationId: Scalars['ID'];
  data: EditStationData;
}>;


export type EditCompanyStationMutation = { editStation?: { id: string } | null };

export type BulkEditCompanyStationsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  data: BulkEditStationsData;
}>;


export type BulkEditCompanyStationsMutation = { bulkEditStations?: { id: string } | null };

export type GetStationCompanyIdQueryVariables = Exact<{
  stationId: Scalars['ID'];
}>;


export type GetStationCompanyIdQuery = { station?: { organizationId?: string | null } | null };

export type AddColorMutationVariables = Exact<{
  name: Scalars['String'];
  color: Scalars['String'];
}>;


export type AddColorMutation = { addColor?: { id?: string | null } | null };

export type DownloadStationsIntegrationsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
}>;


export type DownloadStationsIntegrationsQuery = { cabinet?: { company?: { integrationsReportLink?: string | null } | { integrationsReportLink?: string | null } | { integrationsReportLink?: string | null } | null } | null };

export type GetOfflineStationPageQueryVariables = Exact<{
  contractId: Scalars['ID'];
  stationId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type GetOfflineStationPageQuery = { cabinet?: { company?: { station?: { name: string, address?: string | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | { station?: { name: string, address?: string | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | { station?: { name: string, address?: string | null, integration?: { login: string, password?: string | null } | null } | null, ordersNew: { count: number, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null } | { cardNumber?: string | null, id: string, date: any, status: string, statusMessage?: string | null, owner?: { name?: string | null, shortName?: string | null } | null, items: Array<{ id?: string | null, type: OrderItemType, quantity: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, station?: { address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { address?: string | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number }> } } | null } | null };

export type StationsFetchStationsListQueryVariables = Exact<{
  size: Scalars['Int'];
  offset: Scalars['Int'];
  query?: InputMaybe<Scalars['String']>;
}>;


export type StationsFetchStationsListQuery = { stationsByES: { count: number, items: Array<{ id: string, name: string, address?: string | null }> } };

export type StationsGetStationsPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  stationId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type StationsGetStationsPageQuery = { station?: { name: string, address?: string | null } | null, cabinet?: { company?: { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | null } | null };

export type StationsUpdateStationInfoAndTransactionsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type StationsUpdateStationInfoAndTransactionsQuery = { cabinet?: { company?: { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | { ordersNew: { count: number, summary: Array<{ name: string, count: number, total: number, discount: number, quantity: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null }> } } | null } | null };

export type StationsAddAsuMutationVariables = Exact<{
  data: NewStationSystemData;
}>;


export type StationsAddAsuMutation = { addStationSystem?: { id: string } | null };

export type StationsFetchStationIntegrationTabQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type StationsFetchStationIntegrationTabQuery = { cabinet?: { serverAsu: Array<string>, company?: { stationPartner?: { id: string, name: string, outgoing?: string | null, apiType?: string | null, apiKey?: string | null, system?: { id: string, name: string, protocol?: string | null, isPing: boolean } | null } | null, stationPartnerFuels?: Array<{ partnerFuelId: string, fuelId: string, name?: string | null, ename?: string | null }> | null } | {} | null } | null, systems?: Array<{ id: string, name: string, protocol?: string | null, isPing: boolean }> | null, fuel: Array<{ id: string, name: string }> };

export type StationsSaveStationIntegrationMutationVariables = Exact<{
  companyId: Scalars['ID'];
  companyData: CompanyData;
  stationData: StationSystemData;
}>;


export type StationsSaveStationIntegrationMutation = { editStationSystem?: { id: string } | null, saveCompany?: { id: string } | { id: string } | { id: string } | null };

export type StationsUpdatePartnerStationsMutationVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type StationsUpdatePartnerStationsMutation = { updatePartnerStations?: boolean | null };

export type StationsIndexStationsMutationVariables = Exact<{
  stationId?: InputMaybe<Scalars['ID']>;
}>;


export type StationsIndexStationsMutation = { indexStations?: boolean | null };

export type GetAzsCompanyStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  contractsType: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StationStatus>;
}>;


export type GetAzsCompanyStationsQuery = { cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, status?: StationStatus | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, status?: StationStatus | null }>, status: Array<{ status: StationStatus, count: number }> } } | { stations: { count: number, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, status?: StationStatus | null }>, status: Array<{ status: StationStatus, count: number }> } } | null } | null };

export type GetCompanyStationsForStationsGroupQueryVariables = Exact<{
  companyId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type GetCompanyStationsForStationsGroupQuery = { cabinet?: { company?: { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | { stations: { count: number, items: Array<{ id: string, name: string, nameApi: string, address?: string | null }> } } | null } | null };

export type AddStationsToStationsGroupMutationVariables = Exact<{
  groupId: Scalars['ID'];
  stationsIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  companyId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
}>;


export type AddStationsToStationsGroupMutation = { addStationsToStationsGroup: boolean };

export type StationsGetCompanyStationsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
}>;


export type StationsGetCompanyStationsQuery = { cabinet?: { company?: { stations: { items: Array<{ id: string, name: string, address?: string | null }> } } | { stations: { items: Array<{ id: string, name: string, address?: string | null }> } } | { stations: { items: Array<{ id: string, name: string, address?: string | null }> } } | null } | null };

export type StationsGetStationsQueryVariables = Exact<{ [key: string]: never; }>;


export type StationsGetStationsQuery = { stationsByES: { items: Array<{ id: string, name: string, address?: string | null, point?: Array<number> | null, prices: Array<{ price: number, fuel: { code: string } }> }> } };

export type StationsGetMapStationsQueryVariables = Exact<{ [key: string]: never; }>;


export type StationsGetMapStationsQuery = { stationsByES: { items: Array<{ id: string, point?: Array<number> | null }> } };

export type StationsGetStationsWithDiscountQueryVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type StationsGetStationsWithDiscountQuery = { stationsWithDiscount: Array<string> };

export type StationsGetMapStationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type StationsGetMapStationQuery = { station?: { name: string, address?: string | null, prices: Array<{ price: number, fuel: { code: string } }> } | null };

export type StationsSetStationStateMutationVariables = Exact<{
  id: Scalars['ID'];
  state: StationState;
  commentary: Scalars['String'];
}>;


export type StationsSetStationStateMutation = { setStationState: { result?: string | null, error?: string | null } };

export type StationsBulkSetStationStateMutationVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<StationStatus>;
  region?: InputMaybe<Scalars['String']>;
  commentary: Scalars['String'];
  oldState: Array<StationState> | StationState;
  newState: StationState;
}>;


export type StationsBulkSetStationStateMutation = { bulkSetStationsState?: { dataError: Array<string>, pumpsError: Array<{ name: string, address: string }> } | null };

export type BulkSetStationsStateByGroupIdMutationVariables = Exact<{
  groupId: Scalars['ID'];
  state: StationState;
  commentary: Scalars['String'];
}>;


export type BulkSetStationsStateByGroupIdMutation = { bulkSetStationsStateByGroupId: boolean };

export type StationsStateLogsGroupsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type StationsStateLogsGroupsQuery = { cabinet?: { company?: { stationsStateLogsGroups?: { count: number, items: Array<{ id: string, date: any, state: StationState, email: string, commentary: string }> } | null } | { stationsStateLogsGroups?: { count: number, items: Array<{ id: string, date: any, state: StationState, email: string, commentary: string }> } | null } | { stationsStateLogsGroups?: { count: number, items: Array<{ id: string, date: any, state: StationState, email: string, commentary: string }> } | null } | null } | null };

export type StationsGetStationStateLogsQueryVariables = Exact<{
  companyId: Scalars['ID'];
  stationId: Scalars['ID'];
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type StationsGetStationStateLogsQuery = { cabinet?: { company?: { station?: { stateLogs?: { count: number, items: Array<{ date: any, user: string, state: StationState, commentary: string }> } | null } | null } | { station?: { stateLogs?: { count: number, items: Array<{ date: any, user: string, state: StationState, commentary: string }> } | null } | null } | { station?: { stateLogs?: { count: number, items: Array<{ date: any, user: string, state: StationState, commentary: string }> } | null } | null } | null } | null };

export type CopyStationsMutationVariables = Exact<{
  companyId: Scalars['ID'];
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type CopyStationsMutation = { copyStations: boolean };

export type GetUpdatedStationsQueryVariables = Exact<{
  id: Scalars['ID'];
  filter: QueryParams;
}>;


export type GetUpdatedStationsQuery = { cabinet?: { company?: { updatedStations?: { count: number, items: Array<{ id: string, name: string, nameApi: string, address: string, addressApi: string, organizationName: string, lng: number, lngApi: number, lat: number, latApi: number }> } | null } | { updatedStations?: { count: number, items: Array<{ id: string, name: string, nameApi: string, address: string, addressApi: string, organizationName: string, lng: number, lngApi: number, lat: number, latApi: number }> } | null } | { updatedStations?: { count: number, items: Array<{ id: string, name: string, nameApi: string, address: string, addressApi: string, organizationName: string, lng: number, lngApi: number, lat: number, latApi: number }> } | null } | null } | null };

export type TransferStationsToAnotherCompanyMutationVariables = Exact<{
  companyId: Scalars['ID'];
  newCompanyId: Scalars['String'];
  selectedStationIds: Array<Scalars['String']> | Scalars['String'];
  isAllSelected: Scalars['Boolean'];
}>;


export type TransferStationsToAnotherCompanyMutation = { transferStations?: boolean | null };

export type GetStationDataToEditQueryVariables = Exact<{
  companyId: Scalars['ID'];
  stationId: Scalars['ID'];
}>;


export type GetStationDataToEditQuery = { cabinet?: { company?: { station?: { name: string, brand?: string | null, address?: string | null, region?: string | null, promo?: string | null, color?: string | null, point?: Array<number> | null, mode?: { type: StationMode } | null } | null } | { station?: { name: string, brand?: string | null, address?: string | null, region?: string | null, promo?: string | null, color?: string | null, point?: Array<number> | null, mode?: { type: StationMode } | null } | null } | { station?: { name: string, brand?: string | null, address?: string | null, region?: string | null, promo?: string | null, color?: string | null, point?: Array<number> | null, mode?: { type: StationMode } | null } | null } | null } | null };

export type DownloadStationsInfoQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  state: Array<StationState> | StationState;
  status?: InputMaybe<StationStatus>;
  region?: InputMaybe<Scalars['String']>;
}>;


export type DownloadStationsInfoQuery = { cabinet?: { company?: { stationsInfoReportLink?: string | null } | { stationsInfoReportLink?: string | null } | { stationsInfoReportLink?: string | null } | null } | null };

export type GetInternalOrdersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  contractId?: InputMaybe<Scalars['ID']>;
  filter: OrdersQueryParams;
}>;


export type GetInternalOrdersQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { cardNumber?: string | null, bankProduct?: string | null, id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, items: Array<{ id?: string | null, type: OrderItemType, quantityReq: number, quantityReport: number, groupName?: string | null, shortName?: string | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, cost?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null }>, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { company: { name?: string | null } | { name?: string | null } | { name?: string | null }, driver?: { name?: string | null, phone?: string | null } | null, car?: { number: string } | null, waybill?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null, sberSpasiboDetails?: { subId: string, costPromotion?: number | null } | null }>, summary: Array<{ name: string, count: number, quantity: number, total: number, discount: number }> } } | null } | null };

export type GetInternalOrderQueryVariables = Exact<{
  companyId: Scalars['ID'];
  orderId: Scalars['ID'];
}>;


export type GetInternalOrderQuery = { cabinet?: { company?: { orderNew?: { id: string, date: any, finished?: any | null, sberId?: boolean | null, payment: { id?: string | null, type: string, source: Array<string> }, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { id: string, date: any, finished?: any | null, sberId?: boolean | null, payment: { id?: string | null, type: string, source: Array<string> }, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { stationOrderId?: string | null, bankReserveId?: string | null, id: string, date: any, finished?: any | null, sberId?: boolean | null, item?: { pump?: number | null, quantityReq: number, quantityReport: number, fuel: { name: string }, costReport?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, costReq?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, refund?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null, quantity?: number | null } | null } | null, payment: { id?: string | null, type: string, source: Array<string> }, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | null, orderDetails: Array<{ time: number, params?: string | null, details?: string | null, status: string, email?: string | null }> } | { orderNew?: { id: string, date: any, finished?: any | null, sberId?: boolean | null, payment: { id?: string | null, type: string, source: Array<string> }, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { id: string, date: any, finished?: any | null, sberId?: boolean | null, payment: { id?: string | null, type: string, source: Array<string> }, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { stationOrderId?: string | null, bankReserveId?: string | null, id: string, date: any, finished?: any | null, sberId?: boolean | null, item?: { pump?: number | null, quantityReq: number, quantityReport: number, fuel: { name: string }, costReport?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, costReq?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, refund?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null, quantity?: number | null } | null } | null, payment: { id?: string | null, type: string, source: Array<string> }, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | null, orderDetails: Array<{ time: number, params?: string | null, details?: string | null, status: string, email?: string | null }> } | { orderNew?: { id: string, date: any, finished?: any | null, sberId?: boolean | null, payment: { id?: string | null, type: string, source: Array<string> }, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { id: string, date: any, finished?: any | null, sberId?: boolean | null, payment: { id?: string | null, type: string, source: Array<string> }, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | { stationOrderId?: string | null, bankReserveId?: string | null, id: string, date: any, finished?: any | null, sberId?: boolean | null, item?: { pump?: number | null, quantityReq: number, quantityReport: number, fuel: { name: string }, costReport?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, prices?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, costReq?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null } | null, refund?: { corp?: number | null, fact?: number | null, user?: number | null, station?: number | null, quantity?: number | null } | null } | null, payment: { id?: string | null, type: string, source: Array<string> }, station?: { id: string, name: string, address?: string | null, contractId?: string | null, organizationId?: string | null, mode?: { type: StationMode } | null } | null, corp?: { company: { id: string, name?: string | null } | { id: string, name?: string | null } | { id: string, name?: string | null }, driver?: { id?: string | null, name?: string | null, phone?: string | null, partnerId: string } | null, car?: { id: string, number: string } | null, waybill?: { number: string, validSince: string, validTo: string, limit: number } | null } | null, user?: { id?: string | null, phone?: string | null } | null, sberSpasiboDetails?: { oid?: string | null, subId: string, status?: SberSpasiboStatus | null, debit?: number | null, credit?: number | null, refund?: number | null, costPromotion?: number | null } | null } | null, orderDetails: Array<{ time: number, params?: string | null, details?: string | null, status: string, email?: string | null }> } | null } | null };

export type SupportFetchDriversTabQueryVariables = Exact<{
  companyId: Scalars['ID'];
  status?: InputMaybe<DriverStatus>;
  query?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type SupportFetchDriversTabQuery = { cabinet?: { company?: { drivers: { activeCount: number, totalCount: number, items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | { drivers: { activeCount: number, totalCount: number, items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | { drivers: { activeCount: number, totalCount: number, items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | null } | null };

export type SupportRefetchDriversTabQueryVariables = Exact<{
  companyId: Scalars['ID'];
  status?: InputMaybe<DriverStatus>;
  query?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type SupportRefetchDriversTabQuery = { cabinet?: { company?: { drivers: { items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | { drivers: { items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | { drivers: { items: Array<{ id?: string | null, created?: any | null, name?: string | null, phone?: string | null, partnerId: string, partnerName: string, partnerParentName?: string | null }> } } | null } | null };

export type AdminGetApiUsersQueryVariables = Exact<{
  companyId: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  page: Scalars['Int'];
  size: Scalars['Int'];
}>;


export type AdminGetApiUsersQuery = { cabinet?: { company?: { apiUsers: { count: number, items: Array<{ hasSberLoyalty?: number | null, registered?: any | null, email?: string | null, id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null }> } } | { apiUsers: { count: number, items: Array<{ hasSberLoyalty?: number | null, registered?: any | null, email?: string | null, id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null }> } } | { apiUsers: { count: number, items: Array<{ hasSberLoyalty?: number | null, registered?: any | null, email?: string | null, id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null } | { id?: string | null, phone?: string | null }> } } | null } | null };

export type SupportFetchUserPageQueryVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type SupportFetchUserPageQuery = { cabinet?: { company?: { apiUser?: { id?: string | null, email?: string | null, phone?: string | null, state: RecordState, registered?: any | null, sberLoyaltyBalance?: number | null, lastActivity?: any | null, version?: { os?: string | null, osVersion?: string | null, appType?: string | null, appVersion?: string | null } | null, drivers: Array<{ id?: string | null, companyId?: string | null, companyName?: string | null, companyReportType?: string | null, partnerId: string, partnerName: string, isActive: boolean, limitsAndExpenses: { limitsType: RidersConstraintsType, balance?: number | null, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null }, car?: { id: string, number: string } | null }> } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { apiUser?: { id?: string | null, email?: string | null, phone?: string | null, state: RecordState, registered?: any | null, sberLoyaltyBalance?: number | null, lastActivity?: any | null, version?: { os?: string | null, osVersion?: string | null, appType?: string | null, appVersion?: string | null } | null, drivers: Array<{ id?: string | null, companyId?: string | null, companyName?: string | null, companyReportType?: string | null, partnerId: string, partnerName: string, isActive: boolean, limitsAndExpenses: { limitsType: RidersConstraintsType, balance?: number | null, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null }, car?: { id: string, number: string } | null }> } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { apiUser?: { id?: string | null, email?: string | null, phone?: string | null, state: RecordState, registered?: any | null, sberLoyaltyBalance?: number | null, lastActivity?: any | null, version?: { os?: string | null, osVersion?: string | null, appType?: string | null, appVersion?: string | null } | null, drivers: Array<{ id?: string | null, companyId?: string | null, companyName?: string | null, companyReportType?: string | null, partnerId: string, partnerName: string, isActive: boolean, limitsAndExpenses: { limitsType: RidersConstraintsType, balance?: number | null, blocked: boolean, day?: number | null, week?: number | null, month?: number | null, dayExpenses?: number | null, weekExpenses?: number | null, monthExpenses?: number | null, isQuantity?: boolean | null, fuels?: Array<string> | null, regions?: Array<string> | null }, car?: { id: string, number: string } | null }> } | null, ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | null } | null };

export type SupportGetUserOrdersQueryVariables = Exact<{
  companyId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type SupportGetUserOrdersQuery = { cabinet?: { company?: { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { ordersNew: { count: number, items: Array<{ id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null } | { id: string, type?: string | null, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, user?: { phone?: string | null } | null, payment: { type: string, source: Array<string> }, corp?: { car?: { number: string } | null } | null, station?: { name: string, address?: string | null } | null }> } } | null } | null };

export type GetMonitoringTabQueryVariables = Exact<{
  status?: InputMaybe<StationStatus>;
  query?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Array<StationState> | StationState>;
  sort?: InputMaybe<StationsSort>;
  sortDir?: InputMaybe<SortDirection>;
}>;


export type GetMonitoringTabQuery = { stationsByES: { count: number, status: Array<{ status: StationStatus, count: number }>, items: Array<{ id: string, name: string, address?: string | null, lastOnline?: any | null, organizationName?: string | null, organizationId?: string | null, stationName?: string | null, state: StationState, status?: StationStatus | null, acs?: string | null, stateDetails?: { date: string, email: string, commentary: string } | null }> } };

export type SupportRequestUserRestorePasswordEmailMutationVariables = Exact<{
  companyId: Scalars['ID'];
  userId: Scalars['ID'];
  referer: Scalars['String'];
}>;


export type SupportRequestUserRestorePasswordEmailMutation = { result: string };

export type SupportDismissOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  volume?: InputMaybe<Scalars['Float']>;
  commentary: Scalars['String'];
  partial?: InputMaybe<Scalars['Boolean']>;
}>;


export type SupportDismissOrderMutation = { dismissOrder: { id: string } | { id: string } | { id: string } };

export type SupportDismissOrderToIncomeMutationVariables = Exact<{
  orderId: Scalars['ID'];
  volume?: InputMaybe<Scalars['Float']>;
  commentary: Scalars['String'];
}>;


export type SupportDismissOrderToIncomeMutation = { dismissOrderToIncome: { id: string } | { id: string } | { id: string } };

export type SupportRefundOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  volume: Scalars['Float'];
  commentary: Scalars['String'];
}>;


export type SupportRefundOrderMutation = { refundOrder: { id: string } | { id: string } | { id: string } };

export type SupportUndoLossMutationVariables = Exact<{
  orderId: Scalars['ID'];
  companyId: Scalars['ID'];
  commentary: Scalars['String'];
}>;


export type SupportUndoLossMutation = { undoLoss: { id: string, status: string, message?: string | null } };

export type SupportCancelOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  commentary: Scalars['String'];
}>;


export type SupportCancelOrderMutation = { cancelOrder: { id: string } | { id: string } | { id: string } };

export type SupportCloseOrderMutationVariables = Exact<{
  orderId: Scalars['ID'];
  volume: Scalars['Float'];
  commentary: Scalars['String'];
}>;


export type SupportCloseOrderMutation = { closeOrder: { id: string } | { id: string } | { id: string } };

export type SupportGetScriptsQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportGetScriptsQuery = { scripts: Array<{ id: string, name: string }> };

export type SupportGetScriptByIdQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SupportGetScriptByIdQuery = { script?: { name: string, args: string, entry: string, preview: boolean } | null };

export type SupportCreateScriptRunMutationVariables = Exact<{
  id: Scalars['Int'];
  params: Scalars['String'];
}>;


export type SupportCreateScriptRunMutation = { createScriptRun: { status: RunResultStatus, data?: string | null } };

export type SupportPreviewScriptRunMutationVariables = Exact<{
  id: Scalars['Int'];
  params: Scalars['String'];
}>;


export type SupportPreviewScriptRunMutation = { previewScriptRun: string };

export type SupportExecuteScriptRunMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SupportExecuteScriptRunMutation = { executeScriptRun: { status: RunResultStatus, data?: string | null } };

export type SupportGetRunsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type SupportGetRunsQuery = { runs: { count: number, items: Array<{ id: string, date?: any | null, state: RunState, script: { name: string } }> } };

export type SupportGetRunQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type SupportGetRunQuery = { run?: { id: string, date?: any | null, state: RunState, params: string, script: { id: string, name: string, args: string, preview: boolean }, user?: { email?: string | null } | null } | null };

export type SupportGetCompanyNameByContractIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SupportGetCompanyNameByContractIdQuery = { cabinet?: { company?: { contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | { contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | { contract?: { number?: string | null } | { number?: string | null } | { number?: string | null } | null } | null } | null };

export type RefundSpasiboBonusesMutationVariables = Exact<{
  id: Scalars['String'];
  orderId: Scalars['ID'];
}>;


export type RefundSpasiboBonusesMutation = { result: boolean };

export type CheckContractPaymentsMutationVariables = Exact<{
  contractId: Scalars['ID'];
}>;


export type CheckContractPaymentsMutation = { checkContractPayments: { completed: number, errors: number, amount: number } };

export type PutCardsFirmReferenceMutationVariables = Exact<{
  companyId: Scalars['ID'];
}>;


export type PutCardsFirmReferenceMutation = { putCardsFirmReference: boolean };

export type UnlinkUserSberIdMutationVariables = Exact<{
  userId: Scalars['ID'];
}>;


export type UnlinkUserSberIdMutation = { unlinkUserSberId: string };

export type GetWaybillsQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
}>;


export type GetWaybillsQuery = { cabinet?: { company?: { waybills: { count: number, items: Array<{ id: string, number: string, validSince: string, validTo: string, allowedFuels?: Array<number> | null, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string }> } }> } } | { waybills: { count: number, items: Array<{ id: string, number: string, validSince: string, validTo: string, allowedFuels?: Array<number> | null, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string }> } }> } } | { waybills: { count: number, items: Array<{ id: string, number: string, validSince: string, validTo: string, allowedFuels?: Array<number> | null, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string }> } }> } } | null } | null };

export type GetWaybillQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  waybillId: Scalars['ID'];
  filter: OrdersQueryParams;
}>;


export type GetWaybillQuery = { cabinet?: { company?: { waybill: { id: string, number: string, validSince: string, validTo: string, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } }, ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { waybill: { id: string, number: string, validSince: string, validTo: string, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } }, ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | { waybill: { id: string, number: string, validSince: string, validTo: string, limit: number, limitQuantity: boolean, state: string, createdAt: string, car: { number: string }, partner: { name?: string | null }, riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } }, ordersNew: { count: number, summary: Array<{ name: string, quantity: number, total: number, discount: number }>, items: Array<{ id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, station?: { name: string, address?: string | null } | null } | { id: string, date: any, status: string, statusMessage?: string | null, item?: { quantityReport: number, quantityReq: number, pump?: number | null, fuel: { name: string }, costReport?: { fact?: number | null, station?: number | null, corp?: number | null } | null, costReq?: { fact?: number | null, station?: number | null, corp?: number | null } | null, prices?: { fact?: number | null, station?: number | null, corp?: number | null } | null } | null, station?: { name: string, address?: string | null } | null }> } } | null } | null };

export type GetWaybillRidersQueryVariables = Exact<{
  companyId?: InputMaybe<Scalars['ID']>;
  partnerId?: InputMaybe<Scalars['ID']>;
  waybillId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
}>;


export type GetWaybillRidersQuery = { cabinet?: { company?: { waybill: { riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } } } | { waybill: { riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } } } | { waybill: { riders: { count: number, items: Array<{ name: string, phone: string, isBlocked: boolean }> } } } | null } | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: { hash: string }) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const GetPaymentsByContractIdDocument = new TypedDocumentString(`
    query GetPaymentsByContractId($contractId: ID, $filter: PaymentsQueryParams) {
  cabinet {
    company(contractId: $contractId) {
      payments {
        items(filter: $filter) {
          id
          type
          balance {
            amount
            createdAt
            description
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetPaymentsByContractIdQuery, GetPaymentsByContractIdQueryVariables>;
export const DeletePaymentDocument = new TypedDocumentString(`
    mutation deletePayment($contractId: ID!, $paymentId: ID!, $commentary: String!) {
  deletePayment(
    contractId: $contractId
    paymentId: $paymentId
    commentary: $commentary
  )
}
    `) as unknown as TypedDocumentString<DeletePaymentMutation, DeletePaymentMutationVariables>;
export const GetStatementsReceiptsDocument = new TypedDocumentString(`
    query getStatementsReceipts($companyId: ID!, $filter: StatementsReceiptsQueryParams!) {
  cabinet {
    company(id: $companyId) {
      statementsReceipts(filter: $filter) {
        count
        items {
          id
          number
          date
          contragent
          inn
          purpose
          amount
          status
          message
          contractId
          organizationId
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStatementsReceiptsQuery, GetStatementsReceiptsQueryVariables>;
export const AccountantRestartStatementReceiptDocument = new TypedDocumentString(`
    mutation AccountantRestartStatementReceipt($id: ID!, $customContractId: ID, $force: Boolean) {
  restartStatementReceipt(
    id: $id
    customContractId: $customContractId
    force: $force
  )
}
    `) as unknown as TypedDocumentString<AccountantRestartStatementReceiptMutation, AccountantRestartStatementReceiptMutationVariables>;
export const GetStatementReceiptContractsDocument = new TypedDocumentString(`
    query getStatementReceiptContracts($companyId: ID!, $statementReceiptId: ID!) {
  cabinet {
    company(id: $companyId) {
      statementReceiptContracts(statementReceiptId: $statementReceiptId) {
        id
        contract
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStatementReceiptContractsQuery, GetStatementReceiptContractsQueryVariables>;
export const AccountantCancelStatementReceiptDocument = new TypedDocumentString(`
    mutation AccountantCancelStatementReceipt($id: ID!) {
  cancelStatementReceipt(id: $id)
}
    `) as unknown as TypedDocumentString<AccountantCancelStatementReceiptMutation, AccountantCancelStatementReceiptMutationVariables>;
export const GetStatementsReceiptsReportUrlDocument = new TypedDocumentString(`
    query getStatementsReceiptsReportUrl($companyId: ID) {
  cabinet {
    company(id: $companyId) {
      downloadStatementsReceiptsReport
    }
  }
}
    `) as unknown as TypedDocumentString<GetStatementsReceiptsReportUrlQuery, GetStatementsReceiptsReportUrlQueryVariables>;
export const GetInvoicesDocument = new TypedDocumentString(`
    query getInvoices($page: Int!, $size: Int!, $organizationName: String, $invoiceStatus: [String!], $dateFrom: DateTime!, $dateTo: DateTime!) {
  invoices {
    invoicesList(
      organizationName: $organizationName
      invoiceStatus: $invoiceStatus
      dateFrom: $dateFrom
      dateTo: $dateTo
      page: $page
      size: $size
    ) {
      items {
        id
        createdAt
        organizationId
        organizationName
        contract
        contractId
        paymentPurpose
        amount
        status
      }
      count
      total
    }
  }
}
    `) as unknown as TypedDocumentString<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetInvoiceOrganizationsDocument = new TypedDocumentString(`
    query getInvoiceOrganizations {
  invoices {
    invoiceOrganizations {
      name
      id
    }
    fuelUpBankAccount
  }
}
    `) as unknown as TypedDocumentString<GetInvoiceOrganizationsQuery, GetInvoiceOrganizationsQueryVariables>;
export const CreateInvoicesDocument = new TypedDocumentString(`
    mutation createInvoices($organizations: [String!]!, $invoiceType: InvoiceType!, $bankAccount: String!, $prepayDays: Float!) {
  createInvoices(
    organizations: $organizations
    invoiceType: $invoiceType
    bankAccount: $bankAccount
    prepayDays: $prepayDays
  )
}
    `) as unknown as TypedDocumentString<CreateInvoicesMutation, CreateInvoicesMutationVariables>;
export const SaveInvoiceDocument = new TypedDocumentString(`
    mutation saveInvoice($invoiceId: ID!, $amount: Float!, $paymentPurpose: String!, $status: String!) {
  saveInvoice(
    invoiceId: $invoiceId
    amount: $amount
    paymentPurpose: $paymentPurpose
    status: $status
  )
}
    `) as unknown as TypedDocumentString<SaveInvoiceMutation, SaveInvoiceMutationVariables>;
export const SubmitInvoicesDocument = new TypedDocumentString(`
    mutation submitInvoices {
  submitInvoices
}
    `) as unknown as TypedDocumentString<SubmitInvoicesMutation, SubmitInvoicesMutationVariables>;
export const AccountantFetchOfflineCompanyStationsDocument = new TypedDocumentString(`
    query AccountantFetchOfflineCompanyStations($companyId: ID!, $contractsType: String!, $partnerId: ID) {
  regions {
    id
    name
  }
  cabinet {
    company(id: $companyId) {
      stations(contractsType: $contractsType, partnerId: $partnerId) {
        count
        items {
          id
          name
          address
          lastOnline
          certificate
          certificateKey
          certificateExpiration
          region
          partnerExtId
        }
        status {
          status
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AccountantFetchOfflineCompanyStationsQuery, AccountantFetchOfflineCompanyStationsQueryVariables>;
export const AccountantGetCompanyOrdersWithContractsDocument = new TypedDocumentString(`
    query AccountantGetCompanyOrdersWithContracts($companyId: ID, $contractId: ID, $partnerId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId, contractId: $contractId) {
      contracts {
        id
        number
        businessType
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          date
          type
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          payment {
            type
            source
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AccountantGetCompanyOrdersWithContractsQuery, AccountantGetCompanyOrdersWithContractsQueryVariables>;
export const GetStatementsPatternsDocument = new TypedDocumentString(`
    query getStatementsPatterns($id: ID!) {
  cabinet {
    company(id: $id) {
      statementsPatterns {
        id
        payerName
        companyName
        contractName
        pattern
        commentary
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStatementsPatternsQuery, GetStatementsPatternsQueryVariables>;
export const AddStatementsPatternDocument = new TypedDocumentString(`
    mutation addStatementsPattern($data: StatementPatternData!) {
  addStatementsPattern(data: $data)
}
    `) as unknown as TypedDocumentString<AddStatementsPatternMutation, AddStatementsPatternMutationVariables>;
export const DeleteStatementsPatternDocument = new TypedDocumentString(`
    mutation deleteStatementsPattern($id: ID!) {
  deleteStatementsPattern(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteStatementsPatternMutation, DeleteStatementsPatternMutationVariables>;
export const AdminFetchCompanyUsersDocument = new TypedDocumentString(`
    query AdminFetchCompanyUsers($companyId: ID!, $query: String, $filter: UsersQueryParams) {
  cabinet {
    company(id: $companyId) {
      users(filter: $filter, query: $query) {
        count
        items {
          id
          phone
          ... on LKUser {
            name
            email
            role
            lastActivity
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminFetchCompanyUsersQuery, AdminFetchCompanyUsersQueryVariables>;
export const GetAuthLogsDocument = new TypedDocumentString(`
    query getAuthLogs($companyId: ID!, $filter: LogsQueryParams!) {
  cabinet {
    company(id: $companyId) {
      logs(filter: $filter) {
        count
        items {
          date
          phone
          logType
          logName
          smsCode
          input
        }
        summary {
          total
          successful
          errors
          invalid
          timeouts
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAuthLogsQuery, GetAuthLogsQueryVariables>;
export const AdminGetCompanyLimitsDocument = new TypedDocumentString(`
    query AdminGetCompanyLimits($companyId: ID!, $filter: LimitsQueryParams!) {
  cabinet {
    company(id: $companyId) {
      limits(filter: $filter) {
        count
        items {
          ... on SmsLimit {
            phone
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetCompanyLimitsQuery, AdminGetCompanyLimitsQueryVariables>;
export const AdminResetAuthLimitDocument = new TypedDocumentString(`
    mutation AdminResetAuthLimit($type: String!, $id: String!) {
  resetAuthLimits(type: $type, id: $id)
}
    `) as unknown as TypedDocumentString<AdminResetAuthLimitMutation, AdminResetAuthLimitMutationVariables>;
export const AdminFetchAzsInfoDocument = new TypedDocumentString(`
    query AdminFetchAzsInfo($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      id
      name
      status
      contracts {
        id
        number
        businessType
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminFetchAzsInfoQuery, AdminFetchAzsInfoQueryVariables>;
export const AdminGetAzsInfoTabDocument = new TypedDocumentString(`
    query adminGetAzsInfoTab($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      contract {
        balance
        balanceLimit
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          payment {
            type
            source
          }
          corp {
            company {
              name
            }
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          sberSpasiboDetails {
            subId
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetAzsInfoTabQuery, AdminGetAzsInfoTabQueryVariables>;
export const AdminGetAzsCompanyInfoDocument = new TypedDocumentString(`
    query adminGetAzsCompanyInfo($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      id
      name
      type
      brand
      director
      phone
      email
      buh {
        name
        phone
        email
      }
      tech {
        name
        phone
        email
      }
      additional {
        commentary
      }
      inn
      kpp
      ogrn
      postAddress
      officialAddress
      companyType
      contract {
        bik
        account
        correspondence
      }
      contracts {
        id
        number
        date
        finishDate
        paymentType
        discount
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetAzsCompanyInfoQuery, AdminGetAzsCompanyInfoQueryVariables>;
export const AdminGetContractDataDocument = new TypedDocumentString(`
    query adminGetContractData($contractId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      type
      contract {
        id
        number
        bik
        account
        bank
        bankCity
        correspondence
        date
        finishDate
        got
        edo
        paymentType
        businessType
        delayedDiscount
        personalDiscount
        discount
        agentCommission
        ... on OnlineContract {
          timezoneOffset
        }
        ... on CustomContract {
          timezoneOffset
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetContractDataQuery, AdminGetContractDataQueryVariables>;
export const AdminGetContractDiscountsDocument = new TypedDocumentString(`
    query adminGetContractDiscounts($contractId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      contract {
        discount
        ... on OnlineContract {
          customFuelDiscount {
            fuel
            discount
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetContractDiscountsQuery, AdminGetContractDiscountsQueryVariables>;
export const AdminGetStationIntegrationDocument = new TypedDocumentString(`
    query AdminGetStationIntegration($id: ID) {
  cabinet {
    company(id: $id) {
      ... on AzsCompany {
        stationPartner {
          id
          name
          outgoing
          apiType
          system {
            id
            name
            protocol
            isPing
          }
        }
        stationPartnerFuels {
          partnerFuelId
          fuelId
          name
          ename
        }
      }
    }
  }
  systems {
    id
    name
    protocol
    isPing
  }
  fuel {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AdminGetStationIntegrationQuery, AdminGetStationIntegrationQueryVariables>;
export const AdminGetSbidAuthLinkStatusDocument = new TypedDocumentString(`
    query AdminGetSbidAuthLinkStatus {
  cabinet {
    isSberBusinessIdLinked
  }
}
    `) as unknown as TypedDocumentString<AdminGetSbidAuthLinkStatusQuery, AdminGetSbidAuthLinkStatusQueryVariables>;
export const AdminLinkSberBusinessIdDocument = new TypedDocumentString(`
    mutation AdminLinkSberBusinessId($companyId: ID!) {
  linkSberBusinessId(companyId: $companyId)
}
    `) as unknown as TypedDocumentString<AdminLinkSberBusinessIdMutation, AdminLinkSberBusinessIdMutationVariables>;
export const AdminUnlinkSberBusinessIdDocument = new TypedDocumentString(`
    mutation AdminUnlinkSberBusinessId($companyId: ID!) {
  unlinkSberBusinessId(companyId: $companyId)
}
    `) as unknown as TypedDocumentString<AdminUnlinkSberBusinessIdMutation, AdminUnlinkSberBusinessIdMutationVariables>;
export const AdminGetContractDocumentsDocument = new TypedDocumentString(`
    query adminGetContractDocuments($contractId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      contract {
        ... on OnlineContract {
          documents {
            items {
              id
              filename
              commentary
              createdAt
            }
            count
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetContractDocumentsQuery, AdminGetContractDocumentsQueryVariables>;
export const AdminDownloadContractDocumentDocument = new TypedDocumentString(`
    query adminDownloadContractDocument($contractId: ID!, $documentId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      contract {
        ... on OnlineContract {
          document(id: $documentId) {
            url
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminDownloadContractDocumentQuery, AdminDownloadContractDocumentQueryVariables>;
export const AdminEditContractDocumentDocument = new TypedDocumentString(`
    mutation adminEditContractDocument($id: ID!, $data: OnlineContractDocumentData!) {
  editContractDocument(id: $id, data: $data)
}
    `) as unknown as TypedDocumentString<AdminEditContractDocumentMutation, AdminEditContractDocumentMutationVariables>;
export const AdminDeleteContractDocumentDocument = new TypedDocumentString(`
    mutation adminDeleteContractDocument($id: ID!) {
  deleteContractDocument(id: $id)
}
    `) as unknown as TypedDocumentString<AdminDeleteContractDocumentMutation, AdminDeleteContractDocumentMutationVariables>;
export const GetTerBankReportUrlDocument = new TypedDocumentString(`
    query getTerBankReportUrl($id: ID!, $from: String!, $to: String!) {
  cabinet {
    company(id: $id) {
      terBankReportUrl(from: $from, to: $to)
    }
  }
}
    `) as unknown as TypedDocumentString<GetTerBankReportUrlQuery, GetTerBankReportUrlQueryVariables>;
export const GetAccountantDashboardReportUrlDocument = new TypedDocumentString(`
    query getAccountantDashboardReportUrl($id: ID!, $from: String!, $to: String!) {
  cabinet {
    company(id: $id) {
      accountantDashboardReportUrl(from: $from, to: $to)
    }
  }
}
    `) as unknown as TypedDocumentString<GetAccountantDashboardReportUrlQuery, GetAccountantDashboardReportUrlQueryVariables>;
export const FindCompaniesDocument = new TypedDocumentString(`
    query findCompanies($filter: CompaniesFilterParams!) {
  cabinet {
    findCompanies(filter: $filter, size: 5) {
      items {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FindCompaniesQuery, FindCompaniesQueryVariables>;
export const GetCompanyContractsDocument = new TypedDocumentString(`
    query getCompanyContracts($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      contracts {
        id
        number
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyContractsQuery, GetCompanyContractsQueryVariables>;
export const IndexOrderDocument = new TypedDocumentString(`
    mutation indexOrder($id: String!) {
  indexOrder(id: $id)
}
    `) as unknown as TypedDocumentString<IndexOrderMutation, IndexOrderMutationVariables>;
export const GetUtmsDocument = new TypedDocumentString(`
    query getUtms {
  cabinet {
    utms
  }
}
    `) as unknown as TypedDocumentString<GetUtmsQuery, GetUtmsQueryVariables>;
export const SendReceiptDocument = new TypedDocumentString(`
    mutation sendReceipt($bankReserveId: String!, $paymentSource: String!) {
  sendReceipt(bankReserveId: $bankReserveId, paymentSource: $paymentSource)
}
    `) as unknown as TypedDocumentString<SendReceiptMutation, SendReceiptMutationVariables>;
export const GetNotificationsTemplatesDocument = new TypedDocumentString(`
    query getNotificationsTemplates($id: ID!, $filter: NotificationsTemplatesQueryParams!) {
  cabinet {
    company(id: $id) {
      templates(filter: $filter) {
        items {
          id
          name
          channel
          title
          template
          trigger
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetNotificationsTemplatesQuery, GetNotificationsTemplatesQueryVariables>;
export const CreateNotificationTemplateDocument = new TypedDocumentString(`
    mutation createNotificationTemplate($data: NotificationTemplateData!) {
  createNotificationTemplate(data: $data) {
    id
    name
    channel
    title
    template
    trigger
    createdAt
  }
}
    `) as unknown as TypedDocumentString<CreateNotificationTemplateMutation, CreateNotificationTemplateMutationVariables>;
export const UpdateNotificationTemplateDocument = new TypedDocumentString(`
    mutation updateNotificationTemplate($id: ID!, $data: NotificationTemplateData!) {
  updateNotificationTemplate(id: $id, data: $data) {
    id
    name
    channel
    title
    template
    trigger
    createdAt
  }
}
    `) as unknown as TypedDocumentString<UpdateNotificationTemplateMutation, UpdateNotificationTemplateMutationVariables>;
export const DeleteNotificationTemplateDocument = new TypedDocumentString(`
    mutation deleteNotificationTemplate($id: ID!) {
  deleteNotificationTemplate(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteNotificationTemplateMutation, DeleteNotificationTemplateMutationVariables>;
export const GetNotificationsDocument = new TypedDocumentString(`
    query getNotifications($id: ID!, $filter: NotificationsQueryParams!) {
  cabinet {
    company(id: $id) {
      notifications(filter: $filter) {
        items {
          recipient
          message
          channel
          status
          createdAt
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetServerAsuDocument = new TypedDocumentString(`
    query getServerAsu {
  cabinet {
    serverAsu
  }
}
    `) as unknown as TypedDocumentString<GetServerAsuQuery, GetServerAsuQueryVariables>;
export const GetJournalDocument = new TypedDocumentString(`
    query getJournal($companyId: ID!, $filter: JournalFilterParams!) {
  cabinet {
    company(id: $companyId) {
      journal(filter: $filter) {
        items {
          date
          email
          action
          response
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetJournalQuery, GetJournalQueryVariables>;
export const GetProfitabilityReportUrlDocument = new TypedDocumentString(`
    query getProfitabilityReportUrl($id: ID!, $from: String!, $to: String!) {
  cabinet {
    company(id: $id) {
      profitabilityReportUrl(from: $from, to: $to)
    }
  }
}
    `) as unknown as TypedDocumentString<GetProfitabilityReportUrlQuery, GetProfitabilityReportUrlQueryVariables>;
export const GetOrderStatusDocument = new TypedDocumentString(`
    query getOrderStatus($id: ID!) {
  getOrderStatus(id: $id) {
    status
    quantity
  }
}
    `) as unknown as TypedDocumentString<GetOrderStatusQuery, GetOrderStatusQueryVariables>;
export const DeleteApiUserDocument = new TypedDocumentString(`
    mutation deleteApiUser($userId: ID!, $commentary: String!) {
  deleteApiUser(id: $userId, commentary: $commentary) {
    result
    error
  }
}
    `) as unknown as TypedDocumentString<DeleteApiUserMutation, DeleteApiUserMutationVariables>;
export const RestoreApiUserDocument = new TypedDocumentString(`
    mutation restoreApiUser($userId: ID!, $commentary: String!) {
  restoreApiUser(id: $userId, commentary: $commentary) {
    result
    error
  }
}
    `) as unknown as TypedDocumentString<RestoreApiUserMutation, RestoreApiUserMutationVariables>;
export const CarsGetCompanyCarPageDocument = new TypedDocumentString(`
    query carsGetCompanyCarPage($companyId: ID, $partnerId: ID, $carId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      car(id: $carId) {
        id
        name
        number
        region
        drivers {
          id
          name
          phone
          partnerId
          partnerName
          isActive
          limits {
            day
            week
            month
            fuels
            blocked
            limitsType
            balance
          }
        }
        partners {
          id
          name
          status
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                corp
              }
              costReq {
                fact
                corp
              }
              prices {
                fact
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CarsGetCompanyCarPageQuery, CarsGetCompanyCarPageQueryVariables>;
export const CarsRefreshCompanyCarPageDocument = new TypedDocumentString(`
    query carsRefreshCompanyCarPage($companyId: ID, $partnerId: ID, $carId: ID!) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      car(id: $carId) {
        id
        name
        number
        region
        drivers {
          id
          name
          phone
          partnerId
          partnerName
          isActive
          limits {
            day
            week
            month
            fuels
            blocked
            limitsType
            balance
          }
        }
        partners {
          id
          name
          status
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CarsRefreshCompanyCarPageQuery, CarsRefreshCompanyCarPageQueryVariables>;
export const CarsAddCarDocument = new TypedDocumentString(`
    mutation carsAddCar($companyId: ID!, $partnerId: [ID!]!, $car: CarData!) {
  addCar(companyId: $companyId, partnerId: $partnerId, data: $car) {
    id
  }
}
    `) as unknown as TypedDocumentString<CarsAddCarMutation, CarsAddCarMutationVariables>;
export const CarsGetCarsByQueryDocument = new TypedDocumentString(`
    query carsGetCarsByQuery($companyId: ID, $contractId: ID, $query: String) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      cars(query: $query) {
        items {
          id
          number
          partners {
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CarsGetCarsByQueryQuery, CarsGetCarsByQueryQueryVariables>;
export const CodegenMockDocument = new TypedDocumentString(`
    query codegenMock($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      id
    }
  }
}
    `) as unknown as TypedDocumentString<CodegenMockQuery, CodegenMockQueryVariables>;
export const CommonGetCompanyUsersDocument = new TypedDocumentString(`
    query CommonGetCompanyUsers($companyId: ID, $partnerId: ID, $contractId: ID, $query: String) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId, contractId: $contractId) {
      users(query: $query) {
        count
        items {
          id
          phone
          ... on LKUser {
            name
            email
            role
            access {
              id
              partners {
                id
                name
              }
            }
            lastActivity
          }
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CommonGetCompanyUsersQuery, CommonGetCompanyUsersQueryVariables>;
export const CommonAddUserDocument = new TypedDocumentString(`
    mutation CommonAddUser($companyId: ID!, $user: UserData!) {
  addUser(companyId: $companyId, data: $user)
}
    `) as unknown as TypedDocumentString<CommonAddUserMutation, CommonAddUserMutationVariables>;
export const CommonRequestUserPasswordResetDocument = new TypedDocumentString(`
    mutation CommonRequestUserPasswordReset($companyId: ID!, $userId: ID!, $referer: String!) {
  sendRestoreUserPasswordEmail(
    companyId: $companyId
    id: $userId
    referer: $referer
  )
}
    `) as unknown as TypedDocumentString<CommonRequestUserPasswordResetMutation, CommonRequestUserPasswordResetMutationVariables>;
export const CommonDeleteUserDocument = new TypedDocumentString(`
    mutation CommonDeleteUser($companyId: ID!, $userId: ID!) {
  removeUser(companyId: $companyId, id: $userId)
}
    `) as unknown as TypedDocumentString<CommonDeleteUserMutation, CommonDeleteUserMutationVariables>;
export const CommonSaveCompanyDataDocument = new TypedDocumentString(`
    mutation CommonSaveCompanyData($companyId: ID!, $data: CompanyData!) {
  saveCompany(companyId: $companyId, data: $data) {
    id
  }
}
    `) as unknown as TypedDocumentString<CommonSaveCompanyDataMutation, CommonSaveCompanyDataMutationVariables>;
export const CommonFetchCompanyStationsDocument = new TypedDocumentString(`
    query CommonFetchCompanyStations($companyId: ID!, $contractsType: String!, $page: Int, $size: Int, $query: String, $status: StationStatus, $partnerId: ID) {
  cabinet {
    company(id: $companyId) {
      stations(
        page: $page
        size: $size
        query: $query
        contractsType: $contractsType
        status: $status
        partnerId: $partnerId
      ) {
        count
        items {
          id
          name
          address
          lastOnline
          certificate
          certificateKey
          certificateExpiration
        }
        status {
          status
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CommonFetchCompanyStationsQuery, CommonFetchCompanyStationsQueryVariables>;
export const CommonGetCompanyOrdersDocument = new TypedDocumentString(`
    query CommonGetCompanyOrders($companyId: ID, $contractId: ID, $partnerId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId, contractId: $contractId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CommonGetCompanyOrdersQuery, CommonGetCompanyOrdersQueryVariables>;
export const CommonDownloadReportDocument = new TypedDocumentString(`
    query CommonDownloadReport($companyId: ID, $contractId: ID, $partnerId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId, partnerId: $partnerId) {
      ordersNewReportLink(format: excel, filter: $filter)
    }
  }
}
    `) as unknown as TypedDocumentString<CommonDownloadReportQuery, CommonDownloadReportQueryVariables>;
export const SetOrganizationModeDocument = new TypedDocumentString(`
    mutation SetOrganizationMode($companyId: ID!, $mode: OrganizationMode!) {
  setOrganizationMode(companyId: $companyId, mode: $mode)
}
    `) as unknown as TypedDocumentString<SetOrganizationModeMutation, SetOrganizationModeMutationVariables>;
export const CompanyAddUserToCompanyDocument = new TypedDocumentString(`
    mutation companyAddUserToCompany($companyId: ID!, $user: UserData!) {
  addUser(companyId: $companyId, data: $user)
}
    `) as unknown as TypedDocumentString<CompanyAddUserToCompanyMutation, CompanyAddUserToCompanyMutationVariables>;
export const RemoveCompanyUserDocument = new TypedDocumentString(`
    mutation removeCompanyUser($companyId: ID!, $userId: ID!) {
  removeUser(companyId: $companyId, id: $userId)
}
    `) as unknown as TypedDocumentString<RemoveCompanyUserMutation, RemoveCompanyUserMutationVariables>;
export const GetCompanyDepartmentStatsDocument = new TypedDocumentString(`
    query getCompanyDepartmentStats($companyId: ID, $partnerId: ID) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      partners {
        id
      }
      drivers {
        count
      }
      cars {
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyDepartmentStatsQuery, GetCompanyDepartmentStatsQueryVariables>;
export const AddCompanyDepartmentDocument = new TypedDocumentString(`
    mutation addCompanyDepartment($companyId: ID!, $data: PartnerData!, $parentId: ID, $moveDrivers: Boolean) {
  addPartner(
    companyId: $companyId
    data: $data
    parentId: $parentId
    moveDrivers: $moveDrivers
  ) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<AddCompanyDepartmentMutation, AddCompanyDepartmentMutationVariables>;
export const CompanyCreateNewContractDocument = new TypedDocumentString(`
    mutation companyCreateNewContract($companyId: ID!, $data: ContractData!) {
  createContract(companyId: $companyId, data: $data) {
    id
  }
}
    `) as unknown as TypedDocumentString<CompanyCreateNewContractMutation, CompanyCreateNewContractMutationVariables>;
export const ChangeDiscountDocument = new TypedDocumentString(`
    mutation changeDiscount($contractId: ID!, $discount: Float, $customFuelDiscount: [ContractCustumFuelDiscountData!], $commentary: String!) {
  changeDiscount(
    contractId: $contractId
    discount: $discount
    customFuelDiscount: $customFuelDiscount
    commentary: $commentary
  )
}
    `) as unknown as TypedDocumentString<ChangeDiscountMutation, ChangeDiscountMutationVariables>;
export const CompanyUpdateCompanyContractDocument = new TypedDocumentString(`
    mutation companyUpdateCompanyContract($contractId: ID!, $data: CompanyData!) {
  saveCompany(contractId: $contractId, data: $data) {
    id
  }
}
    `) as unknown as TypedDocumentString<CompanyUpdateCompanyContractMutation, CompanyUpdateCompanyContractMutationVariables>;
export const FindCorpCompaniesDocument = new TypedDocumentString(`
    query findCorpCompanies($filter: CompaniesFilterParams, $page: Int, $size: Int) {
  cabinet {
    findCompanies(filter: $filter, page: $page, size: $size) {
      count
      stat {
        status
        count
      }
      items {
        id
        name
        type
        source
        companyType
        payments {
          balance
        }
        contract {
          id
          balanceLimit
        }
        registered
        status
        ... on AggregatorCompany {
          stat {
            driversCount
            departmentsCount
            allDepartmentsCount
            driversCount
            activeDriversCount
          }
        }
        ... on TKCompany {
          stat {
            driversCount
            departmentsCount
            allDepartmentsCount
            driversCount
            activeDriversCount
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FindCorpCompaniesQuery, FindCorpCompaniesQueryVariables>;
export const FindAzsCompaniesDocument = new TypedDocumentString(`
    query findAzsCompanies($filter: CompaniesFilterParams, $page: Int, $size: Int) {
  cabinet {
    findCompanies(filter: $filter, page: $page, size: $size) {
      count
      stat {
        status
        count
      }
      items {
        id
        name
        type
        brand
        source
        companyType
        contract {
          ... on OnlineContract {
            balance
          }
        }
        contracts {
          id
          number
          paymentType
          balanceLimit
        }
        registered
        status
        ... on AzsCompany {
          stat {
            active
            online
            all
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FindAzsCompaniesQuery, FindAzsCompaniesQueryVariables>;
export const FindCompaniesNamesDocument = new TypedDocumentString(`
    query findCompaniesNames($filter: CompaniesFilterParams, $page: Int, $size: Int) {
  cabinet {
    findCompanies(filter: $filter, page: $page, size: $size) {
      items {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FindCompaniesNamesQuery, FindCompaniesNamesQueryVariables>;
export const GetCompanyBalanceByContractIdDocument = new TypedDocumentString(`
    query getCompanyBalanceByContractId($contractId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      contract {
        ... on OnlineContract {
          balance
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyBalanceByContractIdQuery, GetCompanyBalanceByContractIdQueryVariables>;
export const GetCompanyPaymentsDocument = new TypedDocumentString(`
    query GetCompanyPayments($companyId: ID, $contractId: ID, $filter: PaymentsQueryParams) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      payments {
        count
        items(filter: $filter) {
          status
          statusDescription
          createdAt
          provider {
            name
          }
          balance {
            amount
            description
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyPaymentsQuery, GetCompanyPaymentsQueryVariables>;
export const GetAdminAzsStationsDocument = new TypedDocumentString(`
    query getAdminAzsStations($companyId: ID!, $query: String, $state: [StationState!]!, $status: StationStatus, $region: String) {
  cabinet {
    company(id: $companyId) {
      ... on AzsCompany {
        stationPartner {
          system {
            protocol
          }
        }
        stations(query: $query, state: $state, status: $status, region: $region) {
          active
          count
          items {
            id
            name
            nameApi
            brand
            address
            color
            state
            status
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAdminAzsStationsQuery, GetAdminAzsStationsQueryVariables>;
export const GetColorsDocument = new TypedDocumentString(`
    query getColors {
  colors {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetColorsQuery, GetColorsQueryVariables>;
export const GetRegionsDocument = new TypedDocumentString(`
    query getRegions {
  regions {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<GetRegionsQuery, GetRegionsQueryVariables>;
export const GetAdminAzsStationsPageDocument = new TypedDocumentString(`
    query getAdminAzsStationsPage($companyId: ID!, $query: String, $state: [StationState!]!, $status: StationStatus, $region: String, $page: Int, $pageSize: Int) {
  cabinet {
    company(id: $companyId) {
      stations(
        query: $query
        state: $state
        status: $status
        region: $region
        page: $page
        size: $pageSize
      ) {
        count
        items {
          id
          name
          nameApi
          brand
          address
          color
          status
          state
          point
          promo
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAdminAzsStationsPageQuery, GetAdminAzsStationsPageQueryVariables>;
export const GetCompanyStationsDocument = new TypedDocumentString(`
    query getCompanyStations($companyId: ID!, $query: String, $page: Int, $size: Int) {
  cabinet {
    company(id: $companyId) {
      stations(query: $query, page: $page, size: $size) {
        count
        items {
          id
          name
          nameApi
          address
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyStationsQuery, GetCompanyStationsQueryVariables>;
export const GetCompaniesDocument = new TypedDocumentString(`
    query getCompanies($filter: CompaniesFilterParams) {
  cabinet {
    findCompanies(filter: $filter) {
      items {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const FetchCompanyContractsAndBalanceDocument = new TypedDocumentString(`
    query FetchCompanyContractsAndBalance($companyId: ID!, $filter: PaymentsQueryParams) {
  cabinet {
    company(id: $companyId) {
      contracts {
        id
        number
        businessType
      }
      contract {
        balanceLimit
        balance
      }
      payments {
        count
        items(filter: $filter) {
          id
          amount
          type
          status
          statusDescription
          transactionId
          provider {
            name
          }
          createdAt
          balance {
            amount
            description
          }
          ... on OnlinePayment {
            pan
          }
        }
      }
    }
  }
  paymentProviders(companyId: $companyId) {
    id
    name
    service
    type
  }
}
    `) as unknown as TypedDocumentString<FetchCompanyContractsAndBalanceQuery, FetchCompanyContractsAndBalanceQueryVariables>;
export const RefetchCompanyContractsAndBalanceDocument = new TypedDocumentString(`
    query RefetchCompanyContractsAndBalance($companyId: ID, $contractId: ID, $filter: PaymentsQueryParams) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      contract {
        balanceLimit
        balance
        id
      }
      payments {
        items(filter: $filter) {
          id
          amount
          type
          status
          statusDescription
          transactionId
          provider {
            name
          }
          createdAt
          balance {
            amount
            description
          }
          ... on OnlinePayment {
            pan
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RefetchCompanyContractsAndBalanceQuery, RefetchCompanyContractsAndBalanceQueryVariables>;
export const CompanyFetchAggregatorTransactionsDocument = new TypedDocumentString(`
    query CompanyFetchAggregatorTransactions($companyId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      ordersNew(filter: $filter) {
        count
        summary {
          name
          quantity
          total
          discount
        }
        items {
          id
          date
          status
          statusMessage
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyFetchAggregatorTransactionsQuery, CompanyFetchAggregatorTransactionsQueryVariables>;
export const CompanyFetchAggregatorContractsDocument = new TypedDocumentString(`
    query CompanyFetchAggregatorContracts($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      contracts {
        id
        number
        date
        finishDate
        paymentType
        discount
        businessType
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyFetchAggregatorContractsQuery, CompanyFetchAggregatorContractsQueryVariables>;
export const CompanyGetCustomContractsDocument = new TypedDocumentString(`
    query CompanyGetCustomContracts($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      contracts(contractsType: online, contractsSubtype: [custom]) {
        number
        discount
        ... on CustomContract {
          discountOrganizations
        }
      }
      verified
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyGetCustomContractsQuery, CompanyGetCustomContractsQueryVariables>;
export const FetchAdminAzsTransactionsDocument = new TypedDocumentString(`
    query FetchAdminAzsTransactions($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          date
          status
          corp {
            driver {
              name
            }
            car {
              number
            }
          }
          user {
            phone
          }
          station {
            name
            address
          }
          payment {
            type
            source
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          total
          quantity
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FetchAdminAzsTransactionsQuery, FetchAdminAzsTransactionsQueryVariables>;
export const DownloadAdminAzsTransactionsDocument = new TypedDocumentString(`
    query DownloadAdminAzsTransactions($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      ordersNewReportLink(filter: $filter, format: excel)
    }
  }
}
    `) as unknown as TypedDocumentString<DownloadAdminAzsTransactionsQuery, DownloadAdminAzsTransactionsQueryVariables>;
export const CompanyGetCompanyNameByIdDocument = new TypedDocumentString(`
    query companyGetCompanyNameById($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      name
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyGetCompanyNameByIdQuery, CompanyGetCompanyNameByIdQueryVariables>;
export const CompanyGetCompanyContractsByIdDocument = new TypedDocumentString(`
    query companyGetCompanyContractsById($companyId: ID!) {
  cabinet {
    company(id: $companyId) {
      contracts {
        id
        number
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyGetCompanyContractsByIdQuery, CompanyGetCompanyContractsByIdQueryVariables>;
export const CompanyGetCardsDocument = new TypedDocumentString(`
    query companyGetCards($id: ID) {
  cabinet {
    company(id: $id) {
      cards {
        cards {
          token
          psp
          number
          label
          status
          limitsShort
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyGetCardsQuery, CompanyGetCardsQueryVariables>;
export const CompanyGetCardDocument = new TypedDocumentString(`
    query companyGetCard($companyId: ID!, $token: String!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      cards {
        card(token: $token) {
          psp
          number
          label
          status
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          payment {
            type
            source
          }
          station {
            name
            address
          }
          ... on OfflineOrder {
            cardNumber
            bankProduct
            items {
              id
              type
              quantityReq
              quantityReport
              groupName
              shortName
              prices {
                corp
                fact
                user
                station
              }
              cost {
                corp
                fact
                user
                station
              }
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CompanyGetCardQuery, CompanyGetCardQueryVariables>;
export const ChangeBusinessCardSettingsDocument = new TypedDocumentString(`
    mutation changeBusinessCardSettings($companyId: ID!, $token: String!, $status: Boolean, $label: String) {
  changeBusinessCardSettings(
    companyId: $companyId
    token: $token
    status: $status
    label: $label
  )
}
    `) as unknown as TypedDocumentString<ChangeBusinessCardSettingsMutation, ChangeBusinessCardSettingsMutationVariables>;
export const GetCardTemplatesDocument = new TypedDocumentString(`
    query getCardTemplates($id: ID!) {
  cabinet {
    company(id: $id) {
      cards {
        templates {
          id
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardTemplatesQuery, GetCardTemplatesQueryVariables>;
export const GetCardTemplateDocument = new TypedDocumentString(`
    query getCardTemplate($companyId: ID!, $templateId: ID!) {
  cabinet {
    company(id: $companyId) {
      cards {
        template(id: $templateId) {
          name
          groupPetroleum {
            groupRestriction {
              allowed
              unlimited
            }
            restrictions {
              allowed
              name
              period
              quantity
              unit
              unlimited
            }
          }
          groupServices {
            groupRestriction {
              allowed
              period
              quantity
              unit
              unlimited
            }
          }
          groupGoods {
            groupRestriction {
              allowed
              period
              quantity
              unit
              unlimited
            }
          }
          groupCafe {
            groupRestriction {
              allowed
              period
              quantity
              unit
              unlimited
            }
          }
          regions
          nets
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardTemplateQuery, GetCardTemplateQueryVariables>;
export const CreateCardTemplateDocument = new TypedDocumentString(`
    mutation createCardTemplate($companyId: ID!, $template: CardTemplateData!) {
  createCardTemplate(companyId: $companyId, template: $template) {
    name
  }
}
    `) as unknown as TypedDocumentString<CreateCardTemplateMutation, CreateCardTemplateMutationVariables>;
export const UpdateCardTemplateDocument = new TypedDocumentString(`
    mutation updateCardTemplate($companyId: ID!, $templateId: ID!, $template: CardTemplateData!) {
  updateCardTemplate(
    companyId: $companyId
    templateId: $templateId
    template: $template
  ) {
    name
  }
}
    `) as unknown as TypedDocumentString<UpdateCardTemplateMutation, UpdateCardTemplateMutationVariables>;
export const DeleteCardTemplateDocument = new TypedDocumentString(`
    mutation deleteCardTemplate($companyId: ID!, $templateId: ID!) {
  deleteCardTemplate(companyId: $companyId, templateId: $templateId)
}
    `) as unknown as TypedDocumentString<DeleteCardTemplateMutation, DeleteCardTemplateMutationVariables>;
export const GetCardLimitsDocument = new TypedDocumentString(`
    query getCardLimits($id: ID!, $token: String!) {
  cabinet {
    company(id: $id) {
      cards {
        card(token: $token) {
          balance {
            id
            name
            groupPetroleum {
              groupRestriction {
                allowed
                unlimited
              }
              restrictions {
                allowed
                name
                period
                quantity
                unit
                unlimited
                balanceQuantity
                usedQuantity
              }
            }
            groupServices {
              groupRestriction {
                allowed
                period
                quantity
                unit
                unlimited
              }
            }
            groupGoods {
              groupRestriction {
                allowed
                period
                quantity
                unit
                unlimited
              }
            }
            groupCafe {
              groupRestriction {
                allowed
                period
                quantity
                unit
                unlimited
              }
            }
          }
          limits {
            regions
            nets
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardLimitsQuery, GetCardLimitsQueryVariables>;
export const UpdateCardLimitsDocument = new TypedDocumentString(`
    mutation updateCardLimits($companyId: ID!, $token: String!, $limits: CardLimitsData!) {
  updateCardLimits(companyId: $companyId, token: $token, limits: $limits)
}
    `) as unknown as TypedDocumentString<UpdateCardLimitsMutation, UpdateCardLimitsMutationVariables>;
export const GetCardsDataDocument = new TypedDocumentString(`
    query getCardsData($id: ID!) {
  cabinet {
    company(id: $id) {
      cards {
        fuels {
          name
        }
        regions {
          name
        }
        nets {
          name
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCardsDataQuery, GetCardsDataQueryVariables>;
export const GetCompanyVerifiedDocument = new TypedDocumentString(`
    query getCompanyVerified($id: ID!) {
  cabinet {
    company(id: $id) {
      verified
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyVerifiedQuery, GetCompanyVerifiedQueryVariables>;
export const GetCompanyTypeDocument = new TypedDocumentString(`
    query getCompanyType($id: ID!) {
  cabinet {
    company(id: $id) {
      type
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyTypeQuery, GetCompanyTypeQueryVariables>;
export const CorpClientGetCompanyPageDocument = new TypedDocumentString(`
    query corpClientGetCompanyPage($companyId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      id
      name
      type
      status
      source
      mode
      registered
      payments {
        balance
      }
      contract {
        id
        balanceLimit
      }
      cars {
        count
      }
      ... on TKCompany {
        stat {
          driversCount
          departmentsCount
          allDepartmentsCount
          driversCount
          activeDriversCount
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          payment {
            type
            source
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                corp
              }
              costReq {
                fact
                corp
              }
              prices {
                fact
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CorpClientGetCompanyPageQuery, CorpClientGetCompanyPageQueryVariables>;
export const ChangeLkFormDocument = new TypedDocumentString(`
    mutation changeLkForm($companyId: ID!, $data: CompanyData!) {
  saveCompany(companyId: $companyId, data: $data) {
    id
    mode
  }
}
    `) as unknown as TypedDocumentString<ChangeLkFormMutation, ChangeLkFormMutationVariables>;
export const CorpClientFetchDriversTabDocument = new TypedDocumentString(`
    query CorpClientFetchDriversTab($companyId: ID!, $status: DriverStatus, $query: String, $partners: [String!], $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      departments {
        id
        name
        children {
          id
          name
        }
      }
      reportType
      type
      drivers(
        status: $status
        query: $query
        partners: $partners
        page: $page
        size: $size
      ) {
        count
        items {
          id
          name
          phone
          partnerId
          partnerName
          partnerParentName
          isActive
          limits {
            minLeft
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          car {
            id
            number
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CorpClientFetchDriversTabQuery, CorpClientFetchDriversTabQueryVariables>;
export const CorpClientRefetchDriversTabDocument = new TypedDocumentString(`
    query CorpClientRefetchDriversTab($companyId: ID!, $status: DriverStatus, $query: String, $partners: [String!], $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      drivers(
        status: $status
        query: $query
        partners: $partners
        page: $page
        size: $size
      ) {
        count
        items {
          id
          name
          phone
          partnerId
          partnerName
          partnerParentName
          isActive
          limits {
            minLeft
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          car {
            id
            number
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<CorpClientRefetchDriversTabQuery, CorpClientRefetchDriversTabQueryVariables>;
export const GetOfflineClientsDocument = new TypedDocumentString(`
    query GetOfflineClients($filter: CompaniesFilterParams, $page: Int, $size: Int) {
  cabinet {
    findCompanies(filter: $filter, page: $page, size: $size) {
      count
      items {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetOfflineClientsQuery, GetOfflineClientsQueryVariables>;
export const GetCompanyOfflineTransactionsDocument = new TypedDocumentString(`
    query GetCompanyOfflineTransactions($cardOwnerId: ID, $dateFrom: String!, $dateTo: String!) {
  cabinet {
    company(cardOwnerId: $cardOwnerId) {
      name
      summaryByFuelType(from: $dateFrom, to: $dateTo) {
        shortName
        volumeFact
        costFact
        costFirm
        costRefund
        firmCostRefund
        volumeRefund
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyOfflineTransactionsQuery, GetCompanyOfflineTransactionsQueryVariables>;
export const GetDriversDocument = new TypedDocumentString(`
    query getDrivers($companyId: ID, $partnerId: ID, $query: String, $status: DriverStatus, $page: Int, $size: Int) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      drivers(query: $query, status: $status, page: $page, size: $size) {
        hasAny
        count
        items {
          id
          name
          phone
          created
          partnerId
          partnerDriverId
          partnerName
          isActive
          limits {
            minLeft
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          car {
            id
            number
          }
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetDriversQuery, GetDriversQueryVariables>;
export const GetDriversListPageDocument = new TypedDocumentString(`
    query getDriversListPage($companyId: ID, $partnerId: ID, $status: DriverStatus, $query: String, $page: Int, $size: Int) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      drivers(query: $query, status: $status, page: $page, size: $size) {
        hasAny
        count
        items {
          id
          name
          phone
          created
          partnerId
          partnerDriverId
          partnerName
          isActive
          limits {
            minLeft
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          car {
            id
            number
          }
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetDriversListPageQuery, GetDriversListPageQueryVariables>;
export const DriversGetDriverPageDocument = new TypedDocumentString(`
    query driversGetDriverPage($companyId: ID!, $partnerId: ID!, $driverId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      type
      driver(id: $driverId, partnerId: $partnerId) {
        id
        name
        phone
        created
        partnerCars {
          partner {
            id
            name
          }
          car {
            id
            number
          }
          limits {
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          isActive
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                corp
              }
              costReq {
                fact
                corp
              }
              prices {
                fact
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
      departments {
        id
        name
        children {
          id
          name
          children {
            id
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DriversGetDriverPageQuery, DriversGetDriverPageQueryVariables>;
export const DriversRefreshDriverPageDocument = new TypedDocumentString(`
    query driversRefreshDriverPage($companyId: ID!, $partnerId: ID!, $driverId: ID!) {
  cabinet {
    company(id: $companyId) {
      type
      driver(id: $driverId, partnerId: $partnerId) {
        id
        name
        phone
        created
        partnerCars {
          partner {
            id
            name
          }
          car {
            id
            number
          }
          limits {
            blocked
            day
            week
            month
            isQuantity
            fuels
            regions
            limitsType
            balance
          }
          isActive
        }
      }
      userAccess {
        partnerParentId
        partnerId
        name
        role
      }
      departments {
        id
        name
        children {
          id
          name
          children {
            id
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DriversRefreshDriverPageQuery, DriversRefreshDriverPageQueryVariables>;
export const DriversAddDriverDocument = new TypedDocumentString(`
    mutation driversAddDriver($companyId: ID!, $driver: DriverData!) {
  addDriver(companyId: $companyId, data: $driver) {
    id
  }
}
    `) as unknown as TypedDocumentString<DriversAddDriverMutation, DriversAddDriverMutationVariables>;
export const GetDriverBalanceHistoryDocument = new TypedDocumentString(`
    query getDriverBalanceHistory($companyId: ID, $partnerId: ID!, $contractId: ID, $driverId: ID!, $filter: QueryParams!) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId, contractId: $contractId) {
      driver(id: $driverId, partnerId: $partnerId) {
        balanceHistory(filter: $filter) {
          items {
            total
            date
          }
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetDriverBalanceHistoryQuery, GetDriverBalanceHistoryQueryVariables>;
export const GetDriverExpensesDocument = new TypedDocumentString(`
    query getDriverExpenses($companyId: ID!, $partnerId: ID!, $driverId: ID!) {
  cabinet {
    company(id: $companyId) {
      driver(partnerId: $partnerId, id: $driverId) {
        limitsAndExpenses {
          limitsType
          isQuantity
          dayExpenses
          weekExpenses
          monthExpenses
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetDriverExpensesQuery, GetDriverExpensesQueryVariables>;
export const GetFaqDocument = new TypedDocumentString(`
    query getFAQ {
  faq {
    id
    question
    answer
    sorting
  }
}
    `) as unknown as TypedDocumentString<GetFaqQuery, GetFaqQueryVariables>;
export const AddFaqDocument = new TypedDocumentString(`
    mutation addFaq($question: String, $answer: String, $sorting: Float) {
  addFaq(question: $question, answer: $answer, sorting: $sorting) {
    id
  }
}
    `) as unknown as TypedDocumentString<AddFaqMutation, AddFaqMutationVariables>;
export const RemoveQuestionDocument = new TypedDocumentString(`
    mutation removeQuestion($id: String!) {
  removeFaq(id: $id) {
    id
  }
}
    `) as unknown as TypedDocumentString<RemoveQuestionMutation, RemoveQuestionMutationVariables>;
export const UpdateQuestionDocument = new TypedDocumentString(`
    mutation updateQuestion($id: String!, $question: String, $answer: String, $sorting: Float) {
  editFaq(id: $id, question: $question, answer: $answer, sorting: $sorting) {
    id
  }
}
    `) as unknown as TypedDocumentString<UpdateQuestionMutation, UpdateQuestionMutationVariables>;
export const GetStationsGroupsDocument = new TypedDocumentString(`
    query getStationsGroups($filter: StationsGroupQueryParams!) {
  cabinet {
    stationsGroups(filter: $filter) {
      items {
        id
        name
        description
      }
      count
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupsQuery, GetStationsGroupsQueryVariables>;
export const GetIndividualDiscountsGroupPageDocument = new TypedDocumentString(`
    query getIndividualDiscountsGroupPage($groupId: ID!) {
  cabinet {
    stationsGroup(id: $groupId) {
      name
      description
      stations(filter: {}) {
        items {
          id
          name
          address
          organizationName
        }
        count
      }
      discountsGroups(filter: {}) {
        items {
          contractId
          contractNumber
          organizationName
          fuels
          discounts
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetIndividualDiscountsGroupPageQuery, GetIndividualDiscountsGroupPageQueryVariables>;
export const GetStationsGroupStationsDocument = new TypedDocumentString(`
    query getStationsGroupStations($groupId: ID!, $filter: QueryParams!) {
  cabinet {
    stationsGroup(id: $groupId) {
      stations(filter: $filter) {
        items {
          id
          name
          address
          organizationName
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupStationsQuery, GetStationsGroupStationsQueryVariables>;
export const GetStationsGroupDiscountsDocument = new TypedDocumentString(`
    query getStationsGroupDiscounts($groupId: ID!, $filter: QueryParams!) {
  cabinet {
    stationsGroup(id: $groupId) {
      discountsGroups(filter: $filter) {
        items {
          contractId
          contractNumber
          organizationName
          fuels
          discounts
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupDiscountsQuery, GetStationsGroupDiscountsQueryVariables>;
export const GetStationsGroupFuelDiscountDocument = new TypedDocumentString(`
    query getStationsGroupFuelDiscount($groupId: ID!, $discountId: ID!) {
  cabinet {
    stationsGroup(id: $groupId) {
      contractDiscount(id: $discountId) {
        fuel
        discount
        startDate
        endDate
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupFuelDiscountQuery, GetStationsGroupFuelDiscountQueryVariables>;
export const GetStationsGroupContractDiscountsDocument = new TypedDocumentString(`
    query getStationsGroupContractDiscounts($groupId: ID!, $contractId: ID!) {
  cabinet {
    company(contractId: $contractId) {
      name
      contract {
        number
      }
    }
    stationsGroup(id: $groupId) {
      name
      contractDiscounts(contractId: $contractId) {
        items {
          id
          fuel
          discount
          startDate
          endDate
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupContractDiscountsQuery, GetStationsGroupContractDiscountsQueryVariables>;
export const GetStationsGroupNameAndDescriptionDocument = new TypedDocumentString(`
    query getStationsGroupNameAndDescription($groupId: ID!) {
  cabinet {
    stationsGroup(id: $groupId) {
      name
      description
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationsGroupNameAndDescriptionQuery, GetStationsGroupNameAndDescriptionQueryVariables>;
export const AddStationsGroupDocument = new TypedDocumentString(`
    mutation addStationsGroup($name: String!, $description: String!) {
  addStationsGroup(name: $name, description: $description)
}
    `) as unknown as TypedDocumentString<AddStationsGroupMutation, AddStationsGroupMutationVariables>;
export const EditStationsGroupDocument = new TypedDocumentString(`
    mutation editStationsGroup($id: ID!, $name: String!, $description: String!) {
  editStationsGroup(id: $id, name: $name, description: $description)
}
    `) as unknown as TypedDocumentString<EditStationsGroupMutation, EditStationsGroupMutationVariables>;
export const AddCorpClientStationsGroupFuelDiscountsDocument = new TypedDocumentString(`
    mutation addCorpClientStationsGroupFuelDiscounts($groupId: ID!, $contractId: ID!, $discount: Float!, $fuelsIds: [Int!]!, $startDate: DateTime, $endDate: DateTime) {
  addCorpClientStationsGroupFuelDiscounts(
    groupId: $groupId
    contractId: $contractId
    fuelsIds: $fuelsIds
    discount: $discount
    startDate: $startDate
    endDate: $endDate
  )
}
    `) as unknown as TypedDocumentString<AddCorpClientStationsGroupFuelDiscountsMutation, AddCorpClientStationsGroupFuelDiscountsMutationVariables>;
export const EditCorpClientStationsGroupFuelDiscountDocument = new TypedDocumentString(`
    mutation editCorpClientStationsGroupFuelDiscount($discountId: ID!, $discount: Float!, $startDate: DateTime, $endDate: DateTime) {
  editCorpClientStationsGroupFuelDiscount(
    discountId: $discountId
    discount: $discount
    startDate: $startDate
    endDate: $endDate
  )
}
    `) as unknown as TypedDocumentString<EditCorpClientStationsGroupFuelDiscountMutation, EditCorpClientStationsGroupFuelDiscountMutationVariables>;
export const DeleteStationsGroupStationsDocument = new TypedDocumentString(`
    mutation deleteStationsGroupStations($id: ID!) {
  deleteStationsGroupStations(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteStationsGroupStationsMutation, DeleteStationsGroupStationsMutationVariables>;
export const DeleteStationsGroupStationDocument = new TypedDocumentString(`
    mutation deleteStationsGroupStation($groupId: ID!, $stationId: ID!) {
  deleteStationsGroupStation(groupId: $groupId, stationId: $stationId)
}
    `) as unknown as TypedDocumentString<DeleteStationsGroupStationMutation, DeleteStationsGroupStationMutationVariables>;
export const DeleteStationsGroupFuelDiscountsDocument = new TypedDocumentString(`
    mutation deleteStationsGroupFuelDiscounts($id: ID!) {
  deleteStationsGroupFuelDiscounts(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteStationsGroupFuelDiscountsMutation, DeleteStationsGroupFuelDiscountsMutationVariables>;
export const DeleteStationsGroupContractFuelDiscountsDocument = new TypedDocumentString(`
    mutation deleteStationsGroupContractFuelDiscounts($groupId: ID!, $contractId: ID!) {
  deleteStationsGroupContractFuelDiscounts(
    groupId: $groupId
    contractId: $contractId
  )
}
    `) as unknown as TypedDocumentString<DeleteStationsGroupContractFuelDiscountsMutation, DeleteStationsGroupContractFuelDiscountsMutationVariables>;
export const DeleteStationsGroupFuelDiscountDocument = new TypedDocumentString(`
    mutation deleteStationsGroupFuelDiscount($id: ID!) {
  deleteStationsGroupFuelDiscount(id: $id)
}
    `) as unknown as TypedDocumentString<DeleteStationsGroupFuelDiscountMutation, DeleteStationsGroupFuelDiscountMutationVariables>;
export const MapsFetchStationsDocument = new TypedDocumentString(`
    query mapsFetchStations {
  stations {
    id
    name
    address
    point
    prices {
      fuel {
        code
      }
      price
    }
  }
}
    `) as unknown as TypedDocumentString<MapsFetchStationsQuery, MapsFetchStationsQueryVariables>;
export const MapsFetchFindStationsDocument = new TypedDocumentString(`
    query MapsFetchFindStations($query: String) {
  stationsByES(query: $query, size: 5) {
    items {
      id
      name
      address
    }
  }
}
    `) as unknown as TypedDocumentString<MapsFetchFindStationsQuery, MapsFetchFindStationsQueryVariables>;
export const MapsFetchStationPointDocument = new TypedDocumentString(`
    query MapsFetchStationPoint($id: ID!) {
  station(id: $id) {
    point
  }
}
    `) as unknown as TypedDocumentString<MapsFetchStationPointQuery, MapsFetchStationPointQueryVariables>;
export const FetchOfflineCompanySettingsAndCatalogDocument = new TypedDocumentString(`
    query FetchOfflineCompanySettingsAndCatalog($companyId: ID!, $partnerId: ID!) {
  productCatalog {
    groupId
    groupName
    products {
      productId
      productName
    }
  }
  cabinet {
    company(id: $companyId) {
      ... on AzsCompany {
        settings(partnerId: $partnerId) {
          osnovans
        }
        productCatalog(partnerId: $partnerId) {
          groupId
          groupName
          parentGroupId
          discount
          internalId
          products {
            productId
            productName
            discount
            internalId
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FetchOfflineCompanySettingsAndCatalogQuery, FetchOfflineCompanySettingsAndCatalogQueryVariables>;
export const OfflineSaveCompanySettingsAndCatalogDocument = new TypedDocumentString(`
    mutation OfflineSaveCompanySettingsAndCatalog($companyId: ID!, $data: CompanyData!, $partnerId: ID!) {
  saveCompany(companyId: $companyId, data: $data, partnerId: $partnerId) {
    id
  }
}
    `) as unknown as TypedDocumentString<OfflineSaveCompanySettingsAndCatalogMutation, OfflineSaveCompanySettingsAndCatalogMutationVariables>;
export const CreateOfflinePartnerDocument = new TypedDocumentString(`
    mutation CreateOfflinePartner($contract: String!, $firmId: String!, $name: String!, $organization: ID!, $osnovans: [Float!]) {
  createOfflinePartner(
    organization: $organization
    contract: $contract
    firmId: $firmId
    name: $name
    osnovans: $osnovans
  )
}
    `) as unknown as TypedDocumentString<CreateOfflinePartnerMutation, CreateOfflinePartnerMutationVariables>;
export const AddOfflineStationDocument = new TypedDocumentString(`
    mutation AddOfflineStation($partnerId: ID!, $stationData: NewOfflineStationData!) {
  addOfflineStation(partnerId: $partnerId, stationData: $stationData) {
    id
  }
}
    `) as unknown as TypedDocumentString<AddOfflineStationMutation, AddOfflineStationMutationVariables>;
export const GetOfflineTransactionsPageDocument = new TypedDocumentString(`
    query GetOfflineTransactionsPage($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          date
          station {
            address
          }
          status
          statusMessage
          ... on OfflineOrder {
            owner {
              name
              shortName
            }
            cardNumber
            items {
              id
              type
              quantity
              groupName
              shortName
              prices {
                corp
                fact
                user
                station
              }
              cost {
                corp
                fact
                user
                station
              }
            }
          }
        }
        summary {
          name
          count
          quantity
          total
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetOfflineTransactionsPageQuery, GetOfflineTransactionsPageQueryVariables>;
export const GetOfflineTransactionsDownloadLinkDocument = new TypedDocumentString(`
    query GetOfflineTransactionsDownloadLink($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      ordersNewReportLink(filter: $filter, format: excel)
    }
  }
}
    `) as unknown as TypedDocumentString<GetOfflineTransactionsDownloadLinkQuery, GetOfflineTransactionsDownloadLinkQueryVariables>;
export const GetOfflineOrderDocument = new TypedDocumentString(`
    query GetOfflineOrder($companyId: ID, $contractId: ID, $orderId: ID!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      orderNew(id: $orderId) {
        id
        date
        station {
          id
          name
          address
          organizationName
        }
        status
        statusMessage
        ... on OfflineOrder {
          mps
          owner {
            name
            shortName
          }
          items {
            id
            type
            quantityReq
            quantityReport
            groupName
            shortName
            prices {
              corp
              fact
              user
              station
            }
            cost {
              corp
              fact
              user
              station
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetOfflineOrderQuery, GetOfflineOrderQueryVariables>;
export const OrdersGetOrderDataDocument = new TypedDocumentString(`
    query ordersGetOrderData($fuelUpCompanyId: ID!, $orderId: ID!) {
  cabinet {
    company(id: $fuelUpCompanyId) {
      orderNew(id: $orderId) {
        ... on OnlineOrder {
          station {
            id
            name
            address
          }
          sberSpasiboDetails {
            credit
          }
          item {
            fuel {
              id
              name
            }
            quantityReport
            quantityReq
            costReport {
              fact
              station
              corp
              user
            }
            prices {
              fact
              station
              corp
            }
            discount {
              station
              corp
            }
          }
          corp {
            car {
              id
              number
            }
            driver {
              id
            }
            company {
              id
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OrdersGetOrderDataQuery, OrdersGetOrderDataQueryVariables>;
export const OrdersModifyOrderDocument = new TypedDocumentString(`
    mutation ordersModifyOrder($orderId: ID!, $volume: Float, $discountCorp: Float, $discountStation: Float, $carId: ID, $fuelId: Int, $stationId: ID, $costPromotion: Float, $commentary: String!) {
  modifyOrder(
    id: $orderId
    volume: $volume
    discountCorp: $discountCorp
    discountStation: $discountStation
    carId: $carId
    fuelId: $fuelId
    stationId: $stationId
    costPromotion: $costPromotion
    commentary: $commentary
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<OrdersModifyOrderMutation, OrdersModifyOrderMutationVariables>;
export const GetPaymentsDocument = new TypedDocumentString(`
    query GetPayments($companyId: ID!, $partnerId: ID, $filter: PaymentsQueryParams) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      payments {
        balance
        needMoney
        count
        cards {
          id
          name
          provider {
            id
            name
          }
        }
        items(filter: $filter) {
          id
          amount
          type
          status
          statusDescription
          transactionId
          provider {
            name
          }
          createdAt
          balance {
            amount
            description
          }
          ... on OnlinePayment {
            pan
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetPaymentsQuery, GetPaymentsQueryVariables>;
export const GetPaymentProvidersDocument = new TypedDocumentString(`
    query GetPaymentProviders($companyId: ID) {
  paymentProviders(companyId: $companyId) {
    id
    name
    service
    type
  }
}
    `) as unknown as TypedDocumentString<GetPaymentProvidersQuery, GetPaymentProvidersQueryVariables>;
export const CreatePaymentDocument = new TypedDocumentString(`
    mutation CreatePayment($contractId: ID!, $providerId: ID!, $cardId: ID, $amount: Float!) {
  createPayment(
    contractId: $contractId
    providerId: $providerId
    cardId: $cardId
    amount: $amount
  ) {
    id
    error
    ... on InvoicePaymentResponse {
      url
      number
    }
    ... on OnlinePaymentResponse {
      url
      auto
    }
    ... on SberInvoicePaymentResponse {
      url
    }
  }
}
    `) as unknown as TypedDocumentString<CreatePaymentMutation, CreatePaymentMutationVariables>;
export const GetMonthlyReportLinkDocument = new TypedDocumentString(`
    query getMonthlyReportLink($id: ID!, $month: String!) {
  cabinet {
    company(id: $id) {
      monthlyReportLink(month: $month)
    }
  }
}
    `) as unknown as TypedDocumentString<GetMonthlyReportLinkQuery, GetMonthlyReportLinkQueryVariables>;
export const StationsGetStationPageDocument = new TypedDocumentString(`
    query stationsGetStationPage($companyId: ID, $contractId: ID, $stationId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      id
      name
      station(id: $stationId) {
        name
        status
        address
        isActive
        integration {
          login
          password
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationPageQuery, StationsGetStationPageQueryVariables>;
export const AdminGetStationPageDocument = new TypedDocumentString(`
    query adminGetStationPage($companyId: ID, $contractId: ID, $stationId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      id
      name
      station(id: $stationId) {
        name
        status
        address
        isActive
        lastOnline
        integration {
          login
          password
        }
        routeTarget {
          id
          name
        }
      }
      ... on AzsCompany {
        stationPartner {
          system {
            isPing
          }
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
            car {
              number
            }
          }
          station {
            name
            address
          }
          payment {
            type
            source
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetStationPageQuery, AdminGetStationPageQueryVariables>;
export const GetStationDataDocument = new TypedDocumentString(`
    query getStationData($companyId: ID!, $stationId: ID!) {
  cabinet {
    company(id: $companyId) {
      station(id: $stationId) {
        name
        promo
        address
        color
        point
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationDataQuery, GetStationDataQueryVariables>;
export const StationsRefreshStationPageDocument = new TypedDocumentString(`
    query stationsRefreshStationPage($companyId: ID, $stationId: ID!) {
  cabinet {
    company(id: $companyId) {
      id
      name
      station(id: $stationId) {
        name
        status
        address
        isActive
        integration {
          login
          password
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsRefreshStationPageQuery, StationsRefreshStationPageQueryVariables>;
export const StationsGetStationOrdersDocument = new TypedDocumentString(`
    query stationsGetStationOrders($companyId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          corp {
            driver {
              name
              phone
            }
          }
          station {
            name
            address
          }
          payment {
            type
            source
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationOrdersQuery, StationsGetStationOrdersQueryVariables>;
export const StationsGetStationCoordsDocument = new TypedDocumentString(`
    query stationsGetStationCoords($stationId: ID!) {
  station(id: $stationId) {
    name
    point
    address
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationCoordsQuery, StationsGetStationCoordsQueryVariables>;
export const StationsGetStationPricesDocument = new TypedDocumentString(`
    query stationsGetStationPrices($stationId: ID!) {
  station(id: $stationId) {
    prices {
      fuel {
        shortName
      }
      pumps
      price
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationPricesQuery, StationsGetStationPricesQueryVariables>;
export const StationsGetStationPricesDiscountsDocument = new TypedDocumentString(`
    query stationsGetStationPricesDiscounts($companyId: ID!, $stationId: ID!) {
  cabinet {
    company(id: $companyId) {
      station(id: $stationId) {
        prices {
          fuel {
            id
            shortName
          }
          pumps
          price
        }
        stationFuelDiscounts {
          id
          fuel
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationPricesDiscountsQuery, StationsGetStationPricesDiscountsQueryVariables>;
export const SetStationDiscountPriceDocument = new TypedDocumentString(`
    mutation setStationDiscountPrice($discountId: ID, $stationId: ID!, $fuelId: ID, $discount: Float!) {
  setStationFuelDiscount(
    discountId: $discountId
    stationId: $stationId
    fuelId: $fuelId
    discount: $discount
  )
}
    `) as unknown as TypedDocumentString<SetStationDiscountPriceMutation, SetStationDiscountPriceMutationVariables>;
export const AddCompanyStationDocument = new TypedDocumentString(`
    mutation AddCompanyStation($companyId: ID!, $data: NewStationData!) {
  addStation(companyId: $companyId, stationData: $data) {
    id
  }
}
    `) as unknown as TypedDocumentString<AddCompanyStationMutation, AddCompanyStationMutationVariables>;
export const EditCompanyStationDocument = new TypedDocumentString(`
    mutation EditCompanyStation($stationId: ID!, $data: EditStationData!) {
  editStation(stationId: $stationId, stationData: $data) {
    id
  }
}
    `) as unknown as TypedDocumentString<EditCompanyStationMutation, EditCompanyStationMutationVariables>;
export const BulkEditCompanyStationsDocument = new TypedDocumentString(`
    mutation BulkEditCompanyStations($companyId: ID!, $data: BulkEditStationsData!) {
  bulkEditStations(companyId: $companyId, stationsData: $data) {
    id
  }
}
    `) as unknown as TypedDocumentString<BulkEditCompanyStationsMutation, BulkEditCompanyStationsMutationVariables>;
export const GetStationCompanyIdDocument = new TypedDocumentString(`
    query getStationCompanyId($stationId: ID!) {
  station(id: $stationId) {
    organizationId
  }
}
    `) as unknown as TypedDocumentString<GetStationCompanyIdQuery, GetStationCompanyIdQueryVariables>;
export const AddColorDocument = new TypedDocumentString(`
    mutation AddColor($name: String!, $color: String!) {
  addColor(name: $name, color: $color) {
    id
  }
}
    `) as unknown as TypedDocumentString<AddColorMutation, AddColorMutationVariables>;
export const DownloadStationsIntegrationsDocument = new TypedDocumentString(`
    query DownloadStationsIntegrations($companyId: ID) {
  cabinet {
    company(id: $companyId) {
      integrationsReportLink
    }
  }
}
    `) as unknown as TypedDocumentString<DownloadStationsIntegrationsQuery, DownloadStationsIntegrationsQueryVariables>;
export const GetOfflineStationPageDocument = new TypedDocumentString(`
    query GetOfflineStationPage($contractId: ID!, $stationId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(contractId: $contractId) {
      station(id: $stationId) {
        name
        address
        integration {
          login
          password
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          date
          station {
            address
          }
          status
          statusMessage
          ... on OfflineOrder {
            owner {
              name
              shortName
            }
            cardNumber
            items {
              id
              type
              quantity
              groupName
              shortName
              prices {
                corp
                fact
                user
                station
              }
              cost {
                corp
                fact
                user
                station
              }
            }
          }
        }
        summary {
          name
          count
          quantity
          total
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetOfflineStationPageQuery, GetOfflineStationPageQueryVariables>;
export const StationsFetchStationsListDocument = new TypedDocumentString(`
    query StationsFetchStationsList($size: Int!, $offset: Int!, $query: String) {
  stationsByES(size: $size, offset: $offset, query: $query) {
    count
    items {
      id
      name
      address
    }
  }
}
    `) as unknown as TypedDocumentString<StationsFetchStationsListQuery, StationsFetchStationsListQueryVariables>;
export const StationsGetStationsPageDocument = new TypedDocumentString(`
    query StationsGetStationsPage($companyId: ID!, $stationId: ID!, $filter: OrdersQueryParams!) {
  station(id: $stationId) {
    name
    address
  }
  cabinet {
    company(id: $companyId) {
      ordersNew(filter: $filter) {
        count
        summary {
          name
          count
          total
          discount
          quantity
        }
        items {
          id
          date
          status
          statusMessage
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationsPageQuery, StationsGetStationsPageQueryVariables>;
export const StationsUpdateStationInfoAndTransactionsDocument = new TypedDocumentString(`
    query StationsUpdateStationInfoAndTransactions($companyId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      ordersNew(filter: $filter) {
        count
        summary {
          name
          count
          total
          discount
          quantity
        }
        items {
          id
          date
          status
          statusMessage
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsUpdateStationInfoAndTransactionsQuery, StationsUpdateStationInfoAndTransactionsQueryVariables>;
export const StationsAddAsuDocument = new TypedDocumentString(`
    mutation stationsAddAsu($data: NewStationSystemData!) {
  addStationSystem(data: $data) {
    id
  }
}
    `) as unknown as TypedDocumentString<StationsAddAsuMutation, StationsAddAsuMutationVariables>;
export const StationsFetchStationIntegrationTabDocument = new TypedDocumentString(`
    query StationsFetchStationIntegrationTab($id: ID) {
  cabinet {
    company(id: $id) {
      ... on AzsCompany {
        stationPartner {
          id
          name
          outgoing
          apiType
          apiKey
          system {
            id
            name
            protocol
            isPing
          }
        }
        stationPartnerFuels {
          partnerFuelId
          fuelId
          name
          ename
        }
      }
    }
    serverAsu
  }
  systems {
    id
    name
    protocol
    isPing
  }
  fuel {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<StationsFetchStationIntegrationTabQuery, StationsFetchStationIntegrationTabQueryVariables>;
export const StationsSaveStationIntegrationDocument = new TypedDocumentString(`
    mutation StationsSaveStationIntegration($companyId: ID!, $companyData: CompanyData!, $stationData: StationSystemData!) {
  editStationSystem(data: $stationData) {
    id
  }
  saveCompany(companyId: $companyId, data: $companyData) {
    id
  }
}
    `) as unknown as TypedDocumentString<StationsSaveStationIntegrationMutation, StationsSaveStationIntegrationMutationVariables>;
export const StationsUpdatePartnerStationsDocument = new TypedDocumentString(`
    mutation StationsUpdatePartnerStations($companyId: ID!) {
  updatePartnerStations(companyId: $companyId)
}
    `) as unknown as TypedDocumentString<StationsUpdatePartnerStationsMutation, StationsUpdatePartnerStationsMutationVariables>;
export const StationsIndexStationsDocument = new TypedDocumentString(`
    mutation StationsIndexStations($stationId: ID) {
  indexStations(id: $stationId)
}
    `) as unknown as TypedDocumentString<StationsIndexStationsMutation, StationsIndexStationsMutationVariables>;
export const GetAzsCompanyStationsDocument = new TypedDocumentString(`
    query GetAzsCompanyStations($companyId: ID!, $contractsType: String!, $page: Int, $size: Int, $query: String, $status: StationStatus) {
  cabinet {
    company(id: $companyId) {
      stations(
        contractsType: $contractsType
        page: $page
        size: $size
        query: $query
        status: $status
      ) {
        count
        items {
          id
          name
          address
          lastOnline
          status
        }
        status {
          status
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetAzsCompanyStationsQuery, GetAzsCompanyStationsQueryVariables>;
export const GetCompanyStationsForStationsGroupDocument = new TypedDocumentString(`
    query getCompanyStationsForStationsGroup($companyId: ID!, $page: Int, $size: Int, $query: String) {
  cabinet {
    company(id: $companyId) {
      stations(page: $page, size: $size, query: $query) {
        items {
          id
          name
          nameApi
          address
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetCompanyStationsForStationsGroupQuery, GetCompanyStationsForStationsGroupQueryVariables>;
export const AddStationsToStationsGroupDocument = new TypedDocumentString(`
    mutation addStationsToStationsGroup($groupId: ID!, $stationsIds: [String!], $companyId: ID, $query: String) {
  addStationsToStationsGroup(
    groupId: $groupId
    stationsIds: $stationsIds
    companyId: $companyId
    query: $query
  )
}
    `) as unknown as TypedDocumentString<AddStationsToStationsGroupMutation, AddStationsToStationsGroupMutationVariables>;
export const StationsGetCompanyStationsDocument = new TypedDocumentString(`
    query stationsGetCompanyStations($companyId: ID!, $query: String) {
  cabinet {
    company(id: $companyId) {
      stations(query: $query) {
        items {
          id
          name
          address
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetCompanyStationsQuery, StationsGetCompanyStationsQueryVariables>;
export const StationsGetStationsDocument = new TypedDocumentString(`
    query stationsGetStations {
  stationsByES(size: 10000) {
    items {
      id
      name
      address
      point
      prices {
        fuel {
          code
        }
        price
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationsQuery, StationsGetStationsQueryVariables>;
export const StationsGetMapStationsDocument = new TypedDocumentString(`
    query stationsGetMapStations {
  stationsByES(size: 10000) {
    items {
      id
      point
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetMapStationsQuery, StationsGetMapStationsQueryVariables>;
export const StationsGetStationsWithDiscountDocument = new TypedDocumentString(`
    query stationsGetStationsWithDiscount($contractId: ID!) {
  stationsWithDiscount(contractId: $contractId)
}
    `) as unknown as TypedDocumentString<StationsGetStationsWithDiscountQuery, StationsGetStationsWithDiscountQueryVariables>;
export const StationsGetMapStationDocument = new TypedDocumentString(`
    query stationsGetMapStation($id: ID!) {
  station(id: $id) {
    name
    address
    prices {
      fuel {
        code
      }
      price
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetMapStationQuery, StationsGetMapStationQueryVariables>;
export const StationsSetStationStateDocument = new TypedDocumentString(`
    mutation stationsSetStationState($id: ID!, $state: StationState!, $commentary: String!) {
  setStationState(id: $id, state: $state, commentary: $commentary) {
    result
    error
  }
}
    `) as unknown as TypedDocumentString<StationsSetStationStateMutation, StationsSetStationStateMutationVariables>;
export const StationsBulkSetStationStateDocument = new TypedDocumentString(`
    mutation stationsBulkSetStationState($companyId: ID!, $query: String, $status: StationStatus, $region: String, $commentary: String!, $oldState: [StationState!]!, $newState: StationState!) {
  bulkSetStationsState(
    companyId: $companyId
    query: $query
    status: $status
    region: $region
    oldState: $oldState
    newState: $newState
    commentary: $commentary
  ) {
    dataError
    pumpsError {
      name
      address
    }
  }
}
    `) as unknown as TypedDocumentString<StationsBulkSetStationStateMutation, StationsBulkSetStationStateMutationVariables>;
export const BulkSetStationsStateByGroupIdDocument = new TypedDocumentString(`
    mutation bulkSetStationsStateByGroupId($groupId: ID!, $state: StationState!, $commentary: String!) {
  bulkSetStationsStateByGroupId(
    groupId: $groupId
    state: $state
    commentary: $commentary
  )
}
    `) as unknown as TypedDocumentString<BulkSetStationsStateByGroupIdMutation, BulkSetStationsStateByGroupIdMutationVariables>;
export const StationsStateLogsGroupsDocument = new TypedDocumentString(`
    query stationsStateLogsGroups($companyId: ID!, $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      stationsStateLogsGroups(filter: {page: $page, size: $size}) {
        items {
          id
          date
          state
          email
          commentary
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsStateLogsGroupsQuery, StationsStateLogsGroupsQueryVariables>;
export const StationsGetStationStateLogsDocument = new TypedDocumentString(`
    query stationsGetStationStateLogs($companyId: ID!, $stationId: ID!, $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      station(id: $stationId) {
        stateLogs(filter: {page: $page, size: $size}) {
          items {
            date
            user
            state
            commentary
          }
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<StationsGetStationStateLogsQuery, StationsGetStationStateLogsQueryVariables>;
export const CopyStationsDocument = new TypedDocumentString(`
    mutation copyStations($companyId: ID!, $ids: [ID!]!) {
  copyStations(ids: $ids, companyId: $companyId)
}
    `) as unknown as TypedDocumentString<CopyStationsMutation, CopyStationsMutationVariables>;
export const GetUpdatedStationsDocument = new TypedDocumentString(`
    query getUpdatedStations($id: ID!, $filter: QueryParams!) {
  cabinet {
    company(id: $id) {
      updatedStations(filter: $filter) {
        count
        items {
          id
          name
          nameApi
          address
          addressApi
          organizationName
          lng
          lngApi
          lat
          latApi
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetUpdatedStationsQuery, GetUpdatedStationsQueryVariables>;
export const TransferStationsToAnotherCompanyDocument = new TypedDocumentString(`
    mutation transferStationsToAnotherCompany($companyId: ID!, $newCompanyId: String!, $selectedStationIds: [String!]!, $isAllSelected: Boolean!) {
  transferStations(
    companyId: $companyId
    newCompanyId: $newCompanyId
    selectedStationIds: $selectedStationIds
    isAllSelected: $isAllSelected
  )
}
    `) as unknown as TypedDocumentString<TransferStationsToAnotherCompanyMutation, TransferStationsToAnotherCompanyMutationVariables>;
export const GetStationDataToEditDocument = new TypedDocumentString(`
    query getStationDataToEdit($companyId: ID!, $stationId: ID!) {
  cabinet {
    company(id: $companyId) {
      station(id: $stationId) {
        name
        brand
        address
        region
        promo
        color
        point
        mode {
          type
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetStationDataToEditQuery, GetStationDataToEditQueryVariables>;
export const DownloadStationsInfoDocument = new TypedDocumentString(`
    query DownloadStationsInfo($companyId: ID, $query: String, $state: [StationState!]!, $status: StationStatus, $region: String) {
  cabinet {
    company(id: $companyId) {
      stationsInfoReportLink(
        query: $query
        state: $state
        status: $status
        region: $region
      )
    }
  }
}
    `) as unknown as TypedDocumentString<DownloadStationsInfoQuery, DownloadStationsInfoQueryVariables>;
export const GetInternalOrdersDocument = new TypedDocumentString(`
    query getInternalOrders($companyId: ID, $contractId: ID, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, contractId: $contractId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          payment {
            type
            source
          }
          corp {
            company {
              name
            }
            driver {
              name
              phone
            }
            car {
              number
            }
            waybill {
              number
            }
          }
          station {
            name
            address
          }
          sberSpasiboDetails {
            subId
            costPromotion
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
          ... on OfflineOrder {
            cardNumber
            bankProduct
            items {
              id
              type
              quantityReq
              quantityReport
              groupName
              shortName
              prices {
                corp
                fact
                user
                station
              }
              cost {
                corp
                fact
                user
                station
              }
            }
          }
        }
        summary {
          name
          count
          quantity
          total
          discount
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetInternalOrdersQuery, GetInternalOrdersQueryVariables>;
export const GetInternalOrderDocument = new TypedDocumentString(`
    query getInternalOrder($companyId: ID!, $orderId: ID!) {
  cabinet {
    company(id: $companyId) {
      orderNew(id: $orderId) {
        id
        date
        finished
        payment {
          id
          type
          source
        }
        station {
          id
          name
          mode {
            type
          }
          address
          contractId
          organizationId
        }
        corp {
          company {
            id
            name
          }
          driver {
            id
            name
            phone
            partnerId
          }
          car {
            id
            number
          }
          waybill {
            number
            validSince
            validTo
            limit
          }
        }
        user {
          id
          phone
        }
        sberId
        sberSpasiboDetails {
          oid
          subId
          status
          debit
          credit
          refund
          costPromotion
        }
        ... on OnlineOrder {
          stationOrderId
          bankReserveId
          item {
            pump
            fuel {
              name
            }
            quantityReq
            quantityReport
            costReport {
              corp
              fact
              user
              station
            }
            prices {
              corp
              fact
              user
              station
            }
            costReq {
              corp
              fact
              user
              station
            }
            refund {
              corp
              fact
              user
              station
              quantity
            }
          }
        }
      }
      orderDetails(id: $orderId) {
        time
        params
        details
        status
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetInternalOrderQuery, GetInternalOrderQueryVariables>;
export const SupportFetchDriversTabDocument = new TypedDocumentString(`
    query SupportFetchDriversTab($companyId: ID!, $status: DriverStatus, $query: String, $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      drivers(status: $status, query: $query, page: $page, size: $size) {
        activeCount
        totalCount
        items {
          id
          created
          name
          phone
          partnerId
          partnerName
          partnerParentName
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportFetchDriversTabQuery, SupportFetchDriversTabQueryVariables>;
export const SupportRefetchDriversTabDocument = new TypedDocumentString(`
    query SupportRefetchDriversTab($companyId: ID!, $status: DriverStatus, $query: String, $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      drivers(status: $status, query: $query, page: $page, size: $size) {
        items {
          id
          created
          name
          phone
          partnerId
          partnerName
          partnerParentName
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportRefetchDriversTabQuery, SupportRefetchDriversTabQueryVariables>;
export const AdminGetApiUsersDocument = new TypedDocumentString(`
    query adminGetApiUsers($companyId: ID!, $query: String, $page: Int!, $size: Int!) {
  cabinet {
    company(id: $companyId) {
      apiUsers(query: $query, page: $page, size: $size) {
        count
        items {
          id
          phone
          ... on ApiUser {
            hasSberLoyalty
            registered
            email
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdminGetApiUsersQuery, AdminGetApiUsersQueryVariables>;
export const SupportFetchUserPageDocument = new TypedDocumentString(`
    query SupportFetchUserPage($companyId: ID!, $userId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      apiUser(id: $userId) {
        id
        email
        phone
        state
        registered
        version {
          os
          osVersion
          appType
          appVersion
        }
        sberLoyaltyBalance
        lastActivity
        drivers {
          id
          companyId
          companyName
          companyReportType
          partnerId
          partnerName
          limitsAndExpenses {
            limitsType
            balance
            blocked
            day
            week
            month
            dayExpenses
            weekExpenses
            monthExpenses
            isQuantity
            fuels
            regions
          }
          car {
            id
            number
          }
          isActive
        }
      }
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          payment {
            type
            source
          }
          corp {
            car {
              number
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportFetchUserPageQuery, SupportFetchUserPageQueryVariables>;
export const SupportGetUserOrdersDocument = new TypedDocumentString(`
    query supportGetUserOrders($companyId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId) {
      ordersNew(filter: $filter) {
        count
        items {
          id
          type
          date
          status
          statusMessage
          user {
            phone
          }
          payment {
            type
            source
          }
          corp {
            car {
              number
            }
          }
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportGetUserOrdersQuery, SupportGetUserOrdersQueryVariables>;
export const GetMonitoringTabDocument = new TypedDocumentString(`
    query getMonitoringTab($status: StationStatus, $query: String, $offset: Int, $size: Int, $state: [StationState!], $sort: StationsSort, $sortDir: SortDirection) {
  stationsByES(
    point: [0, 0]
    status: $status
    query: $query
    state: $state
    offset: $offset
    size: $size
    sort: $sort
    sortDir: $sortDir
  ) {
    count
    status {
      status
      count
    }
    items {
      id
      name
      address
      lastOnline
      organizationName
      organizationId
      stationName
      state
      status
      stateDetails {
        date
        email
        commentary
      }
      acs
    }
  }
}
    `) as unknown as TypedDocumentString<GetMonitoringTabQuery, GetMonitoringTabQueryVariables>;
export const SupportRequestUserRestorePasswordEmailDocument = new TypedDocumentString(`
    mutation SupportRequestUserRestorePasswordEmail($companyId: ID!, $userId: ID!, $referer: String!) {
  result: sendRestoreUserPasswordEmail(
    companyId: $companyId
    id: $userId
    referer: $referer
  )
}
    `) as unknown as TypedDocumentString<SupportRequestUserRestorePasswordEmailMutation, SupportRequestUserRestorePasswordEmailMutationVariables>;
export const SupportDismissOrderDocument = new TypedDocumentString(`
    mutation supportDismissOrder($orderId: ID!, $volume: Float, $commentary: String!, $partial: Boolean) {
  dismissOrder(
    id: $orderId
    volume: $volume
    commentary: $commentary
    partial: $partial
  ) {
    id
  }
}
    `) as unknown as TypedDocumentString<SupportDismissOrderMutation, SupportDismissOrderMutationVariables>;
export const SupportDismissOrderToIncomeDocument = new TypedDocumentString(`
    mutation supportDismissOrderToIncome($orderId: ID!, $volume: Float, $commentary: String!) {
  dismissOrderToIncome(id: $orderId, volume: $volume, commentary: $commentary) {
    id
  }
}
    `) as unknown as TypedDocumentString<SupportDismissOrderToIncomeMutation, SupportDismissOrderToIncomeMutationVariables>;
export const SupportRefundOrderDocument = new TypedDocumentString(`
    mutation supportRefundOrder($orderId: ID!, $volume: Float!, $commentary: String!) {
  refundOrder(id: $orderId, volume: $volume, commentary: $commentary) {
    id
  }
}
    `) as unknown as TypedDocumentString<SupportRefundOrderMutation, SupportRefundOrderMutationVariables>;
export const SupportUndoLossDocument = new TypedDocumentString(`
    mutation supportUndoLoss($orderId: ID!, $companyId: ID!, $commentary: String!) {
  undoLoss(id: $orderId, companyId: $companyId, commentary: $commentary) {
    id
    status
    message
  }
}
    `) as unknown as TypedDocumentString<SupportUndoLossMutation, SupportUndoLossMutationVariables>;
export const SupportCancelOrderDocument = new TypedDocumentString(`
    mutation SupportCancelOrder($orderId: ID!, $commentary: String!) {
  cancelOrder(id: $orderId, commentary: $commentary) {
    id
  }
}
    `) as unknown as TypedDocumentString<SupportCancelOrderMutation, SupportCancelOrderMutationVariables>;
export const SupportCloseOrderDocument = new TypedDocumentString(`
    mutation SupportCloseOrder($orderId: ID!, $volume: Float!, $commentary: String!) {
  closeOrder(id: $orderId, volume: $volume, commentary: $commentary) {
    id
  }
}
    `) as unknown as TypedDocumentString<SupportCloseOrderMutation, SupportCloseOrderMutationVariables>;
export const SupportGetScriptsDocument = new TypedDocumentString(`
    query supportGetScripts {
  scripts {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<SupportGetScriptsQuery, SupportGetScriptsQueryVariables>;
export const SupportGetScriptByIdDocument = new TypedDocumentString(`
    query supportGetScriptById($id: Int!) {
  script(id: $id) {
    name
    args
    entry
    preview
  }
}
    `) as unknown as TypedDocumentString<SupportGetScriptByIdQuery, SupportGetScriptByIdQueryVariables>;
export const SupportCreateScriptRunDocument = new TypedDocumentString(`
    mutation supportCreateScriptRun($id: Int!, $params: String!) {
  createScriptRun(id: $id, params: $params) {
    status
    data
  }
}
    `) as unknown as TypedDocumentString<SupportCreateScriptRunMutation, SupportCreateScriptRunMutationVariables>;
export const SupportPreviewScriptRunDocument = new TypedDocumentString(`
    mutation supportPreviewScriptRun($id: Int!, $params: String!) {
  previewScriptRun(id: $id, params: $params)
}
    `) as unknown as TypedDocumentString<SupportPreviewScriptRunMutation, SupportPreviewScriptRunMutationVariables>;
export const SupportExecuteScriptRunDocument = new TypedDocumentString(`
    mutation supportExecuteScriptRun($id: Int!) {
  executeScriptRun(id: $id) {
    status
    data
  }
}
    `) as unknown as TypedDocumentString<SupportExecuteScriptRunMutation, SupportExecuteScriptRunMutationVariables>;
export const SupportGetRunsDocument = new TypedDocumentString(`
    query supportGetRuns($page: Int, $size: Int) {
  runs(page: $page, size: $size) {
    count
    items {
      id
      date
      script {
        name
      }
      state
    }
  }
}
    `) as unknown as TypedDocumentString<SupportGetRunsQuery, SupportGetRunsQueryVariables>;
export const SupportGetRunDocument = new TypedDocumentString(`
    query supportGetRun($id: Int!) {
  run(id: $id) {
    id
    date
    script {
      id
      name
      args
      preview
    }
    state
    params
    user {
      ... on LKUser {
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportGetRunQuery, SupportGetRunQueryVariables>;
export const SupportGetCompanyNameByContractIdDocument = new TypedDocumentString(`
    query supportGetCompanyNameByContractId($id: ID!) {
  cabinet {
    company(contractId: $id) {
      contract {
        number
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SupportGetCompanyNameByContractIdQuery, SupportGetCompanyNameByContractIdQueryVariables>;
export const RefundSpasiboBonusesDocument = new TypedDocumentString(`
    mutation RefundSpasiboBonuses($id: String!, $orderId: ID!) {
  result: cancelSberLoyaltyReceipt(id: $id, orderId: $orderId)
}
    `) as unknown as TypedDocumentString<RefundSpasiboBonusesMutation, RefundSpasiboBonusesMutationVariables>;
export const CheckContractPaymentsDocument = new TypedDocumentString(`
    mutation checkContractPayments($contractId: ID!) {
  checkContractPayments(contractId: $contractId) {
    completed
    errors
    amount
  }
}
    `) as unknown as TypedDocumentString<CheckContractPaymentsMutation, CheckContractPaymentsMutationVariables>;
export const PutCardsFirmReferenceDocument = new TypedDocumentString(`
    mutation putCardsFirmReference($companyId: ID!) {
  putCardsFirmReference(companyId: $companyId)
}
    `) as unknown as TypedDocumentString<PutCardsFirmReferenceMutation, PutCardsFirmReferenceMutationVariables>;
export const UnlinkUserSberIdDocument = new TypedDocumentString(`
    mutation unlinkUserSberId($userId: ID!) {
  unlinkUserSberId(userId: $userId)
}
    `) as unknown as TypedDocumentString<UnlinkUserSberIdMutation, UnlinkUserSberIdMutationVariables>;
export const GetWaybillsDocument = new TypedDocumentString(`
    query getWaybills($companyId: ID, $partnerId: ID, $page: Int, $size: Int, $query: String, $state: String, $dateFrom: DateTime, $dateTo: DateTime) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      waybills(
        page: $page
        size: $size
        dateFrom: $dateFrom
        dateTo: $dateTo
        state: $state
        query: $query
      ) {
        items {
          id
          number
          validSince
          validTo
          allowedFuels
          limit
          limitQuantity
          state
          createdAt
          car {
            number
          }
          partner {
            name
          }
          riders(size: 3) {
            items {
              name
              phone
            }
            count
          }
        }
        count
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetWaybillsQuery, GetWaybillsQueryVariables>;
export const GetWaybillDocument = new TypedDocumentString(`
    query getWaybill($companyId: ID, $partnerId: ID, $waybillId: ID!, $filter: OrdersQueryParams!) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      waybill(id: $waybillId) {
        id
        number
        validSince
        validTo
        limit
        limitQuantity
        state
        createdAt
        car {
          number
        }
        partner {
          name
        }
        riders(size: 10) {
          items {
            name
            phone
            isBlocked
          }
          count
        }
      }
      ordersNew(filter: $filter) {
        count
        summary {
          name
          quantity
          total
          discount
        }
        items {
          id
          date
          status
          statusMessage
          station {
            name
            address
          }
          ... on OnlineOrder {
            item {
              fuel {
                name
              }
              quantityReport
              quantityReq
              costReport {
                fact
                station
                corp
              }
              costReq {
                fact
                station
                corp
              }
              prices {
                fact
                station
                corp
              }
              pump
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetWaybillQuery, GetWaybillQueryVariables>;
export const GetWaybillRidersDocument = new TypedDocumentString(`
    query GetWaybillRiders($companyId: ID, $partnerId: ID, $waybillId: ID!, $page: Int, $size: Int) {
  cabinet {
    company(id: $companyId, partnerId: $partnerId) {
      waybill(id: $waybillId) {
        riders(page: $page, size: $size) {
          items {
            name
            phone
            isBlocked
          }
          count
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetWaybillRidersQuery, GetWaybillRidersQueryVariables>;